/* eslint-disable perfectionist/sort-objects -- Generated catalog stays in translation-key order. */
/* Generated by scripts/i18n-review translate-export. */
export const PT_PT_TRANSLATIONS = {
  'guestTrial.backToOffer': 'Voltar à oferta',
  'guestTrial.checkoutError': 'Não foi possível abrir a página de pagamento. Tente novamente.',
  'guestTrial.demoHeadline': 'Veja a dobragem com IA em ação',
  'guestTrial.soundHint': 'Ative o som para ouvir a diferença',
  'guestTrial.startNow': 'Comece agora por {price}',
  'guestTrial.includes': '{days} dias · {minutes} minutos de dobragem · Todas as funcionalidades premium',
  'guestTrial.renewal': 'Depois, o plano Creator por {renewalPrice}/mês, salvo cancelamento',
  'guestTrial.metaTitle': 'Experimente o Rask',
  'guestTrial.offerUnavailable': 'Esta oferta não está disponível de momento. Tente novamente mais tarde.',
  'guestTrial.payment.cardError': 'O pagamento não foi concluído. Verifique os seus dados e tente novamente.',
  'guestTrial.payment.contactInformation': 'Contacto',
  'guestTrial.payment.daysFree': '{days} dias grátis',
  'guestTrial.payment.details': 'Detalhes',
  'guestTrial.payment.headline': 'Período experimental do Rask',
  'guestTrial.payment.or': 'OU',
  'guestTrial.payment.payAndStartTrial': 'Pagar e iniciar o período experimental',
  'guestTrial.payment.paymentMethod': 'Método de pagamento',
  'guestTrial.payment.perMonthAfter': '{amount} por mês após o período experimental',
  'guestTrial.payment.poweredBy': 'Com tecnologia da',
  'guestTrial.payment.privacy': 'Privacidade',
  'guestTrial.payment.purchasingAsBusiness': 'Estou a comprar como empresa',
  'guestTrial.payment.sandbox': 'Ambiente de testes',
  'guestTrial.payment.subtotal': 'Subtotal',
  'guestTrial.payment.terms': 'Termos',
  'guestTrial.payment.thenPerMonth': 'Depois, {amount} por mês',
  'guestTrial.payment.totalDueToday': 'Total a pagar hoje',
  'guestTrial.payment.viewDetails': 'Ver detalhes',
  'guestTrial.payment.email': 'E-mail',
  'guestTrial.payment.emailRequired': 'Introduza o seu e-mail para pagar com cartão.',
  'guestTrial.payment.loadError': 'Não foi possível carregar o formulário de pagamento. Tente novamente.',
  'guestTrial.payment.tax': 'Impostos',
  'guestTrial.payment.taxInfo': 'O valor de {tax} é calculado com base na sua localização e nos detalhes do produto.',
  'guestTrial.payment.taxPending': 'Calculados com base no seu endereço',
  'guestTrial.payment.accountExists': 'Já tem uma conta Rask com este e-mail.',
  'guestTrial.payment.logInToChoosePlan': 'Inicie sessão para escolher um plano.',
  'guestTrial.success.checking': 'A confirmar o seu pagamento…',
  'guestTrial.success.claimed': 'Este pagamento já está associado a uma conta Rask.',
  'guestTrial.success.createAccount': 'Criar conta',
  'guestTrial.success.email':
    'Registe-se com {email} para associar este pagamento. Também lhe enviámos por e-mail uma ligação para concluir o registo em qualquer dispositivo.',
  'guestTrial.success.noClaim':
    'Não encontrámos os dados do seu pagamento neste dispositivo. Abra esta página no dispositivo e no navegador que utilizou para pagar.',
  'guestTrial.success.openApp': 'Abrir o Rask',
  'guestTrial.success.paid': 'Pagamento recebido: crie a sua conta para iniciar o período experimental',
  'guestTrial.success.pending': 'Ainda estamos a confirmar o seu pagamento. Pode demorar um minuto.',
  'guestTrial.success.retry': 'Verificar novamente',
  'paidTrial.cancel.confirm': 'Cancelar período experimental',
  'paidTrial.cancel.description':
    'Manterá todas as funcionalidades premium até {date}. Depois, a sua conta passará para o plano gratuito e não lhe será cobrado nada.',
  'paidTrial.cancel.keep': 'Manter período experimental',
  'paidTrial.cancel.title': 'Cancelar o período experimental?',
  'paidTrial.canceledInfo':
    'O seu período experimental termina em {date}. Depois, a sua conta passará para o plano gratuito. Para manter as funcionalidades premium, escolha um plano.',
  'paidTrial.claimAlreadyClaimed':
    'Este pagamento do período experimental já está associado a outra conta. Inicie sessão nessa conta para utilizar o período experimental.',
  'paidTrial.claimEmailMismatch':
    'Para associar o pagamento do período experimental, registe-se com o e-mail que utilizou para pagar.',
  'paidTrial.claimNotClaimable':
    'Não foi possível associar automaticamente este pagamento do período experimental a uma nova conta. Contacte o apoio ao cliente.',
  'paidTrial.planFeatures.dubbing': 'Dobragem',
  'paidTrial.planFeatures.dubbingOnly': 'Apenas dobragem',
  'paidTrial.planFeatures.title': 'Escolha o plano que melhor se adapta às suas necessidades',
  'paidTrial.planLabel': 'Período experimental',
  'paidTrial.renews':
    'O seu período experimental termina em {date}. Depois, ser-lhe-á cobrado o valor de {price} por {interval} pelo plano {plan}, salvo cancelamento.',
  'paidTrial.upgradeOnly': 'Durante o período experimental, só pode mudar para o Creator ou para um plano superior.',
  'pricing.featurePaywall.controlDownload.title':
    'Desbloqueie a exportação do vídeo completo ou partilhe-o gratuitamente',
  'pricing.featurePaywall.controlDownload.subtitle':
    'Atualize o plano para transferir vídeos sem marca de água e obter transferências ilimitadas, ou partilhe este vídeo gratuitamente.',
  'pricing.featurePaywall.controlDownload.fullVideo': 'Exporte o vídeo completo, não apenas a pré-visualização',
  'pricing.featurePaywall.controlDownload.watermark': 'Remova a marca de água',
  'pricing.featurePaywall.controlDownload.formats': 'Qualquer formato, a qualquer momento',
  'pricing.featurePaywall.controlDownload.share': 'Partilhar gratuitamente',
  'pricing.featurePaywall.controlDownload.unlock': 'Desbloquear exportação de vídeo',

  'auth.signupExperiment.adminEnabled': 'Ativar teste de registo',
  'auth.signupExperiment.brandTone': 'Marca e tom consistentes',
  'auth.signupExperiment.cleanSubtitle': 'Junte-se a mais de 4 milhões de utilizadores que traduzem vídeos com IA',
  'auth.signupExperiment.company': 'Usa uma conta empresarial?',
  'auth.signupExperiment.createPassword': 'Criar palavra-passe',
  'auth.signupExperiment.emailSubmit': 'Registar-se com e-mail',
  'auth.signupExperiment.fiveStars': '5 de 5 estrelas',
  'auth.signupExperiment.languages': 'Mais de 135 idiomas',
  'auth.signupExperiment.noCard': 'Não é necessário cartão de crédito',
  'auth.signupExperiment.orEmail': 'ou com e-mail',
  'auth.signupExperiment.publishReady': 'Vídeos prontos a publicar',
  'auth.signupExperiment.rating': 'Classificação de {rating} em 5 no G2',
  'auth.signupExperiment.reviewOne':
    '“Localizamos toda a nossa biblioteca de formação em 12 idiomas — e todos os vídeos continuam a soar como nós.”',
  'auth.signupExperiment.reviewTwo':
    '“Foi a clonagem de voz que me convenceu. Gravo uma vez e publico em quatro idiomas sem contratar quatro atores.”',
  'auth.signupExperiment.richTitle': 'Traduza o seu primeiro vídeo',
  'auth.signupExperiment.roleOne': 'Diretora de Operações de Conteúdos',
  'auth.signupExperiment.roleTwo': 'Especialista em Aprendizagem e Desenvolvimento',
  'auth.signupExperiment.startFree': 'Começar gratuitamente',
  'auth.signupExperiment.teams': 'Utilizado por equipas de todo o mundo',
  'auth.signupExperiment.trustTitle': 'Mais de 4 000 000 de utilizadores confiam à Rask a localização de vídeos com IA',
  'auth.signupExperiment.voiceClone': 'Clonagem de voz',

  'account.actions.cancel': 'Cancelar',
  'account.actions.delete': 'Eliminar',
  'account.actions.save': 'Guardar',
  'account.addEmail.confirmTitle': 'Confirme o seu endereço de e-mail',
  'account.addEmail.emailLabel': 'E-mail',
  'account.addEmail.emailMismatch': 'Os endereços de e-mail não coincidem',
  'account.addEmail.emailPlaceholder': 'O seu e-mail',
  'account.addEmail.incorrectEmail': 'E-mail inválido',
  'account.addEmail.nextQuestion': 'Continuar',
  'account.addEmail.repeatEmailLabel': 'Repita o e-mail',
  'account.addEmail.subtitle': 'Confirmar novamente o e-mail garante que terá sempre acesso à sua conta',
  'account.api.clientId': 'ID de cliente da API',
  'account.api.code': 'Chave da API',
  'account.api.generateAction': 'Gerar chave de API',
  'account.api.generateSubtitle': 'Gere uma chave para começar a utilizar a API',
  'account.api.generateTitle': 'Gerar chave de API',
  'account.api.readDocumentation': 'Ler a documentação',
  'account.api.renewAction': 'Renovar subscrição',
  'account.api.renewTitle': 'Renove a sua subscrição para aceder à API',
  'account.api.startTitle': 'Comece a utilizar a nossa API',
  'account.api.upgradeAction': 'Atualizar plano',
  'account.api.upgradeSubtitle': 'Atualize para um plano Business ou Enterprise para aceder à API',
  'account.copy.copied': 'Copiado',
  'account.copy.copy': 'Copiar',
  'account.credits.availableForTranslation': 'Minutos disponíveis para tradução: {minutes}. {schedule}',
  'account.credits.availableForTranslationAndLipSync':
    'Minutos disponíveis para tradução ou sincronização labial: {minutes}. {schedule}',
  'account.credits.buyAdditional': 'Comprar minutos adicionais',
  'account.credits.buyMinutesMessage': 'Para continuar a utilizar o Rask, compre mais minutos.',
  'account.credits.buyMore': 'Comprar mais minutos',
  'account.credits.manageSubscriptionMessage': 'Para continuar a utilizar o Rask, faça a gestão da sua subscrição.',
  'account.credits.minutesAddedInDay': 'Daqui a {days} dia, serão adicionados {minutes} novos minutos.',
  'account.credits.minutesAddedInDays': 'Daqui a {days} dias, serão adicionados {minutes} novos minutos.',
  'account.credits.minutesAddedToday': 'Hoje serão adicionados {minutes} novos minutos.',
  'account.credits.moreMinutes': 'Mais minutos',
  'account.credits.recording': 'Gravação',
  'account.credits.recordingAlt': 'Gravador de ecrã do Rask',
  'account.credits.rolloverHint':
    'Os minutos não utilizados transitam para o mês seguinte enquanto a subscrição estiver ativa.',
  'account.credits.translation': 'Tradução',
  'account.credits.unlockFull': 'Desbloquear a versão completa',
  'account.credits.upgrade': 'Atualizar plano',
  'account.credits.usageMinutes': 'Utilizados: {used} min • Restantes: {left} min',
  'account.credits.usageVideos': 'Vídeos utilizados: {used} • Vídeos restantes: {left}',
  'account.credits.waitForMinutes':
    'Em alternativa, aguarde até {date}, data em que serão adicionados mais {minutes} minutos.',
  'account.credits.yourMinutes': 'Os seus minutos',
  'account.delete.action': 'Eliminar a minha conta',
  'account.delete.itemCounts': 'Membros: {members} • Projetos: {projects}',
  'account.delete.title': 'Eliminar permanentemente a sua conta? Os seguintes Teamspaces também serão eliminados:',
  'account.delete.warning':
    'Ao eliminar a sua conta, todos os Teamspaces que criou e respetivos projetos serão removidos permanentemente. A sua equipa perderá o acesso.',
  'account.password.change': 'Alterar palavra-passe',
  'account.password.incorrect': 'Palavra-passe incorreta',
  'account.password.newLabel': 'Nova palavra-passe',
  'account.password.newPlaceholder': 'Introduza a nova palavra-passe',
  'account.password.oldLabel': 'Palavra-passe atual',
  'account.password.oldPlaceholder': 'Introduza a palavra-passe atual',
  'account.password.sameError': 'As palavras-passe não podem ser iguais',
  'account.password.updated': 'Palavra-passe atualizada',
  'account.profile.email': 'E-mail',
  'account.profile.emailUpdates': 'Atualizações por e-mail sobre novas funcionalidades e notícias',
  'account.settings': 'Definições da conta',
  'account.subscription.actionCancel': 'Cancelar subscrição',
  'account.subscription.actionCancelDowngrade': 'Cancelar mudança para plano inferior',
  'account.subscription.actionChangePlan': 'Alterar plano',
  'account.subscription.actionManageBilling': 'Gerir faturação',
  'account.subscription.actionRenew': 'Renovar subscrição',
  'account.subscription.activeEnterprise': 'A sua subscrição termina em {date}.',
  'account.subscription.annual': 'anual',
  'account.subscription.canceled': 'A sua subscrição foi cancelada. Renove-a para continuar a traduzir os seus vídeos.',
  'account.subscription.cancellationFailed': 'Não foi possível cancelar. Tente novamente.',
  'account.subscription.cancellationScheduled': 'Cancelamento agendado',
  'account.subscription.ending': 'A sua subscrição termina em {date}.',
  'account.subscription.expired': 'A sua subscrição expirou. Renove-a para continuar a traduzir os seus vídeos.',
  'account.subscription.fromDate': 'A partir de {date}',
  'account.subscription.month': 'mês',
  'account.subscription.monthly': 'mensal',
  'account.subscription.pastDue':
    'A sua subscrição e os boosters estão suspensos devido a uma falha no pagamento. Atualize os dados de pagamento para continuar a utilizar o Rask.',
  'account.subscription.paused':
    'A sua subscrição está suspensa. Renove-a ou contacte-nos através do chat de suporte para continuar a traduzir os seus vídeos.',
  'account.subscription.planName': 'Plano {planName}',
  'account.subscription.remainingExpires':
    'Os minutos restantes expiram após esta data. Renove a sua subscrição para continuar a utilizá-los.',
  'account.subscription.renews':
    'A sua subscrição será renovada automaticamente em {date}, por {price} por {interval}.',
  'account.subscription.scheduled':
    'A sua subscrição {currentPlan} {currentInterval} está ativa até {date}. Em {changeDate}, mudará automaticamente para o plano {nextPlan} {nextInterval}, por {price} por {interval}.',
  'account.subscription.statusActive': 'Ativa',
  'account.subscription.statusCanceled': 'Cancelada',
  'account.subscription.statusExpired': 'Expirada',
  'account.subscription.statusPastDue': 'Pagamento em atraso',
  'account.subscription.statusPaused': 'Suspensa',
  'account.subscription.statusScheduled': 'Agendada',
  'account.subscription.statusTrial': 'Período experimental',
  'account.subscription.statusTrialing': 'Período experimental',
  'account.subscription.statusUnpaid': 'Por pagar',
  'account.subscription.trialContactAfter': 'para conhecer as opções que melhor se adequam às suas necessidades.',
  'account.subscription.trialContactBefore':
    'O seu período experimental termina em {date}. Para escolher um plano, visite a página Preços ou contacte a nossa equipa de parcerias através de',
  'account.subscription.year': 'ano',
  'account.subscription.yearly': 'anual',
  'account.trialUpgrade.apiAccess': 'Acesso à API',
  'account.trialUpgrade.customVoices': 'Personalize vozes clonadas e guarde-as na sua biblioteca',
  'account.trialUpgrade.dictionary': 'Guarde traduções personalizadas no dicionário',
  'account.trialUpgrade.downloadSrt': 'Transfira ficheiros de legendas',
  'account.trialUpgrade.lipSync': 'Aplique sincronização labial',
  'account.trialUpgrade.subtitles': 'Adicione legendas ao seu vídeo',
  'account.trialUpgrade.teamspaces': 'Crie Teamspaces e colabore com a sua equipa',
  'account.trialUpgrade.title': 'Atualize para ter acesso completo',
  'account.trialUpgrade.translate': 'Traduza vídeo e áudio para mais de 135 idiomas',
  'account.trialUpgrade.upgradePlan': 'Atualizar plano',
  'account.trialUpgrade.uploadSrt': 'Carregue um ficheiro SRT com o seu vídeo',
  'account.trialUpgrade.voiceClone': 'Clone vozes em 32 idiomas',
  'auth.change.newPasswordLabel': 'Nova palavra-passe',
  'auth.change.newPasswordPlaceholder': 'Introduza a nova palavra-passe',
  'auth.change.subtitle': 'Defina uma nova palavra-passe',
  'auth.change.title': 'Alterar palavra-passe',
  'auth.change.verificationCode': 'Código de verificação',
  'auth.code.label': 'Código',
  'auth.confirm.backSignup': 'Voltar ao registo',
  'auth.confirm.resend': 'Reenviar código',
  'auth.confirm.resendFew': 'Reenviar dentro de {count} segundos',
  'auth.confirm.resendMany': 'Reenviar dentro de {count} segundos',
  'auth.confirm.resendOne': 'Reenviar dentro de {count} segundo',
  'auth.confirm.resendOther': 'Reenviar dentro de {count} segundos',
  'auth.confirm.submit': 'Confirmar e-mail',
  'auth.confirm.subtitle':
    'Enviámos um e-mail com um código para {email}. Copie o código do e-mail e cole-o no formulário para confirmar a sua conta.',
  'auth.confirm.title': 'Confirme o seu e-mail',
  'auth.confirmationCodeSent': 'Foi enviado um código de confirmação para o seu e-mail',
  'auth.email.label': 'E-mail',
  'auth.email.placeholder': 'Introduza o seu e-mail',
  'auth.error.emailValidationFailed': 'Falha na validação do e-mail',
  'auth.error.incorrectEmail': 'Introduza um endereço de e-mail válido',
  'auth.error.incorrectPassword': 'Palavra-passe incorreta',
  'auth.error.passwordTooShort': 'Pelo menos 6 caracteres',
  'auth.error.somethingWentWrong': 'Ocorreu um erro',
  'auth.error.temporaryEmail': 'Utilize um endereço de e-mail não temporário',
  'auth.forgot.backSignin': 'Voltar a iniciar sessão',
  'auth.forgot.confirm': 'Confirmar',
  'auth.forgot.subtitle': 'Introduza o seu endereço de e-mail e enviaremos instruções para repor a sua palavra-passe.',
  'auth.forgot.title': 'Esqueceu-se da palavra-passe?',
  'auth.google.signin': 'Iniciar sessão com o Google',
  'auth.google.signup': 'Iniciar sessão com o Google',
  'auth.info.achievementsAlt': 'Prémios e classificações da Rask AI',
  'auth.info.editorAlt': 'Interface do editor de vídeo do Rask AI',
  'auth.info.feature.captions': 'Legendas geradas por IA',
  'auth.info.feature.dictionary': 'Dicionário de tradução',
  'auth.info.feature.languages': 'Tradução para mais de 135 línguas suportadas',
  'auth.info.feature.lipSync': 'Sincronização labial para uma localização de excelência',
  'auth.info.feature.multiSpeaker': 'Suporte para dobragem com vários interlocutores',
  'auth.info.feature.voiceClone': 'Clonagem de voz em 32 línguas',
  'auth.info.featuresTitleBottom': 'para resultados de alta qualidade',
  'auth.info.featuresTitleTop': 'As melhores funcionalidades',
  'auth.info.review.enterpriseRole': 'Mentora, Enterprise',
  'auth.info.review.enterpriseText': 'Uma excelente ferramenta para traduzir vídeos educativos!',
  'auth.info.review.startupRole': 'Startup',
  'auth.info.review.startupText': 'A melhor ferramenta para dobragem e tradução',
  'auth.info.scaleTitleBottom': 'em grande escala',
  'auth.info.scaleTitleTop': 'Tradução inteligente de vídeo',
  'auth.info.usersTitleBottom': 'na nossa IA de tradução de vídeo',
  'auth.info.usersTitleTop': 'Mais de 2 000 000 de utilizadores confiam',
  'auth.landing.createAccount': 'Crie uma conta gratuita para o traduzir gratuitamente.',
  'auth.landing.fileUploaded': 'O seu ficheiro já foi carregado!',
  'auth.landing.hasAccount': 'Já tem uma conta?',
  'auth.landing.marketingConsent':
    'Vamos enviar-lhe novidades sobre o produto, dicas e ofertas da Rask.ai. Pode cancelar a subscrição a qualquer momento.',
  'auth.landing.orEmail': 'Ou registe-se com o e-mail',
  'auth.landing.signIn': 'Iniciar sessão',
  'auth.landing.signUpFree': 'Registar-se gratuitamente',
  'auth.landing.uploadComplete': 'Carregamento concluído',
  'auth.password.label': 'Palavra-passe',
  'auth.passwordResetNotice': 'Atualize a sua palavra-passe. Enviámos um código de confirmação para o seu e-mail.',
  'auth.signin.forgotPassword': 'Esqueceu-se da palavra-passe?',
  'auth.signin.noAccount': 'Ainda não tem uma conta?',
  'auth.signin.subtitle': 'Continue a traduzir os seus vídeos 🤘',
  'auth.signin.title': 'Iniciar sessão',
  'auth.signup.landingSubtitle': 'Crie uma conta gratuita para o ver.',
  'auth.signup.landingTitle': 'O seu vídeo traduzido está quase pronto!',
  'auth.signup.submit': 'Criar conta',
  'auth.signup.subtitle': 'Junte-se a mais de 2 milhões de utilizadores que traduzem vídeos em minutos com IA',
  'auth.signup.welcome': 'Boas-vindas',
  'auth.signup.welcomeRask': 'Boas-vindas à Rask AI',
  'auth.sso.back': 'Voltar',
  'auth.sso.continue': 'Continuar',
  'auth.sso.continueEmail': 'Continuar com e-mail e palavra-passe',
  'auth.sso.notConfigured': 'O SSO não está configurado para o seu e-mail',
  'auth.sso.signin': 'Iniciar sessão com SSO',
  'auth.sso.signup': 'Iniciar sessão com SSO',
  'auth.sso.subtitle': 'Utilize o e-mail da sua empresa para iniciar sessão',
  'auth.sso.title': 'Continuar com SSO',
  'auth.terms.and': 'e os',
  'auth.terms.prefix': 'Ao registar-se, aceita os documentos da Rask:',
  'auth.terms.privacy': 'Política de Privacidade',
  'auth.terms.service': 'Termos de Serviço',
  'billing.confirm.amountDue': 'Montante a pagar hoje',
  'billing.confirm.and': 'e',
  'billing.confirm.boostersTerms': 'Termos de Utilização dos Boosters',
  'billing.confirm.confirm': 'Confirmar',
  'billing.confirm.discountHint': 'O desconto de {percent}% aplica-se apenas à primeira fatura.',
  'billing.confirm.havePromo': 'Tem um código promocional?',
  'billing.confirm.hideDetails': 'Ocultar detalhes',
  'billing.confirm.invalidPromo': 'O código promocional é inválido',
  'billing.confirm.monthlyFrom': 'Mensalmente a partir de {date}',
  'billing.confirm.noCharges': 'Sem próximas cobranças de boosters',
  'billing.confirm.noChargesDescription': 'Não terá boosters ativos após a confirmação.',
  'billing.confirm.oneTimeHint': 'O pagamento único cobre a utilização até ao fim do ciclo de faturação.',
  'billing.confirm.paymentMethod': 'Método de pagamento',
  'billing.confirm.perMonth': '/mês',
  'billing.confirm.perYear': '/ano',
  'billing.confirm.privacy': 'Política de Privacidade',
  'billing.confirm.promoFailed': 'Não foi possível aplicar o código promocional',
  'billing.confirm.promoLine': 'Código promocional {code}',
  'billing.confirm.promoPlaceholder': 'Código promocional',
  'billing.confirm.promotionTerms': 'Termos da Promoção',
  'billing.confirm.remove': '(removido)',
  'billing.confirm.removeItem': 'Remover {item}',
  'billing.confirm.renews': 'Renovação automática até ao cancelamento',
  'billing.confirm.subscribe': 'Subscrever com obrigação de pagamento',
  'billing.confirm.taxHint': 'O total inclui os impostos calculados com base nos seus dados de faturação.',
  'billing.confirm.terms': 'Termos de Serviço',
  'billing.confirm.termsIntro': 'Ao confirmar, aceita os documentos da Rask AI:',
  'billing.confirm.updatePayment': 'Atualize o método de pagamento',
  'billing.confirm.vat': 'IVA {percent}',
  'billing.confirm.viewDetails': 'Ver detalhes',
  'billing.confirm.yearlyFrom': 'Anualmente a partir de {date}',
  'billing.error.authentication':
    'A autenticação do pagamento falhou. Não foi possível confirmar o pagamento junto do seu banco.',
  'billing.error.bankDeclined': 'O pagamento foi recusado pelo seu banco. O banco não aprovou esta transação.',
  'billing.error.cardCannotBeUsed': 'Este cartão não pode ser utilizado',
  'billing.error.cardDetails':
    'Os dados do cartão estão incorretos. Verifique o número do cartão, a data de validade e o código de segurança.',
  'billing.error.changePayment': 'Altere o método de pagamento',
  'billing.error.editPayment': 'Editar método de pagamento',
  'billing.error.failed': 'O pagamento falhou',
  'billing.error.insufficient':
    'O pagamento falhou — saldo insuficiente ou limite atingido. O seu banco recusou o pagamento devido a saldo insuficiente ou ao limite de despesas.',
  'billing.error.retryPayment': 'Tente novamente ou altere o método de pagamento',
  'billing.result.canClose': 'Pode fechar esta janela a qualquer momento.',
  'billing.result.closeWindow': 'Fechar janela',
  'billing.result.processing': 'Estamos a processar a sua encomenda',
  'billing.result.processingDescription':
    'Isto pode demorar alguns minutos. Continuaremos a processá-la em segundo plano e ativaremos automaticamente a sua subscrição quando o processo terminar.',
  'billing.result.success': 'Pagamento processado com sucesso',
  'billing.result.viewInvoice': 'Ver fatura',
  'bookDemo.booked': 'A sua demonstração está marcada!',
  'bookDemo.bookedFor': 'A sua demonstração está marcada para {slot}',
  'bookDemo.coverDescription':
    'o seu caso de uso de localização, a melhor forma de o implementar no Rask, como o Rask se integra no fluxo de trabalho da sua equipa e uma estrutura de preços clara.',
  'bookDemo.coverTitle': 'O que vamos abordar:',
  'bookDemo.inviteSent': 'Foi enviado para o seu e-mail um convite com a ligação para a reunião.',
  'bookDemo.seeYou': 'Até breve',
  'bookDemo.subtitle':
    'Vamos analisar o seu fluxo de trabalho, mostrar funcionalidades menos conhecidas e escolher o melhor plano para as suas necessidades.',
  'bookDemo.timeBenefit': 'Uma demonstração de 30 minutos poupa-lhe cerca de 5 horas a explorar o produto.',
  'bookDemo.title': 'Marque uma demonstração com o nosso especialista',
  'boosters.about': 'sobre os Boosters',
  'boosters.action.add': 'Adicionar boosters',
  'boosters.action.addAndContinue': 'Adicionar e continuar',
  'boosters.action.manage': 'Gerir',
  'boosters.action.manageBilling': 'Gerir faturação',
  'boosters.action.renewSubscription': 'Renovar subscrição',
  'boosters.action.resumeSubscription': 'Retomar subscrição',
  'boosters.action.saveAndContinue': 'Guardar e continuar',
  'boosters.banner.description': 'Escolha as ferramentas que pretende adicionar ao seu fluxo de trabalho',
  'boosters.banner.title': 'Dê um impulso ao seu trabalho sem mudar de plano!',
  'boosters.card.activeUntil': 'Ativo até {date}, sem custos',
  'boosters.card.activeUntilQuantity': '{quantity} × {name} (até {date})',
  'boosters.card.noAvailable': 'Nenhum booster disponível',
  'boosters.card.quantity': '{quantity} × {name}',
  'boosters.intro.title': 'Adicione Boosters para obter melhores resultados',
  'boosters.item.prompting.description': 'Adapte os seus vídeos dobrados à voz da sua marca',
  'boosters.item.prompting.title': 'Prompts de tradução',
  'boosters.item.prompting.tooltip':
    'Defina o tom, o estilo e o contexto através de prompts. Use um modelo ou crie o seu próprio para cada tradução.',
  'boosters.item.seat.description': 'Colabore facilmente com a sua equipa em projetos partilhados',
  'boosters.item.seat.title': 'Lugar adicional no Teamspace',
  'boosters.item.seat.tooltip': 'Colabore com a sua equipa em Teamspaces partilhados.',
  'boosters.item.srt.description': 'Carregue e descarregue uma transcrição corrigida',
  'boosters.item.srt.title': 'Carregamento e transferência de SRT',
  'boosters.item.srt.tooltip':
    'Transfira legendas com o texto original e traduzido ou carregue as suas para as sincronizar com a dobragem.',
  'boosters.learnMore': 'Saiba mais',
  'boosters.manage.description':
    'Potencie o seu trabalho sem mudar de plano — escolha as ferramentas que pretende adicionar ao seu fluxo de trabalho.',
  'boosters.manage.title': 'Gerir Boosters',
  'boosters.perMonth': '{price} / mês',
  'boosters.scheduled.activeUntil': 'Ativo até {date}, sem custos adicionais',
  'boosters.scheduled.seats': 'Lugares ativos: {total} até {date}, sem custos adicionais; depois, {defaultSeats}.',
  'boosters.seats.addManyForMonth': 'Adicionar {count} lugares por {price} por mês',
  'boosters.seats.addOneForMonth': 'Adicionar {count} lugar por {price} por mês',
  'boosters.status.expired': 'Expirado',
  'boosters.status.pastDue': 'Pagamento em atraso',
  'boosters.status.paused': 'Em pausa',
  'boosters.success.changed': 'Pagamento processado com sucesso. A sua subscrição foi atualizada.',
  'boosters.success.saved': 'As alterações aos boosters foram guardadas',
  'boosters.title': 'Boosters',
  'boosters.tooltip.add': 'Adicionar Boosters',
  'boosters.tooltip.description': 'Adicione Boosters para obter melhores resultados com apenas um clique.',
  'boosters.tooltip.title': 'Quer obter melhores resultados?',
  'boosters.warning.canceled': 'Os Boosters estão indisponíveis porque a sua subscrição foi cancelada',
  'boosters.warning.expired': 'Os Boosters estão indisponíveis porque a sua subscrição expirou',
  'boosters.warning.failedPayment': 'Em pausa após uma falha no pagamento',
  'boosters.warning.paused': 'Os Boosters estão em pausa juntamente com a sua subscrição',
  'common.advancedTools': 'Ferramentas avançadas',
  'common.back': 'Voltar',
  'common.close': 'Fechar',
  'common.desktopOnly': 'Apenas no computador',
  'common.fieldRequired': 'Campo obrigatório',
  'common.hideSidebar': 'Ocultar barra lateral',
  'common.lockSidebar': 'Fixar barra lateral',
  'common.logout': 'Terminar sessão',
  'common.navigationSidebar': 'Barra lateral de navegação',
  'common.openSidebar': 'Abrir barra lateral',
  'common.or': 'ou',
  'common.profile': 'Perfil',
  'common.profileImage': 'Imagem de perfil',
  'common.serverError': 'Erro do servidor. Tente novamente mais tarde',
  'common.upgrade': 'Atualizar plano',
  'createProject.additionalParameters': 'Parâmetros adicionais',
  'createProject.autodetect': 'Detetar automaticamente',
  'createProject.bulkUpload.contactSupport': 'contacte o apoio',
  'createProject.bulkUpload.errorPrefix': 'Não foi possível carregar alguns ficheiros. Tente novamente ou',
  'createProject.choose': 'Escolher',
  'createProject.chooseFile': 'Clique para escolher um ficheiro',
  'createProject.chooseFiles': 'Clique para escolher até {count} ficheiros',
  'createProject.dictionary.add': 'Adicionar dicionário',
  'createProject.dictionary.choose': 'Escolher dicionário',
  'createProject.dictionary.createNew': 'Criar novo',
  'createProject.dictionary.label': 'Dicionário de tradução',
  'createProject.dictionary.upgrade': 'Atualizar plano',
  'createProject.dubbingModel.new': 'Novo',
  'createProject.dubbingModel.recommended': 'Recomendado',
  'createProject.dubbingModel.v1.description':
    'O modelo que tem utilizado até agora: resultados estáveis e previsíveis.',
  'createProject.dubbingModel.v1.title': 'Dubbing 1.0',
  'createProject.dubbingModel.v2.description':
    'Preserva a emoção e a entoação de quem fala, com uma tradução e um ritmo mais naturais.',
  'createProject.dubbingModel.v2.title': 'Dubbing 2.0',
  'createProject.dragIt': 'ou arraste-o e largue-o aqui',
  'createProject.dragThem': 'ou arraste-os e largue-os aqui',
  'createProject.dropFiles': 'Largue os ficheiros aqui ou clique para carregar',
  'createProject.error.chooseOnlyOneFile': 'Escolha apenas 1 ficheiro',
  'createProject.error.correctLink': 'Introduza uma ligação válida',
  'createProject.error.fileTooLarge': 'O ficheiro é demasiado grande',
  'createProject.error.fileTooLargeWithMax': 'O ficheiro é demasiado grande. Máximo: {maxSize} MB',
  'createProject.error.fileTooSmall': 'O ficheiro é demasiado pequeno',
  'createProject.error.invalidFileType': 'Tipo de ficheiro inválido',
  'createProject.error.maximumVideo': 'Máximo de {count} vídeo',
  'createProject.error.maximumVideos': 'Máximo de {count} vídeos',
  'createProject.error.server': 'Erro do servidor',
  'createProject.error.somethingWentWrong': 'Ocorreu um erro',
  'createProject.error.srtFormat':
    'Formato de ficheiro SRT inválido. Escolha outro ficheiro SRT ou continue sem ficheiro SRT.',
  'createProject.error.srtMismatch':
    'Certifique-se de que ambos os ficheiros SRT têm códigos de tempo idênticos ou remova um deles.',
  'createProject.error.unavailablePublicLink':
    'Não foi possível adicionar essa ligação. Certifique-se de que é o URL de um vídeo público.',
  'createProject.error.unknown': 'Erro desconhecido',
  'createProject.error.unsupportedFormat': 'Esse formato não é suportado. Utilize MP4, MOV, WEBM, MKV, MP3 ou WAV.',
  'createProject.error.videoUploadFailed': 'Falha ao carregar o vídeo',
  'createProject.fillDetails': 'Preencha os detalhes do seu projeto',
  'createProject.fillDetailsAndUpload': 'Preencha os detalhes do projeto e carregue os ficheiros',
  'createProject.freeVideoLeft': '{count} vídeo gratuito',
  'createProject.freeVideosLeft': '{count} vídeos gratuitos',
  'createProject.language.aiPresets': 'Tradução: {language}, locução: vozes de IA predefinidas',
  'createProject.language.voiceClone':
    'Tradução: {language}, locução: vozes de IA predefinidas ou clone de voz em {voiceLanguage}',
  'createProject.limit.paid': 'O ficheiro excede o limite ({size} MB/{minutes} min). Selecione outro.',
  'createProject.limit.subtitle.durationMinutes': 'Duração máxima do vídeo: {duration} min.',
  'createProject.limit.subtitle.durationSeconds': 'Duração máxima do vídeo: {duration} s.',
  'createProject.limit.subtitle.size': 'Tamanho máximo do vídeo: {maxSize} MB.',
  'createProject.limit.subtitle.sizeOrDurationMinutes':
    'Tamanho máximo do vídeo: {maxSize} MB ou duração máxima do vídeo: {duration} min.',
  'createProject.limit.subtitle.sizeOrDurationSeconds':
    'Tamanho máximo do vídeo: {maxSize} MB ou duração máxima do vídeo: {duration} s.',
  'createProject.limit.trial': 'O ficheiro excede o limite de avaliação de 1 GB. Selecione outro.',
  'createProject.limit.upgrade': 'Atualize o plano para carregar ficheiros sem limitações',
  'createProject.link.fallbackTitle': 'Vídeo a partir de uma ligação',
  'createProject.link.pendingName': 'Ficheiro da ligação',
  'createProject.localizeVideoTitle': 'Localize o seu vídeo',
  'createProject.mobile.description':
    'Para utilizar esta funcionalidade, aceda a esta página num computador e visualize-a em ecrã inteiro.',
  'createProject.mobile.title': 'É necessário um computador',
  'createProject.newTranslation': 'Nova tradução',
  'createProject.noVideo': 'Não tem um vídeo?',
  'createProject.notAccess.contactPrefix': 'Contacte',
  'createProject.notAccess.contactSuffix': 'para obter mais ajuda',
  'createProject.notAccess.imageAlt': 'Acesso indisponível',
  'createProject.notAccess.title': 'Não tem permissão para gerar vídeos',
  'createProject.originalLanguage': 'Idioma original',
  'createProject.pasteLink': 'Cole uma ligação do YouTube ou Google Drive',
  'createProject.pasteLinkWithVimeo': 'Cole uma ligação do YouTube, Google Drive ou Vimeo',
  'createProject.projectName': 'Nome do projeto',
  'createProject.renewPlan': 'Retomar plano',
  'createProject.sampleDescription':
    'Já preenchemos os detalhes do vídeo de exemplo. Basta escolher o idioma para o qual pretende traduzir o vídeo.',
  'createProject.selectLanguages': 'Selecione o idioma do vídeo original e o idioma para o qual o vai traduzir',
  'createProject.selectTargetLanguage': 'Selecione o idioma de destino da tradução do vídeo',
  'createProject.srt.singleVideoTooltip':
    'O carregamento de SRT só está disponível ao traduzir um único vídeo para um único idioma.',
  'createProject.support.contact': 'contacte a nossa equipa de apoio',
  'createProject.support.problemPrefix': 'Ocorreu um erro. Tente novamente ou',
  'createProject.translate': 'Traduzir',
  'createProject.translateFirstMinute':
    'Vamos traduzir o primeiro minuto do seu vídeo. Pode ser mais longo: por agora, utilizaremos apenas o primeiro minuto.',
  'createProject.translateRecording': 'Traduza a sua gravação de ecrã',
  'createProject.translateTo': 'Traduzir para',
  'createProject.trySampleVideo': 'Experimente um vídeo de exemplo',
  'createProject.upgradePlan': 'Fazer upgrade do plano',
  'createProject.upload.error': 'Erro de carregamento',
  'createProject.upload.fileUploaded': 'Ficheiro carregado',
  'createProject.upload.finishing': 'Faltam apenas alguns instantes',
  'createProject.upload.inProgress': 'Carregamento em curso — não feche este separador.',
  'createProject.upload.progress': '{percent}% carregado',
  'createProject.upload.retrying': 'A tentar carregar novamente. Aguarde.',
  'createProject.uploadFile': 'Clique para carregar um ficheiro',
  'createProject.uploadTitle': 'Carregue um vídeo ou áudio para traduzir',
  'createProject.videoLeft': 'Resta {count} vídeo',
  'createProject.videoName': 'Nome do vídeo',
  'createProject.videoNames': 'Nomes dos vídeos',
  'createProject.videosLeft': 'Restam {count} vídeos',
  'createProject.videoSpeakers': 'Número de oradores no vídeo',
  'createProject.onscreen.beta': 'O modelo de preços está em fase beta e pode sofrer alterações.',
  'createProject.onscreen.cost': 'Texto no ecrã: {minutes} min, cobrados após a dobragem.',
  'createProject.onscreen.costPerMinute': 'Texto no ecrã: {minutes} min por minuto de vídeo, cobrados após a dobragem.',
  'createProject.onscreen.hint':
    'Deteta o texto no fotograma e substitui-o pela tradução quando a dobragem automática estiver pronta.',
  'createProject.onscreen.label': 'Traduzir o texto no ecrã',
  'createProject.onscreen.lockAddOn': 'Complemento',
  'createProject.onscreen.lockBusiness': 'Business+',
  'createProject.onscreen.paused':
    'A tradução do texto no ecrã está temporariamente indisponível, por isso o vídeo foi carregado sem ela. Pode iniciá-la mais tarde no separador Visual do projeto.',
  'editor.accessibility.celebration': 'Celebração',
  'editor.accessibility.desktop': 'Computador de secretária',
  'editor.accessibility.sparkles': 'Brilhos',
  'editor.action.add': 'Adicionar',
  'editor.action.applyChanges': 'Aplicar alterações',
  'editor.action.back': 'Voltar',
  'editor.action.cancel': 'Cancelar',
  'editor.action.choose': 'Escolher',
  'editor.action.continue': 'Continuar',
  'editor.action.delete': 'Eliminar',
  'editor.action.download': 'Transferir',
  'editor.action.edit': 'Editar',
  'editor.action.generate': 'Gerar',
  'editor.action.generating': 'A gerar',
  'editor.action.getStarted': 'Começar',
  'editor.action.goBack': 'Voltar',
  'editor.action.goHome': 'Ir para o início',
  'editor.action.gotIt': 'Percebi',
  'editor.action.import': 'Importar',
  'editor.action.learnMore': 'Saiba mais',
  'editor.action.next': 'Seguinte',
  'editor.action.okay': 'Está bem',
  'editor.action.pause': 'Pausar',
  'editor.action.play': 'Reproduzir',
  'editor.action.previous': 'Anterior',
  'editor.action.redo': 'Refazer',
  'editor.action.rename': 'Mudar o nome',
  'editor.action.retranslate': 'Retraduzir',
  'editor.action.save': 'Guardar',
  'editor.action.skip': 'Ignorar',
  'editor.action.submit': 'Enviar',
  'editor.action.tryAgain': 'Tentar novamente',
  'editor.action.undo': 'Desfazer',
  'editor.action.update': 'Atualizar',
  'editor.action.upgrade': 'Fazer upgrade',
  'editor.action.uploadVideo': 'Carregar vídeo',
  'editor.advancedTools.label': 'Ferramentas avançadas',
  'editor.advancedTools.none': 'Nenhum',
  'editor.advancedTools.off': 'Desativado',
  'editor.advancedTools.on': 'Ativado',
  'editor.advancedTools.prompting': 'Instruções de tradução',
  'editor.advancedTools.srtFile': 'Ficheiro SRT',
  'editor.attention.checkItOut': 'Veja o resultado ✨',
  'editor.attention.oldSubtitle': 'Aplique as alterações para ver as atualizações 👀',
  'editor.attention.oldTitle': 'Esta é a versão anterior!',
  'editor.attention.readyTitle': 'O seu vídeo está pronto!',
  'editor.audioTrack.open': 'Abrir editor',
  'editor.audioTrack.zoomAria': 'Zoom do áudio',
  'editor.bookDemo.action': 'Agendar demonstração',
  'editor.bookDemo.booked': 'Demonstração agendada',
  'editor.dub.button': 'Dobrar vídeo',
  'editor.dub.costFew': 'Vamos dobrar este vídeo e descontar {minutes} minutos da sua conta',
  'editor.dub.costMany': 'Vamos dobrar este vídeo e descontar {minutes} minutos da sua conta',
  'editor.dub.costOne': 'Vamos dobrar este vídeo e descontar {minutes} minuto da sua conta',
  'editor.dub.costOther': 'Vamos dobrar este vídeo e descontar {minutes} minutos da sua conta',
  'editor.dub.criteriaSpeakers': 'Os oradores estão corretamente atribuídos',
  'editor.dub.criteriaText': 'O texto foi revisto',
  'editor.dub.criteriaTimestamps': 'As marcas temporais estão corretamente posicionadas',
  'editor.dub.deleteAll': 'Eliminar todos ({count})',
  'editor.dub.dontShow': 'Não voltar a mostrar',
  'editor.dub.emptySegments': 'Preencha ou elimine os segmentos vazios para dobrar o vídeo.',
  'editor.dub.free': 'Grátis',
  'editor.dub.minutesShort': '{minutes} min',
  'editor.dub.notEnoughSpeech':
    'Não há fala suficiente para clonar a voz de {speaker}. Altere a atribuição do locutor ou use as predefinições recomendadas.',
  'editor.dub.subtitle': 'Para obter melhores resultados de dobragem, certifique-se de que o guião está pronto:',
  'editor.dub.timeCost': 'Custo:',
  'editor.dub.tooltipEdit': 'Conclua a edição antes de dobrar',
  'editor.dub.tooltipNoChanges': 'Faça alterações para voltar a dobrar o vídeo',
  'editor.dub.tooltipProcessing': 'Aguarde até os dados serem guardados',
  'editor.dub.tooltipUnavailableDemo': 'Indisponível para projetos de demonstração',
  'editor.dub.tooltipVoiceSuggest': 'Aguarde até a seleção de vozes estar concluída',
  'editor.dub.unlockUnlimited': 'Desbloquear edições ilimitadas',
  'editor.dub.upgradeApplyChanges': 'Atualize o plano para aplicar as alterações',
  'editor.dub.usePresets': 'Usar predefinições ({count})',
  'editor.editor.autodetect': 'Detetar automaticamente',
  'editor.editor.creatingSegment': 'A criar novo segmento...',
  'editor.editor.infoLater': 'Talvez mais tarde',
  'editor.editor.infoSubtitle': 'Consulte o nosso tutorial para saber como tirar o máximo partido desta funcionalidade',
  'editor.editor.infoTitle': 'Traduza facilmente os seus conteúdos para vários idiomas',
  'editor.editor.newLanguage': 'Novo idioma',
  'editor.editor.splitSegment': 'Dividir segmento',
  'editor.editor.translate': 'Traduzir',
  'editor.editor.voiceTooltipAlt': 'Definições de voz',
  'editor.editor.voiceTooltipSubtitle':
    'Ajuste os níveis de expressividade e semelhança e guarde-a na sua biblioteca de vozes',
  'editor.editor.voiceTooltipTitle': 'Agora pode personalizar o seu clone de voz!',
  'editor.error.determineSpeakers': 'Não foi possível identificar os oradores',
  'editor.error.dubbingSubtitle':
    'Se isso não ajudar, contacte a nossa equipa de apoio. Teremos todo o gosto em ajudar.',
  'editor.error.dubbingTitle':
    'A dobragem falhou. Os seus minutos não foram descontados, por isso pode tentar novamente.',
  'editor.error.generic': 'Ocorreu um erro',
  'editor.error.genericRetry': 'Tente novamente.',
  'editor.error.noSoundSubtitle': 'Carregue um vídeo com fala',
  'editor.error.noSoundTitle': 'O vídeo não tem som',
  'editor.error.noSpeechSubtitle': 'Forneça um vídeo com fala',
  'editor.error.noSpeechTitle': 'O vídeo não contém fala',
  'editor.error.pageMissing': 'Página não encontrada',
  'editor.error.pageMissingSubtitle': 'A página que procura não existe.',
  'editor.error.refresh': 'Atualizar a página',
  'editor.error.separateBackground': 'Não foi possível separar o áudio de fundo',
  'editor.error.server': 'Erro do servidor. Tente novamente mais tarde',
  'editor.error.transcriptChangeInProgress': 'Já está em curso outra alteração da transcrição',
  'editor.error.transcribeSegments': 'Não foi possível transcrever os segmentos',
  'editor.error.transcription': 'A transcrição falhou',
  'editor.error.translation': 'A tradução falhou',
  'editor.error.tryRefresh': 'Atualize a página ou tente novamente mais tarde.',
  'editor.error.upload': 'O carregamento falhou',
  'editor.error.videoUnavailableSubtitle': 'Ajuste as definições do link de partilha',
  'editor.error.videoUnavailableTitle': 'Vídeo indisponível',
  'editor.error.workingOnIt': 'Já estamos a trabalhar para corrigir o problema.',
  'editor.history.applyError': 'Não foi possível aplicar esta alteração. Tente novamente',
  'editor.fakeSegment.reuploadTitle': 'Excelente! Volte a carregar o vídeo para o traduzir na íntegra',
  'editor.fakeSegment.upgradeSubtitle':
    'Para traduzir vídeos com mais de um minuto sem marca de água, escolha outro plano adequado às suas necessidades.',
  'editor.fakeSegment.upgradeTitle': 'Faça upgrade para traduzir o vídeo completo',
  'editor.feedback.abFlatVoice': 'Voz monótona e sem expressividade 😐',
  'editor.feedback.abLimitedVoices': 'Opções de voz limitadas 🤏',
  'editor.feedback.abLowQuality': 'Baixa qualidade do som 🔈',
  'editor.feedback.abNoise': 'Ruído ou distorção de áudio 💥',
  'editor.feedback.abPronunciation': 'Erros de pronúncia 🗣️',
  'editor.feedback.abVoiceAccent': 'O sotaque da locução não corresponde ao original 🎙️',
  'editor.feedback.abVoiceClone': 'O clone de voz não soa como a voz original 🤷',
  'editor.feedback.backgroundNoise': 'Ruído de fundo 🌫',
  'editor.feedback.commentPlaceholder': 'Escreva aqui o seu comentário',
  'editor.feedback.freeVideoAdded': 'Foi adicionado 1 vídeo\nà sua conta',
  'editor.feedback.originalMismatch': 'O áudio original e o traduzido não coincidem (p. ex., velocidade ou pausas) 💬',
  'editor.feedback.poorTranslation': 'Tradução de texto fraca 🗺️',
  'editor.feedback.rateFree': 'Avalie o resultado e receba 1 vídeo grátis',
  'editor.feedback.rateLipSync': 'Avalie a sincronização labial',
  'editor.feedback.rateResult': 'Avalie o resultado',
  'editor.feedback.roboticVoice': 'Voz robótica 🤖',
  'editor.feedback.speakerIncorrect': 'Voz errada atribuída ao orador 👨👩',
  'editor.feedback.speechRecognition': 'Transcrição de voz imprecisa 📝',
  'editor.feedback.thankYou': 'Obrigado',
  'editor.feedback.voiceAccent': 'Sotaque errado na voz 🎙',
  'editor.feedback.voiceClone': 'O clone de voz não soa como a voz original 😞',
  'editor.feedback.whatWentWrong': 'O que correu mal?',
  'editor.glossary.actionsAfterProcessing': 'As ações do dicionário estarão disponíveis após o processamento',
  'editor.glossary.addHint':
    'As suas traduções personalizadas serão apresentadas aqui. Pode aplicá-las a todos os projetos futuros.',
  'editor.glossary.alreadyExists': 'A palavra já está no seu glossário — edite a tradução existente.',
  'editor.glossary.chooseLanguage': 'Escolha um idioma',
  'editor.glossary.create': 'Criar dicionário',
  'editor.glossary.createError': 'Erro ao criar o glossário',
  'editor.glossary.createNew': 'Criar novo',
  'editor.glossary.createNewTitle': 'Criar novo glossário',
  'editor.glossary.createSubtitle': 'Selecione o par de idiomas e dê um nome ao glossário',
  'editor.glossary.deleteSubtitle': 'Depois de eliminado, este dicionário deixará de estar acessível.',
  'editor.glossary.deleteTitle': 'Pretende eliminar permanentemente este dicionário?',
  'editor.glossary.dictionaries': 'Dicionários',
  'editor.glossary.dictionary': 'Glossário',
  'editor.glossary.doNotTranslate': 'Não traduzir',
  'editor.glossary.downloadTemplate': 'Transferir modelo',
  'editor.glossary.enterName': 'Introduza o nome',
  'editor.glossary.importHint':
    'Importe o seu glossário a partir de um ficheiro CSV ou TSV. Transfira o modelo para começar rapidamente.',
  'editor.glossary.languagePairUnavailable': 'O dicionário de tradução não está disponível para este par de idiomas',
  'editor.glossary.name': 'Nome',
  'editor.glossary.newVersionSubtitle':
    'O dicionário utilizado neste projeto foi alterado. Volte a traduzir o projeto para aplicar as alterações.',
  'editor.glossary.newVersionTitle': 'Está disponível uma nova versão do dicionário',
  'editor.glossary.noMoreForProject': 'Não voltar a mostrar no projeto atual',
  'editor.glossary.off': 'Desativado',
  'editor.glossary.oldVersion': 'Versão anterior no projeto',
  'editor.glossary.rename': 'Mudar o nome do dicionário',
  'editor.glossary.retranslateSubtitle':
    'O glossário utilizado no projeto foi alterado. Para aplicar as alterações, traduza novamente o projeto.',
  'editor.glossary.retranslateTitle': 'Pretende aplicar as alterações e traduzir novamente o projeto?',
  'editor.glossary.saveAndContinue': 'Guardar e continuar',
  'editor.glossary.searchLanguage': 'Pesquisar idioma',
  'editor.glossary.selectLanguage': 'Selecionar idioma',
  'editor.glossary.typeTranslation': 'Introduza a tradução',
  'editor.glossary.typeWord': 'Introduza a palavra',
  'editor.glossary.unsavedSubtitle':
    'Se sair agora do glossário, perderá as traduções mais recentes. Guarde as alterações e continue.',
  'editor.glossary.unsavedTitle': 'Tem alterações por guardar',
  'editor.glossary.upgradeToCreate': 'Atualize o plano para criar um dicionário',
  'editor.glossary.zeroStateDescription':
    'Defina as suas próprias traduções para palavras e expressões e utilize-as de forma consistente em todos os seus projetos.',
  'editor.header.getHelp': 'Obter ajuda',
  'editor.header.help': 'Ajuda',
  'editor.header.helpCenter': 'Centro de ajuda',
  'editor.header.keyboardShortcuts': 'Atalhos de teclado',
  'editor.header.translateOwnVideo': 'Traduzir o meu próprio vídeo',
  'editor.language.infoAria': 'Detalhes do idioma da Clonagem de voz',
  'editor.language.starsAria': 'Clonagem de voz disponível',
  'editor.language.translation': 'Tradução: {language}',
  'editor.language.voiceClone': 'Clonagem de voz',
  'editor.language.voiceCloneLanguage': 'Clonagem de voz: {language}',
  'editor.lipSync.aboutUpdate': 'sobre a atualização da sincronização labial',
  'editor.lipSync.betaPricing': 'Preço em fase beta',
  'editor.lipSync.betaPricingHint': 'O preço do Enhanced está em fase beta e poderá ser alterado.',
  'editor.lipSync.check': '— Verificar',
  'editor.lipSync.criteriaFace': 'O rosto está claramente visível',
  'editor.lipSync.criteriaLight': 'A iluminação é adequada, sem sombras nem sobre-exposição',
  'editor.lipSync.criteriaNotCovered': 'Nada cobre os olhos, o nariz, a boca ou as sobrancelhas',
  'editor.lipSync.criteriaPassed': 'O seu vídeo cumpre todos os critérios ✓',
  'editor.lipSync.criteriaTitle': 'Antes de começar, certifique-se de que o seu vídeo cumpre estes critérios:',
  'editor.lipSync.detectFaceFailed': 'A sincronização labial falhou: não foi possível detetar um rosto neste vídeo.',
  'editor.lipSync.enhanced': 'Enhanced (novo)',
  'editor.lipSync.enhancedIntro': 'A sincronização labial melhorada já chegou',
  'editor.lipSync.enhancedSubtitleFew':
    'O nosso novo modelo de sincronização labial melhorada oferece qualidade de estúdio. Descontamos {multiplier} minutos do seu saldo por cada minuto de vídeo. As repetições têm o mesmo custo.',
  'editor.lipSync.enhancedSubtitleMany':
    'O nosso novo modelo de sincronização labial melhorada oferece qualidade de estúdio. Descontamos {multiplier} minutos do seu saldo por cada minuto de vídeo. As repetições têm o mesmo custo.',
  'editor.lipSync.enhancedSubtitleOne':
    'O nosso novo modelo de sincronização labial melhorada oferece qualidade de estúdio. Descontamos {multiplier} minuto do seu saldo por cada minuto de vídeo. As repetições têm o mesmo custo.',
  'editor.lipSync.enhancedSubtitleOther':
    'O nosso novo modelo de sincronização labial melhorada oferece qualidade de estúdio. Descontamos {multiplier} minutos do seu saldo por cada minuto de vídeo. As repetições têm o mesmo custo.',
  'editor.lipSync.faceNotDetected': 'Não foi possível detetar um rosto neste vídeo',
  'editor.lipSync.faceRetry':
    'Certifique-se de que o rosto está claramente visível e não está tapado. Depois, tente novamente.',
  'editor.lipSync.free': 'Grátis',
  'editor.lipSync.freeFull': 'Voltar a sincronizar os lábios no vídeo é grátis',
  'editor.lipSync.freeMinuteButton': 'Sincronizar 1 min',
  'editor.lipSync.freeMinuteSubtitle': 'Vamos sincronizar 1 minuto do seu vídeo para poder avaliar o resultado.',
  'editor.lipSync.freeMinuteTitle': 'Vamos aplicar lip-sync a 1 minuto deste vídeo gratuitamente',
  'editor.lipSync.fullCostFew': 'Vamos sincronizar os lábios neste vídeo e descontar {minutes} minutos da sua conta',
  'editor.lipSync.fullCostMany': 'Vamos sincronizar os lábios neste vídeo e descontar {minutes} minutos da sua conta',
  'editor.lipSync.fullCostOne': 'Vamos sincronizar os lábios neste vídeo e descontar {minutes} minuto da sua conta',
  'editor.lipSync.fullCostOther': 'Vamos sincronizar os lábios neste vídeo e descontar {minutes} minutos da sua conta',
  'editor.lipSync.fullCostPrefix': 'Vamos sincronizar os lábios neste vídeo e descontar',
  'editor.lipSync.fullCostSuffix': 'da sua conta',
  'editor.lipSync.fullOfferSubtitle':
    'Sincronizámos os lábios em apenas 1 minuto do seu vídeo para poder avaliar o resultado',
  'editor.lipSync.fullVideo': 'Sincronizar os lábios no vídeo completo',
  'editor.lipSync.helpUse': 'sobre como utilizar eficazmente o lip-sync',
  'editor.lipSync.inProgress': 'Lip-sync em curso',
  'editor.lipSync.inProgressSubtitle':
    'Normalmente, demora alguns minutos. Pode sair desta página — iremos notificá-lo quando estiver pronto.',
  'editor.lipSync.legacy': 'Legacy',
  'editor.lipSync.minuteCost': 'Um minuto de vídeo com lip-sync custa um minuto do seu saldo.',
  'editor.lipSync.minuteFew': '{minutes} minutos',
  'editor.lipSync.minuteMany': '{minutes} minutos',
  'editor.lipSync.minuteOne': '{minutes} minuto',
  'editor.lipSync.minuteOther': '{minutes} minutos',
  'editor.lipSync.model': 'Modelo de sincronização labial',
  'editor.lipSync.new': 'Novo!',
  'editor.lipSync.newUserTitle': 'Sincronize os movimentos da boca com o áudio traduzido através do lip-sync',
  'editor.lipSync.newVersionSubtitle':
    'Atualizámos a qualidade do lip-sync. Agora, tem o mesmo custo da tradução: 1 minuto de lip-sync custa 1 minuto.',
  'editor.lipSync.newVersionTitle': 'Chegou a nova versão do Lip-sync!',
  'editor.lipSync.processing': 'A processar o seu vídeo…',
  'editor.lipSync.processingError': 'Ocorreu um erro durante o processamento',
  'editor.lipSync.queue': 'Fila: {number}',
  'editor.lipSync.queueBeforeFew': 'O seu vídeo está na fila. Há {count} projetos a ser processados antes do seu.',
  'editor.lipSync.queueBeforeMany': 'O seu vídeo está na fila. Há {count} projetos a ser processados antes do seu.',
  'editor.lipSync.queueBeforeOne': 'O seu vídeo está na fila. Há {count} projeto a ser processado antes do seu.',
  'editor.lipSync.queueBeforeOther': 'O seu vídeo está na fila. Há {count} projetos a ser processados antes do seu.',
  'editor.lipSync.reCostFew':
    'Vamos voltar a sincronizar os lábios neste vídeo e descontar {minutes} minutos da sua conta',
  'editor.lipSync.reCostMany':
    'Vamos voltar a sincronizar os lábios neste vídeo e descontar {minutes} minutos da sua conta',
  'editor.lipSync.reCostOne':
    'Vamos voltar a sincronizar os lábios neste vídeo e descontar {minutes} minuto da sua conta',
  'editor.lipSync.reCostOther':
    'Vamos voltar a sincronizar os lábios neste vídeo e descontar {minutes} minutos da sua conta',
  'editor.lipSync.regenerationCost': 'A nova geração tem o mesmo custo da primeira.',
  'editor.lipSync.retryGeneric': 'Tente novamente. Se o problema persistir, contacte o apoio ao cliente.',
  'editor.lipSync.start': 'Iniciar Lip-sync',
  'editor.lipSync.starting': 'A iniciar o Lip-sync...',
  'editor.lipSync.timeCost': 'Custo: {minutes} min',
  'editor.lipSync.tryFree': 'Experimente a sincronização labial grátis',
  'editor.lipSync.upgradeFull': 'Mude de plano para aplicar lip-sync ao vídeo completo',
  'editor.lipSync.upgradeOfferSubtitle':
    'Para gerar a sincronização labial para o vídeo completo, mude para o plano Creator Pro',
  'editor.lipSyncFeedback.articulationCaptionLeft': 'Má articulação 😔',
  'editor.lipSyncFeedback.articulationCaptionRight': 'Excelente articulação 🤩',
  'editor.lipSyncFeedback.articulationSubtitle': 'Quão naturais parecem os movimentos da boca?',
  'editor.lipSyncFeedback.articulationTitle': 'Avalie: Articulação',
  'editor.lipSyncFeedback.consistencyCaptionLeft': 'Nada consistente 😔',
  'editor.lipSyncFeedback.consistencyCaptionRight': 'Muito consistente 🤩',
  'editor.lipSyncFeedback.consistencySubtitle': 'Quão consistentes são os traços faciais ao longo do vídeo gerado?',
  'editor.lipSyncFeedback.consistencyTitle': 'Avalie: Consistência',
  'editor.lipSyncFeedback.leaveMore': 'Deixe mais comentários aqui',
  'editor.lipSyncFeedback.qualityCaptionLeft': 'Muito desfocado, pouco natural 😞',
  'editor.lipSyncFeedback.qualityCaptionRight': 'Muito detalhado e natural 🤩',
  'editor.lipSyncFeedback.qualitySubtitle': 'Como avalia a qualidade do rosto gerado?',
  'editor.lipSyncFeedback.qualityTitle': 'Avalie: Qualidade da imagem',
  'editor.lipSyncFeedback.similarityCaptionLeft': 'Completamente diferente 😔',
  'editor.lipSyncFeedback.similarityCaptionRight': 'Parece-me ser a mesma pessoa 🤩',
  'editor.lipSyncFeedback.similaritySubtitle':
    'Até que ponto o resultado se assemelha ao rosto, aos lábios e aos dentes originais?',
  'editor.lipSyncFeedback.similarityTitle': 'Avalie: Semelhança',
  'editor.lipSyncFeedback.syncCaptionLeft': 'Má sincronização 😔',
  'editor.lipSyncFeedback.syncCaptionRight': 'Excelente sincronização 🤩',
  'editor.lipSyncFeedback.syncSubtitle': 'Com que precisão o movimento da boca corresponde ao áudio?',
  'editor.lipSyncFeedback.syncTitle': 'Avalie: Sincronização',
  'editor.mobile.adjustTimestamps': 'Ajustar códigos de tempo',
  'editor.mobile.assignSpeakers': 'Atribuir oradores e vozes',
  'editor.mobile.backHome': 'Voltar ao início',
  'editor.mobile.deleteAll': 'Eliminar tudo ({count})',
  'editor.mobile.desktopHint': 'Abra o projeto no computador para explorar todas as funcionalidades do editor.',
  'editor.mobile.dubDescription':
    'Ao premir o botão Dobrar, descontaremos automaticamente os minutos do seu plano de acordo com a duração do vídeo',
  'editor.mobile.dubTitle': 'Dobre aqui ou abra no computador para verificar a transcrição e a tradução',
  'editor.mobile.dubVideo': 'Dobrar vídeo',
  'editor.mobile.editorDesktopOnly': 'O editor só está disponível no computador',
  'editor.mobile.editText': 'Editar o texto da transcrição e da tradução',
  'editor.mobile.emptySegments': 'Preencha ou elimine os segmentos vazios para dobrar o vídeo.',
  'editor.mobile.firecrackerAria': 'Lança-confetes',
  'editor.mobile.fullExperience': 'Obtenha a experiência completa no computador',
  'editor.mobile.goatAria': 'Gesto de rock',
  'editor.mobile.laptopAria': 'Computador portátil',
  'editor.mobile.leaveAndReturn': 'Pode sair da página e voltar mais tarde.',
  'editor.mobile.leaveOrWait': 'Pode sair desta página ou aguardar aqui',
  'editor.mobile.phoneAria': 'Telemóvel',
  'editor.mobile.resultDescription':
    'Pode ver o resultado, compará-lo com o original, transferi-lo ou melhorá-lo no nosso editor fácil de utilizar',
  'editor.mobile.translateOwn': 'Traduzir o meu vídeo',
  'editor.mobile.uploadSrt': 'Carregar ficheiro SRT',
  'editor.mobile.videoReady': 'O seu vídeo está pronto!',
  'editor.multilanguage.autoDub': 'Dobragem automática',
  'editor.multilanguage.autoDubHint': 'Gere automaticamente um vídeo com dobragem.',
  'editor.multilanguage.availableLanguages': 'Idiomas disponíveis',
  'editor.multilanguage.choose': 'Escolha os idiomas para a tradução',
  'editor.multilanguage.clearAll': 'Limpar tudo',
  'editor.multilanguage.collapse': 'Recolher',
  'editor.multilanguage.expand': 'Expandir',
  'editor.multilanguage.faqSuffix': 'sobre como utilizar esta funcionalidade de forma eficaz.',
  'editor.multilanguage.goToProjectList': 'Ir para a lista de projetos',
  'editor.multilanguage.openProject': 'Abrir projeto',
  'editor.multilanguage.reuseTranscript':
    'Vamos reutilizar a transcrição do vídeo original, para não ter de a rever duas vezes.',
  'editor.multilanguage.search': 'Pesquisar idiomas',
  'editor.multilanguage.select': 'Selecionar idiomas',
  'editor.multilanguage.stayHere': 'Ficar aqui',
  'editor.multilanguage.submitting': 'A enviar...',
  'editor.multilanguage.successSubtitle':
    'Criámos novos projetos para os idiomas selecionados. Abra um dos projetos abaixo ou permaneça no projeto atual.',
  'editor.multilanguage.successTitle': 'Os seus projetos de tradução estão prontos',
  'editor.multilanguage.translateTo': 'Traduzir para',
  'editor.multilanguage.voiceCloneOr': ' ou clone de voz',
  'editor.multilanguage.voiceCloneOrNamed': ' ou clone de voz {name}',
  'editor.multilanguage.voiceHintMany': '{count} idiomas · locução: vozes de IA predefinidas{voiceClone}',
  'editor.multilanguage.voiceHintOne': 'Tradução: {language}, locução: vozes de IA predefinidas{voiceClone}',
  'editor.notification.videoGenerated': 'Vídeo gerado',
  'editor.onboarding.advancedToolsSubtitle':
    'Aceda a funcionalidades como o Dicionário, as instruções de tradução e o carregamento de ficheiros SRT para melhorar o seu fluxo de trabalho de tradução.',
  'editor.onboarding.advancedToolsTitle': 'Ferramentas avançadas para utilizadores experientes',
  'editor.onboarding.audioTrackTitle': 'Ajuste os códigos de tempo para sincronizar a fala traduzida com a original',
  'editor.onboarding.changeTextTitle': 'Edite aqui o texto, os oradores e as vozes',
  'editor.onboarding.clickPlayTitle': 'Clique em reproduzir para ver o novo vídeo traduzido',
  'editor.onboarding.customizeVoiceTitle':
    'Personalize o seu Clone de Voz ajustando os níveis de expressividade e semelhança',
  'editor.onboarding.demoWelcomeSubtitle':
    'Explore aqui as versões original e traduzida do vídeo. Experimente o editor para perceber como funciona!',
  'editor.onboarding.demoWelcomeTitle': 'Boas-vindas ao projeto de demonstração',
  'editor.onboarding.discoverTeamspaceSubtitle':
    'Faça a gestão da sua equipa e colabore facilmente, criando novos Teamspaces e alternando entre eles aqui.',
  'editor.onboarding.discoverTeamspaceTitle': 'Descubra os Teamspaces',
  'editor.onboarding.downloadTitle': 'Transfira o vídeo aqui',
  'editor.onboarding.editorActionsSubtitle':
    'Passe o cursor sobre um segmento para unir ou adicionar segmentos. Divida na posição do cursor de texto, marque momentos importantes com uma estrela e consulte os atalhos de teclado na Ajuda.',
  'editor.onboarding.editorActionsTitle': 'Edite segmentos mais rapidamente',
  'editor.onboarding.manageTeamspaceSubtitle': 'Alterne facilmente entre espaços aqui para colaborar com a sua equipa.',
  'editor.onboarding.manageTeamspaceTitle': 'Faça a gestão dos seus Teamspaces aqui',
  'editor.onboarding.segmentPreviewSubtitle':
    'Reproduza a linha para verificar a sincronização e a voz antes de aplicar as alterações a todo o projeto.',
  'editor.onboarding.segmentPreviewTitle': 'Pré-visualize um segmento antes de dobrar o vídeo completo',
  'editor.onboarding.speakerVoicesTitle':
    'Faça a gestão das vozes de todos os oradores e não se esqueça de aplicar as alterações',
  'editor.onboarding.transcriptVersionsSubtitle':
    'Abra o histórico de versões para rever as alterações e, em seguida, use o ícone de reposição numa versão anterior para a restaurar.',
  'editor.onboarding.transcriptVersionsTitle': 'Guarde, compare e restaure versões',
  'editor.onboarding.translateOwnTitle': 'Traduza vídeos para mais de 135 idiomas',
  'editor.onboarding.translationVariantsSubtitle':
    'Escolha uma tradução recomendada ou com melhor sincronização e pré-visualize-a na linha.',
  'editor.onboarding.translationVariantsTitle': 'Experimente alternativas de tradução',
  'editor.onboarding.videoTabsTitle': 'Alterne entre os vídeos original e traduzido',
  'editor.processing.analyzingSpeakers': 'A analisar os oradores',
  'editor.processing.analyzingSrt': 'A analisar o SRT',
  'editor.processing.analyzingVideo': 'A analisar o vídeo',
  'editor.processing.analyzingVoices': 'A analisar as vozes',
  'editor.processing.applyingChanges': 'A aplicar alterações',
  'editor.processing.assigningVoiceToAddedSpeaker': 'Estamos a atribuir uma voz ao orador adicionado.',
  'editor.processing.generatingAudio': 'A gerar áudio',
  'editor.processing.generatingVideo': 'A gerar vídeo',
  'editor.processing.processing': 'A processar',
  'editor.processing.saving': 'A guardar',
  'editor.processing.transcriptingVideo': 'A transcrever o vídeo',
  'editor.processing.translating': 'A traduzir ({count})',
  'editor.processing.translatingText': 'A traduzir texto',
  'editor.processing.unknown': 'A processar ({count})',
  'editor.processing.uploadingVideo': 'A carregar o vídeo',
  'editor.processing.voicing': 'A gerar voz ({count})',
  'editor.project.allProjects': 'Todos os projetos',
  'editor.project.chooseLocation': 'Escolher localização',
  'editor.project.deleteManySubtitle': 'Deixará de poder aceder aos projetos.',
  'editor.project.deleteManyTitle': 'Pretende eliminar permanentemente os projetos selecionados?',
  'editor.project.deleteOneSubtitle': 'Depois de eliminado, este projeto deixará de estar acessível.',
  'editor.project.deleteOneTitle': 'Pretende eliminar permanentemente este projeto?',
  'editor.project.fieldRequired': 'Campo obrigatório',
  'editor.project.move': 'Mover',
  'editor.project.moveMany': 'Mover projetos',
  'editor.project.moveManySubtitle': 'Os {count} projetos selecionados serão movidos para esta pasta',
  'editor.project.moveOneSubtitle': 'O projeto selecionado será movido para esta pasta',
  'editor.project.name': 'Nome',
  'editor.project.rename': 'Mudar o nome do projeto',
  'editor.project.selectFolder': 'Selecionar pasta',
  'editor.prompt.customizeSubtitle':
    'Personalize o estilo, o contexto e o tom da tradução através de instruções. Use um modelo ou crie a sua própria instrução.',
  'editor.prompt.customizeTitle': 'Personalizar a tradução',
  'editor.prompt.faqSuffix': 'como utilizar instruções de forma eficaz',
  'editor.prompt.placeholder': 'Escreva aqui a sua instrução ou use um dos modelos existentes',
  'editor.prompt.templateFormal': 'formal',
  'editor.prompt.templateFormalValue':
    'Traduza este vídeo num tom formal. Mantenha uma linguagem profissional adequada a um contexto empresarial e evite expressões informais. Use terminologia adequada ao tema. Não use os seguintes termos: [inserir termos].',
  'editor.prompt.templateIndustry': 'específico do setor',
  'editor.prompt.templateIndustryValue':
    'Traduza este vídeo usando terminologia específica de [setor/área]. Consulte o nosso site [ligação para o site] para conhecer os termos e a linguagem que preferimos.',
  'editor.prompt.templateInformal': 'informal',
  'editor.prompt.templateInformalValue':
    'Traduza este vídeo num tom informal. Use uma linguagem coloquial e adapte as expressões para tornar o conteúdo acessível e amigável. Evite usar os seguintes termos: [inserir termos].',
  'editor.prompt.templates': 'Modelos',
  'editor.resizeWarning': 'Expanda a janela do navegador para uma melhor experiência de edição',
  'editor.search.aria': 'Pesquisar texto',
  'editor.search.placeholder': 'Pesquisar',
  'editor.shortcuts.anywhereDescription': 'Em qualquer parte do projeto',
  'editor.shortcuts.backTenSeconds': 'Recuar 10 s',
  'editor.shortcuts.closeAria': 'Fechar os atalhos de teclado',
  'editor.shortcuts.forwardTenSeconds': 'Avançar 10 s',
  'editor.shortcuts.generalTitle': 'Geral',
  'editor.shortcuts.hoverSegmentDescription': 'Ao passar o cursor sobre um segmento',
  'editor.shortcuts.insertPause': 'Inserir pausa',
  'editor.shortcuts.insertPauseHelper': 'Escreva no ponto onde pretende que a voz faça uma pausa',
  'editor.shortcuts.playbackDescription': 'Quando não estiver a editar texto',
  'editor.shortcuts.playbackSpeed': 'Velocidade de reprodução',
  'editor.shortcuts.playbackTitle': 'Reprodução',
  'editor.shortcuts.playPause': 'Reproduzir / Pausar',
  'editor.shortcuts.searchProject': 'Pesquisar no projeto',
  'editor.shortcuts.segmentTitle': 'Segmento',
  'editor.shortcuts.textEditingDescription': 'Ao editar o texto de um segmento',
  'editor.shortcuts.textEditingTitle': 'Edição de texto',
  'editor.segment.add': 'Adicionar segmento',
  'editor.segment.addAbove': 'Adicionar segmento acima',
  'editor.segment.addBelow': 'Adicionar segmento abaixo',
  'editor.segment.addSpeaker': 'Adicionar orador',
  'editor.segment.cancelOrSave': 'Cancele ou guarde o segmento',
  'editor.segment.chooseSpeaker': 'Escolher orador',
  'editor.segment.createError': 'Não foi possível criar o segmento. Tente novamente',
  'editor.segment.deleteAllTitle': 'Pretende eliminar permanentemente todos os segmentos vazios?',
  'editor.segment.deleteTitle': 'Pretende eliminar este segmento?',
  'editor.segment.enterText': 'Introduza o texto',
  'editor.segment.markAttention': 'Marcar como a precisar de atenção',
  'editor.segment.markedForAttention': 'Marcado como a precisar de atenção',
  'editor.segment.merge': 'Unir e voltar a traduzir',
  'editor.segment.mergeError': 'Não foi possível unir estes segmentos. Tente novamente',
  'editor.segment.mergePendingEditsError':
    'Não foi possível guardar as alterações pendentes, pelo que os segmentos não foram unidos',
  'editor.segment.mergeRecoveryPointError':
    'Não foi possível criar um ponto de restauro, pelo que os segmentos não foram unidos',
  'editor.segment.mergeOnly': 'Unir',
  'editor.segment.mergingProgress': 'A unir segmentos...',
  'editor.segment.removeAttention': 'Remover marcação de atenção',
  'editor.segment.saveError': 'Não foi possível guardar o segmento. Tente novamente',
  'editor.segment.saveManyError': 'Não foi possível guardar estes segmentos. Tente novamente',
  'editor.segment.splitDescriptionCurrent': 'Se quiser manter a tradução atual, pode dividir o texto traduzido.',
  'editor.segment.splitDescriptionOriginal':
    'A divisão do texto original fará com que os segmentos relevantes sejam traduzidos novamente.',
  'editor.segment.splitDontShow': 'Não voltar a mostrar',
  'editor.segment.splitSubmit': 'Dividir segmentos',
  'editor.segment.splitTitle': 'Os novos segmentos serão traduzidos novamente',
  'editor.segment.translationPlaceholder': 'A sua tradução aparecerá aqui',
  'editor.segment.updateAttentionError': 'Não foi possível atualizar a marcação de atenção. Tente novamente',
  'editor.segment.voiceOver': 'Locução',
  'editor.segmentPreview.generating': 'A gerar pré-visualização...',
  'editor.segmentPreview.generatingAria': 'A gerar pré-visualização do áudio do segmento',
  'editor.segmentPreview.generatingAudio': 'A gerar áudio...',
  'editor.segmentPreview.preview': 'Pré-visualizar áudio do segmento',
  'editor.segmentPreview.processingSeconds': '{label} ({seconds} s)',
  'editor.segmentPreview.retry': 'A geração excedeu o tempo limite. Clique para tentar novamente.',
  'editor.segmentPreview.retryAria': 'Tentar novamente a pré-visualização do áudio do segmento',
  'editor.segmentPreview.stillProcessing': 'Ainda a processar...',
  'editor.segmentPreview.stop': 'Parar pré-visualização',
  'editor.segmentPreview.stopAria': 'Parar pré-visualização do áudio do segmento',
  'editor.segmentPreview.translateFirst': 'Traduza o segmento antes de pré-visualizar o áudio',
  'editor.segmentPreview.translating': 'A traduzir o segmento...',
  'editor.speaker.selectSubtitle':
    'Os segmentos a unir têm oradores diferentes. Selecione um orador para o novo segmento.',
  'editor.speaker.selectTitle': 'Selecionar orador do novo segmento',
  'editor.speaker.speaker': 'Orador',
  'editor.srt.applySubtitle':
    'O ficheiro SRT do projeto foi modificado. Esta ação aplicará alterações permanentes ao projeto.',
  'editor.srt.applyTitle': 'Pretende aplicar as alterações?',
  'editor.srt.fillDetails': 'Preencha os detalhes do projeto e carregue o ficheiro',
  'editor.srt.howTo': 'sobre como carregar corretamente um ficheiro SRT',
  'editor.srt.identicalTimestamps':
    'Certifique-se de que ambos os ficheiros SRT têm códigos de tempo idênticos ou remova um deles.',
  'editor.srt.languageInVideo': 'Idioma do vídeo',
  'editor.srt.upload': 'Carregar SRT',
  'editor.srt.wrongFormat': 'Formato de ficheiro SRT incorreto. Utilize outro ficheiro.',
  'editor.srtWarning.gotIt': 'Percebi!',
  'editor.srtWarning.speakers': 'Atribuímos automaticamente os oradores. Verifique-os antes da dobragem.',
  'editor.srtWarning.timestamps':
    'Combinámos algumas das suas marcações de tempo para melhorar a qualidade da dobragem.',
  'editor.srtWarning.title': 'Antes da dobragem, reveja os seguintes pontos',
  'editor.timestamp.exceedsVideo': 'O código de tempo excede a duração do vídeo. Introduza um código de tempo válido.',
  'editor.timestamp.overlap': 'Este segmento sobrepõe-se a outro segmento',
  'editor.timestamp.startAfterEnd': 'O código de tempo inicial não pode ser posterior ao final',
  'editor.toast.voiceMissingDesktop': 'Pode selecionar outra voz para o locutor na versão para computador.',
  'editor.toast.voiceMissingTitle': 'Não conseguimos encontrar uma voz semelhante à do locutor no seu vídeo.',
  'editor.toast.voiceMissingWeb': 'Pode selecionar outra voz para o locutor clicando no botão da voz do locutor.',
  'editor.translationVariants.alternativesFew': '{count} alternativas de tradução',
  'editor.translationVariants.alternativesMany': '{count} alternativas de tradução',
  'editor.translationVariants.alternativesOne': '{count} alternativa de tradução',
  'editor.translationVariants.alternativesOther': '{count} alternativas de tradução',
  'editor.translationVariants.faster': 'Mais rápido',
  'editor.translationVariants.info':
    'Ouça a tradução selecionada através do botão de reprodução da linha ou do leitor principal.',
  'editor.translationVariants.original': 'Original',
  'editor.translationVariants.recommended': 'Recomendada',
  'editor.translationVariants.slower': 'Mais lento',
  'editor.trial.unlockFullAccess': 'Desbloquear acesso total',
  'editor.tutorial.getStartedSubtitle': 'Descubra o poder do Rask para traduzir vídeos de forma eficiente',
  'editor.tutorial.getStartedTitle': 'Como começar',
  'editor.versions.autoAfterMerge': 'Automática (após a fusão)',
  'editor.versions.autoAfterTranslation': 'Automática (após a tradução)',
  'editor.versions.autoSave': 'Gravação automática',
  'editor.versions.changed': 'Alterado',
  'editor.versions.changes': 'Alterações',
  'editor.versions.closeAria': 'Fechar histórico de versões',
  'editor.versions.compareError': 'Não foi possível comparar com a versão {version}',
  'editor.versions.compareLoading': 'A carregar comparação com a versão {version}...',
  'editor.versions.compareSummary':
    'Comparação com a versão {version}: novos: {added}, alterados: {changed}, removidos: {removed}',
  'editor.versions.current': 'Atual',
  'editor.versions.customVoice': 'Voz personalizada',
  'editor.versions.detailError': 'Os detalhes da versão não estão disponíveis',
  'editor.versions.detailLoadError': 'Não foi possível carregar a versão selecionada.',
  'editor.versions.full': 'Versão completa',
  'editor.versions.history': 'Histórico de versões',
  'editor.versions.initialSummary': 'Versão inicial • Segmentos: {count}',
  'editor.versions.listLoadError': 'Não foi possível carregar o histórico de versões. Tente novamente.',
  'editor.versions.manualSave': 'Gravação manual',
  'editor.versions.name': 'Nome da versão',
  'editor.versions.new': 'Novo',
  'editor.versions.noChanges': 'Não há alterações ao texto ou aos tempos dos segmentos nesta versão.',
  'editor.versions.noText': 'Sem texto',
  'editor.versions.noVoice': 'Sem voz',
  'editor.versions.openAria': 'Abrir histórico de versões da transcrição',
  'editor.versions.openVersionAria': 'Abrir versão {version}',
  'editor.versions.optional': 'Opcional',
  'editor.versions.placeholder': 'As versões guardadas da transcrição serão apresentadas aqui',
  'editor.versions.previousUnavailable': 'A versão anterior não está disponível',
  'editor.versions.removed': 'Removido',
  'editor.versions.retry': 'Tentar novamente',
  'editor.versions.rollback': 'Repor',
  'editor.versions.rollbackAria': 'Reverter para a versão {version}',
  'editor.versions.rollbackDescription':
    'Esta ação irá repor todos os segmentos no estado guardado na versão {version}. Antes da reposição, o estado atual será guardado automaticamente como uma nova versão.',
  'editor.versions.rollbackError': 'Não foi possível repor a versão da transcrição. Tente novamente.',
  'editor.versions.rollbackSuccess': 'Transcrição reposta a partir da versão selecionada',
  'editor.versions.rollbackTitle': 'Repor a versão {version}?',
  'editor.versions.save': 'Guardar versão da transcrição',
  'editor.versions.saved': 'Versão da transcrição guardada',
  'editor.versions.saveDescription': 'Crie um ponto de restauro para o estado atual da transcrição.',
  'editor.versions.saveError': 'Não foi possível guardar a versão da transcrição. Tente novamente.',
  'editor.versions.saving': 'A guardar...',
  'editor.versions.waitForSave': 'Aguarde que a versão da transcrição termine de ser guardada e tente novamente',
  'editor.versions.segment': 'Segmento {number}',
  'editor.versions.segments': 'Segmentos: {count}',
  'editor.versions.select': 'Selecione uma versão para pré-visualizar os segmentos guardados.',
  'editor.versions.showFull': 'Mostrar versão completa',
  'editor.versions.speakerVoices': 'Vozes dos oradores',
  'editor.versions.timing': 'Tempos',
  'editor.versions.version': 'Versão {version}',
  'editor.video.aiPresetLanguages': 'Idiomas apenas com vozes de IA predefinidas',
  'editor.video.applyLastChanges':
    'Volte a fazer a sincronização labial do vídeo para aplicar as alterações mais recentes',
  'editor.video.audio': 'Áudio',
  'editor.video.audioBackground': 'Áudio com voz e faixa de fundo',
  'editor.video.audioVoice': 'Áudio apenas com voz',
  'editor.video.checkingLipSync': 'Estamos a verificar se é possível sincronizar os lábios no seu vídeo',
  'editor.video.cloneLanguages': 'Idiomas com clones de voz e vozes de IA predefinidas',
  'editor.video.downloadAudioBackgroundAfterDub':
    'Dobre primeiro o vídeo para transferir o áudio com voz e faixa de fundo',
  'editor.video.downloadAudioVoiceAfterDub': 'Dobre primeiro o vídeo para transferir o áudio com voz',
  'editor.video.downloadCaptionsDubFirst': 'Dobre primeiro o vídeo para gerar legendas',
  'editor.video.downloadCaptionsGenerate': 'Clique em Gerar para descarregar o vídeo com legendas',
  'editor.video.downloadCaptionsLipSyncFirst': 'Aplique primeiro o lip-sync ao vídeo e depois gere as legendas',
  'editor.video.downloadReady': 'O vídeo com legendas está pronto para ser transferido!',
  'editor.video.downloadTranslatedSubtitlesAfterDub': 'Dobre primeiro o vídeo para transferir as legendas traduzidas',
  'editor.video.dubFirstLipSync': 'Dobre primeiro o vídeo e, depois, inicie a sincronização labial',
  'editor.video.dubFirstTranslated': 'Dobre primeiro o vídeo para descarregar o vídeo traduzido',
  'editor.video.dubFirstViewTranslated': 'Dobre primeiro o vídeo para ver o vídeo traduzido',
  'editor.video.exportAfterSaving': 'A transcrição estará disponível para exportação depois de guardar',
  'editor.video.exportTranslationAfterSaving': 'A tradução estará disponível para exportação depois de guardar',
  'editor.video.failedGenerate': 'Não foi possível gerar. Tente novamente',
  'editor.video.fullScreen': 'Ecrã inteiro',
  'editor.video.hideSubtitles': 'Ocultar legendas',
  'editor.video.lipSync': 'Lip-sync',
  'editor.video.lipSyncAndSubtitles': 'Vídeo com lip-sync e legendas',
  'editor.video.lipSynced': 'Sincronizado labialmente',
  'editor.video.lipSyncFaceOnly': 'A sincronização labial só está disponível para vídeos com um rosto humano',
  'editor.video.lipSyncFirstDownload': 'Sincronize primeiro os lábios no vídeo para o poder transferir',
  'editor.video.lipSyncFirstView': 'Faça primeiro a sincronização labial do vídeo para ver o resultado',
  'editor.video.lipSyncReady': 'O seu vídeo com sincronização labial está pronto!',
  'editor.video.original': 'Original',
  'editor.video.originalSubtitles': 'Legendas originais com códigos de tempo',
  'editor.video.originalTextSpeakers': 'Segmentos do texto original com identificação dos locutores',
  'editor.video.originalVideo': 'Vídeo original',
  'editor.video.processingQueueFew':
    'O seu vídeo está a ser processado. Há {count} tarefas de sincronização labial na fila',
  'editor.video.processingQueueMany':
    'O seu vídeo está a ser processado. Há {count} tarefas de sincronização labial na fila',
  'editor.video.processingQueueOne':
    'O seu vídeo está a ser processado. Há {count} tarefa de sincronização labial na fila',
  'editor.video.processingQueueOther':
    'O seu vídeo está a ser processado. Há {count} tarefas de sincronização labial na fila',
  'editor.video.processingSimple': 'O seu vídeo está a ser processado',
  'editor.video.redubAudioBackground': 'Volte a dobrar o vídeo para transferir o áudio com a faixa de fundo',
  'editor.video.remakeSubtitle':
    'Para gerar a sincronização labial para todo o vídeo e transferi-lo, basta iniciar novamente a funcionalidade de sincronização labial.',
  'editor.video.remakeTitle': 'Iniciar novamente a sincronização labial',
  'editor.video.showSubtitles': 'Mostrar legendas',
  'editor.video.textSubtitles': 'Legendas em texto (.srt)',
  'editor.video.translated': 'Traduzido',
  'editor.video.translatedLipSync': 'Vídeo traduzido com lip-sync',
  'editor.video.translatedSubtitles': 'Vídeo traduzido com legendas',
  'editor.video.translatedSubtitlesTimecodes': 'Legendas traduzidas com códigos de tempo',
  'editor.video.translatedTextSpeakers': 'Segmentos do texto traduzido com identificação dos locutores',
  'editor.video.translatedVideo': 'Vídeo traduzido',
  'editor.video.video': 'Vídeo',
  'editor.video.videoLipSync': 'Vídeo com sincronização labial',
  'editor.video.videoSubtitles': 'Vídeo com legendas',
  'editor.visualTranslation.tab': 'Visual',
  'editor.visualTranslation.new': 'Novo',
  'editor.visualTranslation.costOne': 'Vamos traduzir o texto no ecrã e descontar {minutes} minuto da sua conta',
  'editor.visualTranslation.costFew': 'Vamos traduzir o texto no ecrã e descontar {minutes} minutos da sua conta',
  'editor.visualTranslation.costMany': 'Vamos traduzir o texto no ecrã e descontar {minutes} minutos da sua conta',
  'editor.visualTranslation.costOther': 'Vamos traduzir o texto no ecrã e descontar {minutes} minutos da sua conta',
  'editor.visualTranslation.betaPricingHint':
    'Os preços da tradução do texto no ecrã estão em fase beta e poderão ser alterados.',
  'editor.visualTranslation.criteriaLegible': 'O texto no ecrã está nítido e legível',
  'editor.visualTranslation.criteriaNotCovered': 'O texto não está muito tapado nem obstruído',
  'editor.visualTranslation.criteriaNoAnimations': 'Sem animações de texto complexas',
  'editor.visualTranslation.start': 'Iniciar tradução visual',
  'editor.visualTranslation.processingTitle': 'A traduzir o texto no ecrã…',
  'editor.visualTranslation.processingSubtitle':
    'Normalmente demora entre 20 minutos e cerca de duas horas, consoante o vídeo. Pode continuar a editar enquanto trabalhamos.',
  'editor.visualTranslation.processingSubtitleMobile':
    'Normalmente demora entre 20 minutos e cerca de duas horas, consoante o vídeo.',
  'editor.visualTranslation.failedTitle': 'Ocorreu um erro durante o processamento',
  'editor.visualTranslation.failedSubtitle': 'Tente novamente. Se o problema persistir, contacte o suporte.',
  'editor.visualTranslation.refunded': 'Devolvemos os minutos à sua conta.',
  'editor.visualTranslation.notReady': 'Faça primeiro a dobragem do vídeo. Depois, poderá traduzir o texto no ecrã.',
  'editor.visualTranslation.tooLong': 'A tradução visual está disponível para vídeos com até {minutes} min.',
  'editor.visualTranslation.unavailable': 'A tradução visual não está disponível para este projeto.',
  'editor.visualTranslation.paused': 'A tradução visual está temporariamente indisponível. Tente novamente mais tarde.',
  'editor.visualTranslation.autoStartRejected.title':
    'A tradução do texto no ecrã que pediu ao carregar o vídeo não foi iniciada',
  'editor.visualTranslation.autoStartRejected.insufficientMinutes':
    'Não havia minutos suficientes na sua conta quando a dobragem terminou.',
  'editor.visualTranslation.autoStartRejected.videoTooLong':
    'O vídeo é demasiado longo para a tradução do texto no ecrã.',
  'editor.visualTranslation.autoStartRejected.notAvailable': 'O seu plano já não inclui a tradução do texto no ecrã.',
  'editor.visualTranslation.autoStartRejected.disabled':
    'A tradução do texto no ecrã estava temporariamente indisponível.',
  'editor.visualTranslation.autoStartRejected.languageNotSupported':
    'A tradução do texto no ecrã ainda não suporta o idioma de destino deste projeto.',
  'editor.visualTranslation.autoStartRejected.projectNotReady':
    'O vídeo dobrado não estava pronto para a tradução do texto no ecrã.',
  'editor.visualTranslation.autoStartRejected.startFailed': 'Ocorreu um erro ao iniciá-la. Tente novamente.',
  'editor.visualTranslation.autoStartRejected.demoProject':
    'A tradução do texto no ecrã não está disponível para projetos de demonstração nem para projetos em período experimental.',
  'editor.visualTranslation.autoStartRejected.unknown': 'Não conseguimos iniciá-la.',
  'editor.visualTranslation.autoStartRejected.noCharge': 'Não foi descontado nenhum minuto.',
  'editor.visualTranslation.outdated':
    'O vídeo dobrado foi alterado desde esta tradução. Execute novamente a tradução visual para atualizar o texto no ecrã.',
  'editor.visualTranslation.translateAgain': 'Traduzir novamente',
  'editor.visualTranslation.editTeaser': 'Quer editar o texto traduzido?',
  'editor.visualTranslation.editNow': 'Editar agora',
  'editor.visualTranslation.editSoonTitle': 'A edição estará disponível em breve!',
  'editor.visualTranslation.editSoonText':
    'Tem um pedido específico ou muitos vídeos com texto no ecrã para traduzir? Marque uma demonstração com o nosso especialista para falar sobre o acesso antecipado e um fluxo personalizado!',
  'editor.visualTranslation.talkToSales': 'Falar com a equipa comercial',
  'editor.visualTranslation.downloadOption': 'Vídeo com tradução visual',
  'editor.visualTranslation.downloadTooltip': 'Execute primeiro a tradução visual para o transferir',
  'editor.visualTranslation.notEnoughMinutes': 'Não tem minutos suficientes para executar a tradução visual.',
  'editor.visualTranslation.priceChanged': 'O preço foi atualizado. Verifique-o e inicie novamente.',
  'editor.visualTranslation.queuedTitle': 'Na fila',
  'editor.visualTranslation.queuedNext': 'O seu vídeo é o próximo. Começaremos automaticamente.',
  'editor.visualTranslation.queuedAhead': 'Vídeos à frente do seu na fila: {count}. Começaremos automaticamente.',
  'editor.visualTranslation.preparingTitle': 'A preparar o seu vídeo',
  'editor.visualTranslation.workingTitle': 'A traduzir o texto no ecrã',
  'editor.visualTranslation.polishingTitle': 'O agente está a melhorar o rascunho',
  'editor.visualTranslation.finalizingTitle': 'Verificação final e envio',
  'editor.visualTranslation.minutesLeft': 'Faltam cerca de {minutes} min',
  'editor.visualTranslation.almostDone': 'Quase pronto: o agente está a terminar',
  'editor.visualTranslation.stepTranslate': 'A analisar o vídeo e a traduzir o texto',
  'editor.visualTranslation.stepPolish': 'A melhorar e a verificar o rascunho',
  'editor.visualTranslation.activityNow': 'Atividade atual',
  'editor.visualTranslation.justNow': 'agora mesmo',
  'editor.visualTranslation.minutesAgo': 'há {minutes} min',
  'editor.visualTranslation.historyShow': 'Etapas anteriores ({count})',
  'editor.visualTranslation.historyHide': 'Ocultar etapas anteriores',
  'editor.visualTranslation.keepEditing': 'Pode continuar a editar enquanto o agente trabalha.',
  'editor.visualTranslation.draftBadge': 'Rascunho {number}',
  'editor.visualTranslation.draftImproving': 'O agente ainda está a melhorar este vídeo',
  'editor.visualTranslation.downloadDraft': 'Transferir rascunho',
  'editor.visualTranslation.draftDownloadOption': 'Vídeo com tradução visual — rascunho {number}',
  'editor.visualTranslation.draftDownloadTooltip': 'Um rascunho em 720p: o vídeo final terá a qualidade total',
  'editor.visualTranslation.lastDraftTitle': 'Não conseguimos concluir este vídeo',
  'editor.visualTranslation.lastDraftText': 'Aqui está o último rascunho do agente: pode vê-lo e transferi-lo.',
  'editor.visualTranslation.paywall.badgeBusiness': 'INCLUÍDO NO PLANO BUSINESS',
  'editor.visualTranslation.paywall.badgeAddOn': 'DISPONÍVEL COMO EXTRA PAGO',
  'editor.visualTranslation.paywall.title': 'Traduza o texto do seu vídeo',
  'editor.visualTranslation.paywall.description':
    'O Rask encontra títulos, diapositivos e rótulos no seu vídeo e traduz-os, para que o público consiga ler tudo o que aparece no ecrã.',
  'editor.visualTranslation.paywall.bulletLanguage':
    'Títulos, diapositivos e rótulos aparecem no idioma do seu público',
  'editor.visualTranslation.paywall.bulletDubbing': 'Coerente com a sua dobragem e o seu dicionário de tradução',
  'editor.visualTranslation.paywall.bulletDownload': 'Um único vídeo com áudio e texto traduzidos, pronto a transferir',
  'editor.visualTranslation.paywall.strip': 'Para vídeos educativos e de produto com texto no ecrã.',
  'editor.visualTranslation.paywall.demoTitle': 'Como funciona',
  'editor.visualTranslation.paywall.demoUpload': 'Carregue o seu vídeo',
  'editor.visualTranslation.paywall.demoLanguage': 'Escolha um idioma',
  'editor.visualTranslation.paywall.demoDownload': 'Transfira o resultado',
  'editor.visualTranslation.downloadLockedBusiness': 'Disponível no plano Business',
  'editor.visualTranslation.downloadLockedAddOn': 'Disponível como extra pago',
  'header.myProfile': 'O meu perfil',
  'header.profileAndApi': 'Perfil e API',
  'home.contactSales': 'Contactar a equipa comercial',
  'home.newFolder': 'Nova pasta',
  'home.pricingBanner.choosePlan': 'Escolha o seu plano',
  'home.projects': 'Projetos',
  'home.refreshPage': 'Atualizar página',
  'home.searchVideos': 'Pesquisar nos seus vídeos',
  'home.somethingWentWrong': 'Ocorreu um erro',
  'home.translateVideoAndAudio': 'Traduzir vídeo e áudio',
  'home.trial.day': 'Dia {currentDay} de {totalDays}',
  'home.trialBanner.activeDescriptionDesktop':
    'Obtenha acesso total para traduzir mais vídeos sem limites e utilizar todas as ferramentas da plataforma',
  'home.trialBanner.activeDescriptionMobile': 'Obtenha acesso total para traduzir mais vídeos sem limites',
  'home.trialBanner.activeTitle': 'O seu período experimental de 3 dias termina em breve',
  'home.trialBanner.endedDescription': 'Os preços vão aumentar em breve! Subscreva hoje e obtenha:',
  'home.trialBanner.endedTitle': 'O período experimental terminou. Subscreva agora com 35% de desconto',
  'home.trialBanner.featureEditor': 'Redobragem ilimitada com um editor avançado',
  'home.trialBanner.featureMoreDesktop': 'Sincronização labial, Espaços de equipa, Legendas e muito mais...',
  'home.trialBanner.featureMoreMobile': 'Sincronização labial, Espaços de equipa e muito mais...',
  'home.trialBanner.featureTranslation': 'Tradução automática de alta qualidade em mais de 135 idiomas',
  'home.trialBanner.featureVoice': 'Clonagem de voz em 32 idiomas',
  'home.trialBanner.getFullAccess': 'Obter acesso total',
  'home.trialBanner.timer.days': 'DIAS',
  'home.trialBanner.timer.hours': 'H',
  'home.trialBanner.timer.minutes': 'MIN',
  'home.trialBanner.timer.seconds': 'S',
  'home.tryRefresh': 'Atualize a página, por favor',
  'homeHub.announcement.description':
    'Encontre os seus projetos mais recentes e comece algo novo, tudo a partir do Início.',
  'homeHub.announcement.dismiss': 'Fechar',
  'homeHub.announcement.title': 'Conheça a página Início e a opção Gravar vídeo!',
  'homeHub.menu.delete': 'Eliminar',
  'homeHub.menu.download': 'Transferir vídeo',
  'homeHub.menu.move': 'Mover projeto',
  'homeHub.menu.rename': 'Mudar o nome',
  'homeHub.minutes.limitReached': 'Limite atingido',
  'homeHub.minutes.plan': 'Plano',
  'homeHub.minutes.planTrial': 'Período experimental',
  'homeHub.minutes.recordingAvailable': 'Vídeos disponíveis para gravação: {videos}',
  'homeHub.minutes.translation': 'Tradução',
  'homeHub.minutes.translationAvailable': 'Vídeos disponíveis para tradução: {videos}',
  'homeHub.minutes.upgrade': 'Atualizar plano',
  'homeHub.pageTitle': 'Início',
  'homeHub.recent.gridView': 'Vista em grelha',
  'homeHub.recent.listView': 'Vista em lista',
  'homeHub.recent.loadError': 'Não foi possível carregar os seus projetos recentes.',
  'homeHub.recent.meta': '{type} · {time}',
  'homeHub.recent.moreActions': 'Mais ações para {name}',
  'homeHub.recent.noResults': 'Nenhum projeto corresponde à sua pesquisa',
  'homeHub.recent.restoringFiles':
    'Está tudo seguro. O seu projeto está temporariamente indisponível e ficará pronto daqui a 3–4 horas.',
  'homeHub.recent.retry': 'Tentar novamente',
  'homeHub.recent.search': 'Pesquisar',
  'homeHub.recent.title': 'Recentes',
  'homeHub.recent.translate': 'Traduzir',
  'homeHub.recent.translateItem': 'Traduzir {name}',
  'homeHub.recent.type.recording': 'Gravação de ecrã',
  'homeHub.recent.type.translation': 'Tradução',
  'homeHub.record.description': 'Grave o seu ecrã e a IA transforma a gravação numa demonstração profissional.',
  'homeHub.record.title': 'Gravar vídeo',
  'homeHub.title': 'Em que pretende trabalhar hoje?',
  'homeHub.translate.description': 'Dobragem, legendas e sincronização labial em mais de 135 idiomas.',
  'homeHub.translate.title': 'Traduzir vídeo',
  'homeHub.trial.activeDescription':
    'Experimente o Rask no seu próprio vídeo: faça a dobragem, a locução e a localização, ou grave um novo vídeo do ecrã.',
  'homeHub.trial.badge': 'Período experimental de {count} dias',
  'homeHub.trial.endedBadge': 'Período experimental terminado',
  'homeHub.trial.endedDescription': 'Atualize o plano para continuar a localizar e a gravar vídeos no Rask.',
  'homeHub.trial.upgradeNow': 'Atualizar plano agora',
  'homeHub.onscreen.addOn': 'Complemento',
  'homeHub.onscreen.description': 'Detete e traduza o texto que aparece no seu vídeo.',
  'homeHub.onscreen.title': 'Traduzir texto no ecrã',
  'homeHub.onscreen.upgrade': 'Atualizar plano',
  'language.english': 'Inglês',
  'language.french': 'Francês',
  'language.italian': 'Italiano',
  'language.label': 'Idioma da interface',
  'language.portuguese': 'Português (Brasil)',
  'language.portuguesePortugal': 'Português (Portugal)',
  'language.russian': 'Russo',
  'language.spanish': 'Espanhol',
  'pricing.actions.contactUs': 'Contacte-nos',
  'pricing.actions.downgrade': 'Mudar para um plano inferior',
  'pricing.actions.getStarted': 'Começar',
  'pricing.actions.renew': 'Renovar',
  'pricing.actions.switchAnnual': 'Mudar para anual',
  'pricing.actions.switchMonthly': 'Mudar para mensal',
  'pricing.actions.upgrade': 'Mudar para um plano superior',
  'pricing.archived.description': 'Está atualmente num plano {plan} arquivado, com {count} min incluídos.',
  'pricing.archived.hint': 'Continue a utilizá-lo ou mude para o novo plano.',
  'pricing.billing.annual': 'Anual',
  'pricing.billing.aria': 'Período de faturação',
  'pricing.billing.billAnnual': 'Faturação anual',
  'pricing.billing.billedAnnually': 'Faturação anual',
  'pricing.billing.monthly': 'Mensal',
  'pricing.billing.payAnnual': 'Pagar anualmente',
  'pricing.booster.addForMonth': 'Adicionar por {price} por mês',
  'pricing.buyMinutes.benefitRemain':
    'Os minutos não utilizados permanecerão na sua conta, mesmo que pause a subscrição',
  'pricing.buyMinutes.benefitRollOver': 'Transferiremos os minutos não utilizados para o mês seguinte',
  'pricing.buyMinutes.checkout': 'Finalizar compra',
  'pricing.buyMinutes.minutes': 'Minutos',
  'pricing.buyMinutes.newPricingDescription':
    'Conheça os nossos novos preços, com pacotes de minutos flexíveis e novas funcionalidades!',
  'pricing.buyMinutes.newPricingTitle': 'Acabámos de lançar novos preços!',
  'pricing.buyMinutes.payLess': 'Pagar menos',
  'pricing.buyMinutes.payOnly': 'Pague apenas {price} por minuto!',
  'pricing.buyMinutes.perMinute': '{price}/min',
  'pricing.buyMinutes.price': 'Preço',
  'pricing.buyMinutes.title': 'Comprar minutos adicionais',
  'pricing.buyMinutes.upgradeDescription': 'Faça upgrade ao seu plano e pague menos pelos minutos adicionais',
  'pricing.cancelDowngrade.button': 'Cancelar mudança para plano inferior',
  'pricing.cancelDowngrade.currentDescription':
    'Tem atualmente o plano {plan}, por {price}, com faturação {interval}, ativo até {date}.',
  'pricing.cancelDowngrade.currentTitle': 'Plano atual',
  'pricing.cancelDowngrade.hint': 'Pode voltar a agendar a mudança quando quiser.',
  'pricing.cancelDowngrade.scheduledDescription':
    'Está agendada a mudança para o plano {plan}, por {price}, com faturação {interval}, a partir de {date}. Se cancelar esta alteração, a sua subscrição atual do plano {currentPlan} continuará ativa.',
  'pricing.cancelDowngrade.scheduledTitle': 'Plano agendado',
  'pricing.cancelDowngrade.success': 'Alteração da subscrição cancelada. O seu plano {plan} continuará ativo.',
  'pricing.change.activeUntil': 'O seu plano atual permanece ativo até {date}.',
  'pricing.change.boosterDescription':
    'O carregamento e a transferência de ficheiros SRT estão agora incluídos no seu plano, sem custos adicionais. Este Booster será removido automaticamente.',
  'pricing.change.boosterIncluded': 'Booster incluído!',
  'pricing.change.changeSuccess': 'A alteração ao seu plano foi processada',
  'pricing.change.current': 'Plano atual',
  'pricing.change.currentDescription': 'Tem atualmente o plano {plan}, com faturação {interval}, ativo até {date}.',
  'pricing.change.currentTrialDescription': 'O seu período experimental termina em {date}.',
  'pricing.change.downgradeDescription':
    'Está a mudar para o plano {plan}, com faturação {interval}. A alteração entrará em vigor no fim do período de faturação atual.',
  'pricing.change.downgradeError': 'Não foi possível mudar para um plano inferior:',
  'pricing.change.downgradeSuccess': 'A mudança para um plano inferior foi agendada',
  'pricing.change.featuresLost': 'Funcionalidades que perde',
  'pricing.change.monthly': 'mensal',
  'pricing.change.new': 'Novo plano',
  'pricing.change.scheduleDowngrade': 'Agendar mudança de plano',
  'pricing.change.switchBack': 'Pode voltar ao seu plano anterior a partir de {date}.',
  'pricing.change.trialUpgradeDescription':
    'O seu período experimental termina agora e o plano {plan}, com faturação {interval}, começa hoje. Será cobrado hoje o preço total e receberá {count} min.',
  'pricing.change.upgradeDescription':
    'Vai mudar para o plano {plan}, com faturação {interval}. Terá acesso imediato a novas funcionalidades e a mais {count} min (a diferença entre os planos).',
  'pricing.change.upgradeError': 'Não foi possível atualizar o plano:',
  'pricing.change.upgradeNow': 'Atualizar agora',
  'pricing.change.upgradePaidSuccess': 'Pagamento processado com sucesso e subscrição atualizada',
  'pricing.change.upgradeSuccess': 'O seu plano foi atualizado',
  'pricing.change.yearly': 'anual',
  'pricing.compare.credits': 'Créditos e gerações',
  'pricing.compare.editor': 'Editor',
  'pricing.compare.extraMinutes': 'Minutos extra',
  'pricing.compare.minutesIncluded': 'Minutos incluídos',
  'pricing.compare.plans': 'Comparar planos',
  'pricing.compare.row.api': 'API e integrações',
  'pricing.compare.row.apiDescription':
    'Ligue o Rask às ferramentas que já utiliza e automatize o seu fluxo de trabalho.',
  'pricing.compare.row.autoCut': 'Corte automático com IA',
  'pricing.compare.row.autoCutDescription': 'Remova automaticamente palavras de hesitação e silêncios das gravações.',
  'pricing.compare.row.autoZoom': 'Zoom automático',
  'pricing.compare.row.autoZoomDescription': 'Faça zoom automaticamente na ação enquanto grava.',
  'pricing.compare.row.controls': 'Controlos de guião, legendas e voz',
  'pricing.compare.row.controlsDescription':
    'Edite diretamente a transcrição, os códigos de tempo, as etiquetas dos oradores e as definições de voz.',
  'pricing.compare.row.extraDescription': 'Pode comprar minutos adicionais a qualquer momento nos planos anuais.',
  'pricing.compare.row.glossary': 'Glossário e terminologia',
  'pricing.compare.row.glossaryDescription':
    'Guarde termos personalizados para que as mesmas palavras sejam sempre traduzidas de forma consistente.',
  'pricing.compare.row.lipSync': 'Sincronização labial com vários oradores',
  'pricing.compare.row.lipSyncDescription':
    'Sincroniza os movimentos da boca com o áudio traduzido para uma dobragem mais natural.',
  'pricing.compare.row.minutes': 'Minutos de localização incluídos por ano',
  'pricing.compare.row.minutesDescription':
    'Os minutos anuais disponíveis para tradução ou dobragem. Os planos Business anuais disponibilizam todos os minutos desde o início.',
  'pricing.compare.row.minutesTitle': 'Minutos de localização incluídos por ano',
  'pricing.compare.row.multiLanguage': 'Fluxo de trabalho multilingue',
  'pricing.compare.row.multiLanguageDescription': 'Traduza um único vídeo para vários idiomas num só projeto.',
  'pricing.compare.badge.new': 'Nova',
  'pricing.compare.row.onscreen': 'Tradução do texto no ecrã',
  'pricing.compare.row.onscreenDescription':
    'Traduza o texto presente na imagem do vídeo: diapositivos, legendas, gráficos e muito mais.',
  'pricing.compare.row.prompting': 'Instruções de tradução',
  'pricing.compare.row.promptingDescription':
    'Adicione instruções antes da tradução para definir o contexto: tom, formalidade e escolha de palavras.',
  'pricing.compare.row.review': 'Fluxo de revisão',
  'pricing.compare.row.reviewDescription':
    'Envie o conteúdo traduzido aos revisores para aprovação antes da publicação.',
  'pricing.compare.row.screenRecorder': 'Gravador de ecrã com IA',
  'pricing.compare.row.screenRecorderDescription': 'Grave o seu ecrã e a sua câmara diretamente no Rask.',
  'pricing.compare.row.security': 'Segurança e aprovisionamento',
  'pricing.compare.row.securityDescription': 'Suporte para contratos, faturação e documentação de conformidade.',
  'pricing.compare.row.speed': 'Velocidade de processamento',
  'pricing.compare.row.speedDescription': 'A rapidez com que os seus vídeos são processados e renderizados.',
  'pricing.compare.row.srt': 'Importação/exportação de SRT',
  'pricing.compare.row.srtDescription':
    'Transfira ficheiros de legendas ou carregue os seus próprios ficheiros para os sincronizar com a dobragem.',
  'pricing.compare.row.srtTitle': 'Importação / exportação de SRT',
  'pricing.compare.row.team': 'Espaço de trabalho da equipa',
  'pricing.compare.row.teamDescription': 'Convide membros da equipa para colaborar em projetos num espaço partilhado.',
  'pricing.compare.row.voices': 'Vozes personalizadas guardadas',
  'pricing.compare.row.voicesDescription': 'Guarde vozes clonadas para as reutilizar em projetos futuros.',
  'pricing.compare.showAll': 'Ver todas as funcionalidades',
  'pricing.compare.showLess': 'Mostrar menos',
  'pricing.compare.subtitle': 'Escolha o plano adequado à sua frequência de publicação.',
  'pricing.compare.support': 'Apoio e trabalho em equipa',
  'pricing.compare.title': 'Compare o que muda à medida que cresce',
  'pricing.compare.value.compliance': 'SSO, DPA e revisão de conformidade',
  'pricing.compare.value.customBatch': 'Pipelines de processamento em lote personalizados',
  'pricing.compare.value.customIntegrations': 'Integrações personalizadas',
  'pricing.compare.value.customRoles': 'Funções personalizadas',
  'pricing.compare.value.dedicated': 'Dedicado / prioritário',
  'pricing.compare.value.extraMinute': '3 $ por minuto extra',
  'pricing.compare.value.fiveMembers': 'Até 5 membros + revisores convidados',
  'pricing.compare.value.fullApi': 'Acesso total à API',
  'pricing.compare.value.included': 'Incluído',
  'pricing.compare.value.addOn': 'Opção paga',
  'pricing.compare.value.managedQa': 'Controlo de qualidade gerido / aprovação por especialista',
  'pricing.compare.value.managedTerms': 'Fluxo de terminologia gerido',
  'pricing.compare.value.multiBatch': 'Processamento em lote de vários vídeos e idiomas',
  'pricing.compare.value.personalGlossary': 'Glossário pessoal',
  'pricing.compare.value.priorityQueue': 'Fila prioritária',
  'pricing.compare.value.reviewer': 'Funções de revisor e aprovação',
  'pricing.compare.value.sandboxApi': 'Acesso limitado à API sandbox',
  'pricing.compare.value.sharedGlossary': 'Glossário de marca partilhado',
  'pricing.compare.value.sharedVoices': '10 vozes partilhadas pela equipa',
  'pricing.compare.value.standard': 'Padrão',
  'pricing.compare.value.standardQueue': 'Fila padrão',
  'pricing.compare.value.three': '3',
  'pricing.compare.value.threeMembers': 'Até 3 membros',
  'pricing.compare.value.unlimited': 'Ilimitado',
  'pricing.compare.value.upgradePro': 'Atualizar para o Pro',
  'pricing.compare.value.voiceLibrary': 'Biblioteca de vozes personalizadas',
  'pricing.compare.whatChanges': 'O que muda',
  'pricing.enterprisePayment.contactSupport': 'Contacte-nos através do chat de apoio ou envie-nos um e-mail para',
  'pricing.enterprisePayment.unknownError': 'Erro desconhecido',
  'pricing.feature.aiRewriter': 'Ajuste do guião com IA',
  'pricing.feature.allBusiness': 'Todas as funcionalidades do Business, mais:',
  'pricing.feature.allCreator': 'Todas as funcionalidades do Creator, mais:',
  'pricing.feature.allCreatorPro': 'Todas as funcionalidades do Creator Pro, mais:',
  'pricing.feature.api': 'API',
  'pricing.feature.applyChanges': 'Aplicar alterações gratuitamente',
  'pricing.feature.businessContract': 'Contrato empresarial e faturação',
  'pricing.feature.captions': 'Legendas automáticas',
  'pricing.feature.customerSuccess': 'Gestor de sucesso do cliente',
  'pricing.feature.dictionary': 'Dicionário de tradução',
  'pricing.feature.editor': 'Editor de vídeo avançado',
  'pricing.feature.flexibleMinutes': 'Preços flexíveis por minutos',
  'pricing.feature.humanReview': 'Revisão humana integrada',
  'pricing.feature.languages': 'Traduções em mais de 135 idiomas',
  'pricing.feature.languagesDescription':
    'A disponibilidade dos idiomas depende da utilização de vozes de IA ou do Voice Clone.',
  'pricing.feature.learnMore': 'Saber mais',
  'pricing.feature.lipSync': 'Lip-sync para vários locutores',
  'pricing.feature.machineTranslation': 'Tradução automática',
  'pricing.feature.multiLanguage': 'Tradução simultânea para vários idiomas',
  'pricing.feature.noWatermark': 'Sem marca de água',
  'pricing.feature.onlyVideoDownload': 'Apenas transferência de vídeo',
  'pricing.feature.priority': 'Processamento prioritário',
  'pricing.feature.prompting': 'Instruções de tradução',
  'pricing.feature.readDocs': 'Consultar a documentação',
  'pricing.feature.speechToText': 'Transcrição automática de voz para texto',
  'pricing.feature.srtDownload': 'Transferência de SRT',
  'pricing.feature.srtDownloadUpload': 'Transferência e carregamento de SRT',
  'pricing.feature.srtUpload': 'Carregamento de SRT',
  'pricing.feature.support': 'Suporte 24/7',
  'pricing.feature.teamspace3': '1 Teamspace, 3 membros',
  'pricing.feature.teamspace5': '1 Teamspace, 5 membros',
  'pricing.feature.teamspaces': 'Teamspaces',
  'pricing.feature.voiceClones10': '10 clones de voz personalizados',
  'pricing.feature.voiceClones3': '3 clones de voz personalizados',
  'pricing.feature.voiceCloning': 'Clonagem de voz em 32 idiomas',
  'pricing.feature.voiceCloningDescription':
    'Disponível em 32 idiomas, incluindo inglês, espanhol, francês, italiano, português e russo.',
  'pricing.feature.voiceLibrary': 'Biblioteca do Voice Clone',
  'pricing.feature.voiceSettings': 'Definições do Voice Clone',
  'pricing.feature.watermark': 'Marca de água',
  'pricing.header.description':
    'Todos os planos incluem tradução de vídeo para qualquer idioma, clonagem de voz com preservação das emoções e controlos gratuitos e fáceis de utilizar.',
  'pricing.header.title': 'Planos que acompanham o seu volume de vídeos',
  'pricing.trialPaywallExperiment.description':
    'Todos os planos incluem tradução para qualquer idioma e clonagem de voz com preservação das emoções.',
  'pricing.legacy.businessFeature1': 'Garanta a consistência da voz da marca',
  'pricing.legacy.businessFeature2': 'Controle a terminologia das traduções',
  'pricing.legacy.businessFeature3': 'Processe grandes volumes de conteúdos mais depressa do que nunca',
  'pricing.legacy.creatorFeature1': 'Dobre em mais de 135 idiomas com IA',
  'pricing.legacy.creatorFeature2': 'Clone vozes em 32 idiomas',
  'pricing.legacy.creatorFeature3': 'Editor avançado de utilização ilimitada',
  'pricing.legacy.creatorFeature4': 'Transcrição e tradução automáticas',
  'pricing.legacy.creatorProFeature1': 'Adicione sincronização labial e legendas',
  'pricing.legacy.creatorProFeature2': 'Utilize ferramentas profissionais de voz e guião',
  'pricing.legacy.creatorProFeature3': 'Colabore num espaço partilhado',
  'pricing.legacy.enterpriseFeature1': 'Obtenha contratos e faturação personalizados',
  'pricing.legacy.enterpriseFeature2': 'Aceda a apoio prioritário dedicado',
  'pricing.legacy.enterpriseFeature3': 'Adapte tudo às suas necessidades',
  'pricing.legacy.everythingBusiness': 'Tudo o que está incluído no Business, mais:',
  'pricing.legacy.everythingCreator': 'Tudo o que está incluído no Creator, mais:',
  'pricing.legacy.everythingCreatorPro': 'Tudo o que está incluído no Creator Pro, mais:',
  'pricing.limits.enterprise.contactOrSelectPlan':
    'Contacte a nossa especialista em parcerias através do e-mail {email} ou escolha um dos nossos planos de preços.',
  'pricing.limits.enterprise.notEnoughMinutes': 'Não tem minutos suficientes para traduzir este vídeo.',
  'pricing.limits.enterprise.notEnoughMinutesShort': 'Não há minutos suficientes para traduzir este vídeo.',
  'pricing.limits.enterprise.purchaseMore':
    'Contacte a nossa especialista em parcerias para comprar mais minutos: {email}',
  'pricing.limits.enterprise.ranOut': 'O seu plano ficou sem minutos.',
  'pricing.limits.enterprise.renewAccess':
    'Contacte a nossa especialista em parcerias através do e-mail {email} para renovar o seu acesso.',
  'pricing.limits.enterprise.renewOrSelectPlan':
    'Contacte a nossa especialista em parcerias através do e-mail {email} para renovar o seu acesso ou escolha um dos nossos planos de preços.',
  'pricing.limits.exploreFullVersion': 'Explore a versão completa com funcionalidades avançadas',
  'pricing.limits.feature.lipSyncBeta': 'Aplicar a funcionalidade Lip-sync (beta)',
  'pricing.limits.feature.noTrialLimits': 'Carregar ficheiros sem os limites da avaliação gratuita',
  'pricing.limits.feature.proofread': 'Rever o texto antes da dobragem',
  'pricing.limits.feature.srtUpload': 'Carregar um ficheiro SRT com o vídeo',
  'pricing.limits.feature.translation130': 'Traduzir para mais de 135 idiomas',
  'pricing.limits.feature.voiceClone28': 'Utilizar o Voice Clone em 32 idiomas',
  'pricing.limits.freeVideoLimit': 'Atingiu o limite de vídeos gratuitos.',
  'pricing.limits.notEnoughMinutes': 'Não há minutos disponíveis suficientes para traduzir o vídeo.',
  'pricing.limits.paymentFailed':
    'Não foi possível processar o pagamento para renovar a sua subscrição. Atualize os dados de pagamento para continuar a utilizar o Rask.',
  'pricing.limits.renewSubscription': 'Renovar subscrição',
  'pricing.limits.spaceUnsupported':
    'O seu plano atual não é compatível com este espaço. Mude para um plano superior para continuar a utilizá-lo.',
  'pricing.limits.subscriptionCanceled': 'A sua subscrição foi cancelada.',
  'pricing.limits.subscriptionCanceledDescription':
    'Congelámos os minutos da sua conta. Renove a subscrição para continuar a utilizar o Rask e os seus minutos.',
  'pricing.limits.subscriptionExpired': 'A sua subscrição expirou. Renove-a para continuar a utilizar o Rask.',
  'pricing.limits.subscriptionPaused':
    'A sua subscrição está em pausa. Congelámos os minutos da sua conta. Renove-a para continuar a utilizar o Rask e os seus minutos.',
  'pricing.limits.translationMinuteLimit': 'Atingiu o limite de minutos de tradução.',
  'pricing.limits.unlockFullVersion': 'Desbloquear versão completa',
  'pricing.limits.updatePayment': 'Atualizar dados de pagamento',
  'pricing.limits.upgradeForMoreVideos': 'Mude para um plano superior para traduzir mais vídeos',
  'pricing.limits.upgradeForMoreVideosTitle': 'Mude para um plano superior para traduzir mais vídeos:',
  'pricing.limits.upgradePlanForMoreVideos': 'Mude para um plano superior para traduzir mais vídeos',
  'pricing.limits.upgradeToContinue': 'Mude para um plano superior para continuar a gerar conteúdo.',
  'pricing.limits.whiteLabelInactive':
    'A sua subscrição já não está ativa. Contacte {email} para obter assistência adicional.',
  'pricing.limits.whiteLabelOutOfMinutes': 'Não tem minutos suficientes. Recarregue o seu saldo de minutos.',
  'pricing.minutes.custom': 'Minutos personalizados',
  'pricing.minutes.from': 'a partir de {count} minutos',
  'pricing.minutes.fromMonthly': 'A partir de {count} minutos/mês',
  'pricing.minutes.included': '{count} minutos incluídos',
  'pricing.modal.closeAria': 'Fechar',
  'pricing.notActive.checkBoosters': 'Ver outros Boosters',
  'pricing.notActive.closeAria': 'Fechar oferta de convite à equipa',
  'pricing.notActive.paidDescription':
    'Adicione mais membros à sua subscrição e colabore sem esforço no espaço partilhado!',
  'pricing.notActive.title': 'Juntos somos melhores. Convide a sua equipa!',
  'pricing.notActive.trialDescription':
    'Crie espaços de trabalho dedicados, convide colaboradores e gira projetos em conjunto com os Teamspaces.',
  'pricing.notActive.trialPaywallTitle': 'Liberte o potencial da sua equipa',
  'pricing.notActive.unlockTeamspaces': 'Desbloqueie os Teamspaces com o Creator Pro',
  'pricing.pause.chargeDescription': 'Data da cobrança: {date}. Será cobrado o preço original {interval} de {price}.',
  'pricing.pause.description':
    'A reativação está agendada para {date}. Os dados da sua conta serão mantidos em segurança até a sua subscrição ser retomada.',
  'pricing.pause.nextBillingDate': 'a sua próxima data de faturação',
  'pricing.pause.resumeNow': 'Retomar a subscrição agora',
  'pricing.pause.resumeTitle': 'Quer retomar a subscrição?',
  'pricing.pause.success': 'Subscrição retomada.\nA cobrança será efetuada na próxima data de renovação da subscrição.',
  'pricing.pause.title': 'A sua subscrição está em pausa',
  'pricing.paywall.enterpriseQuestion': 'Traduz mais de 1 000 minutos por mês?',
  'pricing.paywall.feature.api': 'Acesso à API',
  'pricing.paywall.feature.customVoiceClone': 'Personalize a clonagem de voz e guarde-a na sua biblioteca',
  'pricing.paywall.feature.dictionary': 'Guarde traduções personalizadas no Dicionário',
  'pricing.paywall.feature.lipSync': 'Aplicar sincronização labial',
  'pricing.paywall.feature.srtDownload': 'Transferir um ficheiro de legendas SRT',
  'pricing.paywall.feature.srtUpload': 'Carregar um ficheiro SRT com o seu vídeo',
  'pricing.paywall.feature.subtitles': 'Adicionar legendas ao seu vídeo',
  'pricing.paywall.feature.teamspacesSoon': 'Criar Teamspaces e colaborar com a sua equipa',
  'pricing.paywall.feature.translation130': 'Traduzir o seu vídeo e áudio para mais de 135 línguas',
  'pricing.paywall.feature.voiceClone29': 'Clonagem de voz em 32 línguas',
  'pricing.paywall.queueTitle': 'A fila para utilizadores gratuitos está sobrecarregada neste momento',
  'pricing.paywall.requestEnterpriseDemo': 'Pedir demonstração empresarial',
  'pricing.paywall.upgradeTitle': 'Passe para um plano pago para ter acesso completo!',
  'pricing.paywall.viewPlans': 'Ver planos',
  'pricing.plan.bestForBeginners': 'Ideal para principiantes',
  'pricing.plan.bestForIndividuals': 'Ideal para particulares',
  'pricing.plan.bestValue': 'Melhor relação qualidade-preço',
  'pricing.plan.business': 'Business',
  'pricing.plan.businessDescription': 'Para equipas com uma videoteca em crescimento',
  'pricing.plan.businessFeature1': 'Reveja e gira projetos com a sua equipa',
  'pricing.plan.businessFeature2': 'Mantenha a marca e a terminologia consistentes',
  'pricing.plan.businessFeature3': 'Carregue e traduza lotes de vídeos',
  'pricing.plan.creator': 'Creator',
  'pricing.plan.creatorDescription': 'Para criadores que trabalham em projetos mais pequenos',
  'pricing.plan.creatorFeature1': 'Comece sem qualquer configuração',
  'pricing.plan.creatorFeature2': 'Traduza um único vídeo para alguns idiomas',
  'pricing.plan.creatorFeature3': 'Faça upgrade quando localizar conteúdos regularmente',
  'pricing.plan.creatorPro': 'Creator Pro',
  'pricing.plan.creatorProDescription': 'Para criadores que publicam vídeos regularmente',
  'pricing.plan.creatorProFeature1': 'Controle a precisão da tradução e da fala',
  'pricing.plan.creatorProFeature2': 'Preserve a identidade do orador com sincronização labial',
  'pricing.plan.creatorProFeature3': 'Concebido para projetos recorrentes com uma equipa pequena',
  'pricing.plan.current': 'Plano atual',
  'pricing.plan.currentOutsideGrid': 'O seu plano atual: {plan}, {price}',
  'pricing.plan.currentShort': 'Atual',
  'pricing.plan.enterprise': 'Enterprise',
  'pricing.plan.enterpriseDescription': 'Para operações globais que exigem confiança e previsibilidade',
  'pricing.plan.enterpriseFeature1': 'Preparação para segurança e conformidade',
  'pricing.plan.enterpriseFeature2': 'Fiabilidade em produção e SLA',
  'pricing.plan.enterpriseFeature3': 'Integrações personalizadas e acesso à API',
  'pricing.plan.enterpriseFeature4': 'Garantia de qualidade gerida',
  'pricing.plan.limitedOffer': 'Oferta por tempo limitado',
  'pricing.plan.mostPopular': 'Mais popular',
  'pricing.plan.starter': 'Starter',
  'pricing.plan.starterDescription': 'Para começar a localizar vídeos de forma simples',
  'pricing.plan.tailoredOnboarding': 'Integração personalizada e SLA',
  'pricing.plan.toggleDetails': 'Mostrar/ocultar detalhes do plano',
  'pricing.plan.unlimitedRecording': 'Gravação de ecrã ilimitada',
  'pricing.plan.onscreenTranslation': 'Traduza o texto no ecrã dos seus vídeos',
  'pricing.price.billedMonthly': 'faturado mensalmente',
  'pricing.price.billedYearly': '{amount} faturados anualmente',
  'pricing.price.custom': 'Personalizado',
  'pricing.price.from': 'a partir de',
  'pricing.price.perMonth': '/mês',
  'pricing.price.perMonthLong': 'por mês',
  'pricing.renew.happy': 'Estamos felizes por estar novamente connosco!',
  'pricing.renew.welcome': 'Bem-vindo de volta!',
  'pricing.savings.year': 'Poupe {amount}/ano ({percent}% de desconto)',
  'pricing.socialProof': 'Mais de {count} utilizadores satisfeitos',
  'pricing.starter.allCreator': 'Todas as funcionalidades do plano Creator',
  'pricing.starter.currentTitle': 'Plano {plan}: {price} por mês',
  'pricing.starter.minuteDescription':
    '1 minuto = 1 minuto de conteúdo traduzido. Por exemplo, traduzir um vídeo de 1 minuto para duas línguas consome 2 minutos.',
  'pricing.starter.minuteTitle': 'A que corresponde um minuto?',
  'pricing.starter.tryTitle': 'Experimente por {price} por mês com o plano {plan}',
  'pricing.starter.watermarkDescription':
    'O vídeo terá a marca de água “Translated by Rask AI” no canto superior direito.',
  'pricing.title': 'Preços',
  'pricing.trial.continue': 'Continuar com o período experimental gratuito',
  'pricing.upgrade.aiRewrite.unlockAiRewriteFeature': 'Desbloqueie a reescrita com IA',
  'pricing.upgrade.aiRewrite.upgradeToCreatorProPlanForSpeedControl':
    'Mude para o plano Creator Pro para controlar a velocidade e alinhar segmentos com IA de acordo com os seus códigos de tempo',
  'pricing.upgrade.audioDownload.unlockAudioDownload': 'Desbloqueie a transferência de áudio',
  'pricing.upgrade.audioDownload.upgradeToCreatorToDownloadAudioWithGenerated':
    'Mude para o Creator para transferir áudio com a voz gerada ou com voz e som de fundo',
  'pricing.upgrade.bullets.1TeamSpaceWithUpTo10Members': '1 Teamspace com até 10 membros',
  'pricing.upgrade.bullets.1TeamSpaceWithUpTo5Members': '1 Teamspace com até 5 membros',
  'pricing.upgrade.bullets.aiScriptAdjustment': 'Ajuste do guião com IA',
  'pricing.upgrade.bullets.apiAccess': 'Acesso à API',
  'pricing.upgrade.bullets.automatedCaptionsSubtitles': 'Legendas automáticas',
  'pricing.upgrade.bullets.businessContractAndInvoicing': 'Contrato empresarial e faturação',
  'pricing.upgrade.bullets.customPriceForMinutes': 'Preço personalizado por minutos',
  'pricing.upgrade.bullets.customVoiceCloneLibrary': 'Biblioteca personalizada do Voice Clone',
  'pricing.upgrade.bullets.customVoiceCloneLibrary10CustomVoices':
    'Biblioteca personalizada do Voice Clone (10 vozes personalizadas)',
  'pricing.upgrade.bullets.downloadGeneratedVoice': 'Transferir voz gerada',
  'pricing.upgrade.bullets.downloadGeneratedVoiceWithBackgroundSound': 'Transferir voz gerada com som de fundo',
  'pricing.upgrade.bullets.from100MinutesEveryMonth': 'A partir de 100 minutos por mês',
  'pricing.upgrade.bullets.from2000MinutesEveryMonth': 'A partir de 2000 minutos por mês',
  'pricing.upgrade.bullets.from25MinutesEveryMonth': 'A partir de 25 minutos por mês',
  'pricing.upgrade.bullets.from500MinutesEveryMonth': 'A partir de 500 minutos por mês',
  'pricing.upgrade.bullets.humanInTheLoop': 'Revisão humana integrada',
  'pricing.upgrade.bullets.multispeakerLipSync': 'Lip-sync para vários locutores',
  'pricing.upgrade.bullets.noWatermark': 'Sem marca de água',
  'pricing.upgrade.bullets.personalCustomerManager': 'Gestor de cliente dedicado',
  'pricing.upgrade.bullets.simultaneousMultiLanguageTranslation': 'Tradução simultânea para vários idiomas',
  'pricing.upgrade.bullets.srtTranscriptUploadAndSrtDownload':
    'Carregamento de transcrições SRT e transferência de SRT',
  'pricing.upgrade.bullets.translationDictionaries': 'Dicionários de tradução',
  'pricing.upgrade.bullets.translationPrompting': 'Instruções de tradução',
  'pricing.upgrade.bullets.unlimitedTeamspacesAndMembers': 'Teamspaces e membros ilimitados',
  'pricing.upgrade.bullets.upToUnlimitedCustomVoiceClones': 'Clones de voz personalizados ilimitados',
  'pricing.upgrade.bullets.voiceCloneSettings': 'Definições do Voice Clone',
  'pricing.upgrade.glossary.addAnyTermsWithPreferredTranslationsOrMark':
    'Adicione termos com as traduções preferidas (ou marque-os como não traduzidos)',
  'pricing.upgrade.glossary.applyToAnyProjectWithOneClick': 'Aplique a qualquer projeto com um clique',
  'pricing.upgrade.glossary.createADictionaryForYourLanguagePair': 'Crie um dicionário para o seu par de idiomas',
  'pricing.upgrade.glossary.howItWorks': 'Como funciona',
  'pricing.upgrade.glossary.howToUseDictionaryEffectively': 'sobre como utilizar o dicionário eficazmente',
  'pricing.upgrade.glossary.learnMore': 'Saiba mais',
  'pricing.upgrade.glossary.lockInTranslationsOnceAndTheyLlStay':
    'Defina as traduções uma vez e mantenha-as consistentes em todos os vídeos.',
  'pricing.upgrade.glossary.perfectFor': 'Ideal para',
  'pricing.upgrade.glossary.trustedBy83OfBusinessUsersForTranslation':
    '83% dos utilizadores do Business confiam na precisão das traduções',
  'pricing.upgrade.glossary.unlockTranslationDictionary': 'Desbloqueie o dicionário de tradução',
  'pricing.upgrade.glossary.upgradeToBusiness': 'Mude para o Business',
  'pricing.upgrade.glossary.upgradeToBusinessToCreateTranslationDictionary':
    'Mude para o Business para criar um dicionário de tradução',
  'pricing.upgrade.glossary.videosWithSpecificTerminologyAndProductNamesOr':
    'vídeos com terminologia e nomes de produtos específicos ou bibliotecas de conteúdo multilingue.',
  'pricing.upgrade.lipSync.aboutLipSyncFeature': 'sobre a funcionalidade Lip-sync',
  'pricing.upgrade.lipSync.enhancedModel':
    'Novo modelo Lip-sync melhorado — qualidade de estúdio (deduz {multiplier} minutos por cada minuto de vídeo)',
  'pricing.upgrade.lipSync.everyFaceOnScreenPerfectlyInSync': 'Todos os rostos no ecrã, perfeitamente sincronizados',
  'pricing.upgrade.lipSync.getProfessionalContentWithLipSyncAndOther':
    'Crie conteúdo profissional com Lip-sync e outras ferramentas Pro',
  'pricing.upgrade.lipSync.lipSyncMatchesMouthMovementsToTranslatedAudio':
    'O Lip-sync sincroniza os movimentos da boca com o áudio traduzido, para que o vídeo pareça dobrado naturalmente e não sobreposto.',
  'pricing.upgrade.lipSync.makeDubbedVideosLookNaturalByMatchingMouth':
    'Faça com que os vídeos dobrados pareçam naturais, sincronizando os movimentos da boca com o áudio traduzido. Disponível no Creator Pro e planos superiores.',
  'pricing.upgrade.lipSync.makeDubbedVideosLookReal': 'Faça com que os vídeos dobrados pareçam reais',
  'pricing.upgrade.lipSync.naturalLookingDubbedVideosInAnyLanguage':
    'Vídeos dobrados com aspeto natural em qualquer idioma',
  'pricing.upgrade.lipSync.professionalContentWhereVisualAuthenticityMatters':
    'conteúdo profissional em que a autenticidade visual é importante.',
  'pricing.upgrade.lipSync.publishToAnyMarketWithoutLosingCredibility':
    'Publique em qualquer mercado sem perder credibilidade',
  'pricing.upgrade.lipSync.seePlansWithLipSync': 'Ver planos com Lip-sync',
  'pricing.upgrade.lipSync.synchronizedLipMovementsWithTranslatedAudioForMultiple':
    'Movimentos labiais sincronizados com o áudio traduzido para vários locutores',
  'pricing.upgrade.lipSync.unlockLipSyncFeature': 'Desbloqueie a funcionalidade Lip-sync',
  'pricing.upgrade.lipSync.upgradeToCreatorProPlanToAddLip':
    'Mude para o plano Creator Pro para adicionar Lip-sync aos seus vídeos e obter traduções de excelência',
  'pricing.upgrade.lipSync.withLipSync': 'Com Lip-sync:',
  'pricing.upgrade.lipSync.yourContentFeelsNativeNotDubbedOver':
    'O seu conteúdo parece nativo, não uma dobragem sobreposta',
  'pricing.upgrade.multilanguage.learnMoreCaption':
    '(Saiba mais)[{link}] sobre como utilizar esta funcionalidade eficazmente',
  'pricing.upgrade.multilanguage.unlockMultiLanguageTranslationFeature': 'Desbloqueie a tradução para vários idiomas',
  'pricing.upgrade.multilanguage.yourPlanAllowsTranslationTo1LanguagePer':
    'O seu plano permite traduzir para 1 idioma por carregamento. Mude para um plano superior para traduzir o vídeo para vários idiomas',
  'pricing.upgrade.multilanguage.youVeReachedYourFreeVideosLimitUpgrade':
    'Atingiu o limite de vídeos gratuitos. Mude para o plano Business para traduzir os seus vídeos para vários idiomas',
  'pricing.upgrade.paywallTitles.unlockAudioExportAndMore': 'Desbloqueie a exportação de áudio e muito mais',
  'pricing.upgrade.paywallTitles.unlockDictionaryAndMore': 'Desbloqueie o dicionário e muito mais',
  'pricing.upgrade.paywallTitles.unlockGlossaryAndMore': 'Desbloqueie o glossário e muito mais',
  'pricing.upgrade.paywallTitles.unlockLipSyncAndMore': 'Desbloqueie o Lip-sync e muito mais',
  'pricing.upgrade.paywallTitles.unlockMultiLanguageAndMore': 'Desbloqueie a tradução para vários idiomas e muito mais',
  'pricing.upgrade.paywallTitles.unlockPromptingAndMore': 'Desbloqueie as instruções e muito mais',
  'pricing.upgrade.paywallTitles.unlockSrtExportAndMore': 'Desbloqueie a exportação de SRT e muito mais',
  'pricing.upgrade.paywallTitles.unlockSrtUploadAndMore': 'Desbloqueie o carregamento de SRT e muito mais',
  'pricing.upgrade.paywallTitles.unlockSubtitleExportAndMore': 'Desbloqueie a exportação de legendas e muito mais',
  'pricing.upgrade.paywallTitles.unlockTeamspacesAndMore': 'Desbloqueie Teamspaces e muito mais',
  'pricing.upgrade.paywallTitles.unlockTranslationPromptingAndMore':
    'Desbloqueie as instruções de tradução e muito mais',
  'pricing.upgrade.paywallTitles.unlockUnlimitedLengthAndMore': 'Desbloqueie a duração ilimitada e muito mais',
  'pricing.upgrade.paywallTitles.unlockVideoSubtitlesAndMore': 'Desbloqueie as legendas no vídeo e muito mais',
  'pricing.upgrade.paywallTitles.unlockVoicePresetsAndMore': 'Desbloqueie as predefinições de voz e muito mais',
  'pricing.upgrade.srtDownload.aboutSrtDownload': 'sobre a transferência de SRT',
  'pricing.upgrade.srtDownload.bothOriginalAndTranslatedSubtitleVersionsWithSpeakers':
    'Versões original e traduzida das legendas com identificação dos locutores',
  'pricing.upgrade.srtDownload.creatorsWhoNeedCustomSubtitleVariationsYoutubeUploads':
    'criadores que precisam de versões personalizadas das legendas, carregamentos para o YouTube ou fluxos de edição externos.',
  'pricing.upgrade.srtDownload.getFlexibleSubtitleFilesYouCanEditCustomize':
    'Obtenha ficheiros de legendas flexíveis que pode editar, personalizar e utilizar onde quiser.',
  'pricing.upgrade.srtDownload.getFullControlOverYourSubtitlesWithSrt':
    'Tenha controlo total sobre as suas legendas com SRT e ferramentas Pro',
  'pricing.upgrade.srtDownload.orUpgradeToCreatorPro': 'ou mude para o Creator Pro',
  'pricing.upgrade.srtDownload.plainTextSubtitleFilesWithTimecodesAndSpoken':
    'Ficheiros de legendas em texto simples com códigos de tempo e texto falado',
  'pricing.upgrade.srtDownload.textSegmentsFormattedForVideoPlatformsOrEditing':
    'Segmentos de texto formatados para plataformas de vídeo ou ferramentas de edição',
  'pricing.upgrade.srtDownload.unlockSrtDownload': 'Desbloqueie a transferência de ficheiros .SRT',
  'pricing.upgrade.srtDownload.upgradeToCreatorProPlanToDownloadSrt':
    'Mude para o plano Creator Pro para transferir ficheiros SRT com legendas dos vídeos original e traduzido',
  'pricing.upgrade.srtDownload.whatYouLlGet': 'O que irá obter',
  'pricing.upgrade.srtUpload.downloadSrtSendForCorrectionsUploadUpdatedFile':
    'Transfira o SRT → Envie para correção → Carregue o ficheiro atualizado',
  'pricing.upgrade.srtUpload.howToUseSrtUpload': 'sobre como utilizar o carregamento de SRT',
  'pricing.upgrade.srtUpload.instantlyRefreshTextTimingAndSpeakerInfo':
    'Atualize instantaneamente o texto, a temporização e os dados dos locutores',
  'pricing.upgrade.srtUpload.noManualCopyPaste': 'Sem copiar e colar manualmente',
  'pricing.upgrade.srtUpload.replaceHoursOfManualEditingWithOneClick': 'Substitua horas de edição manual por um clique',
  'pricing.upgrade.srtUpload.teamsWhoEditSubtitlesExternallyAndWantTo':
    'equipas que editam legendas externamente e querem sincronizar rapidamente as alterações.',
  'pricing.upgrade.srtUpload.unlockSrtUpload': 'Desbloqueie o carregamento de SRT',
  'pricing.upgrade.srtUpload.unlockSrtUploadFeature': 'Desbloqueie a funcionalidade de carregamento de SRT',
  'pricing.upgrade.srtUpload.updateSubtitlesInSeconds': 'Atualize as legendas em segundos',
  'pricing.upgrade.srtUpload.upgradeToCreatorPro': 'Mude para o Creator Pro',
  'pricing.upgrade.srtUpload.upgradeToCreatorProPlanToEffortlesslyPair':
    'Mude para o plano Creator Pro para associar facilmente o vídeo a legendas existentes e obter uma dobragem precisa',
  'pricing.upgrade.srtUpload.uploadAnEditedSrtFile': 'Carregue um ficheiro SRT editado',
  'pricing.upgrade.srtUpload.uploadCorrectedTranscriptInOneClick': 'Carregue a transcrição corrigida com um clique.',
  'pricing.upgrade.subtitleExport.anyoneWhoPublishesAcrossPlatformsOrWorksWith':
    'quem publica em várias plataformas ou trabalha em equipa.',
  'pricing.upgrade.subtitleExport.exportTranslatedSubtitlesAsAnSrtFileAlready':
    'Exporte as legendas traduzidas como ficheiro SRT — já temporizadas, já traduzidas e prontas para qualquer fluxo de trabalho.',
  'pricing.upgrade.subtitleExport.getSubtitleExportWithOtherProTools':
    'Obtenha a exportação de legendas e outras ferramentas Pro',
  'pricing.upgrade.subtitleExport.handOffToEditorsOrClientsWithoutExtra':
    'Entregue a editores ou clientes sem passos adicionais',
  'pricing.upgrade.subtitleExport.publishToYoutubeTiktokOrAnyPlatformIn':
    'Publique no YouTube, TikTok ou em qualquer plataforma em poucos minutos',
  'pricing.upgrade.subtitleExport.seePlansWithSubtitleExport': 'Ver planos com exportação de legendas',
  'pricing.upgrade.subtitleExport.takeYourSubtitlesWhereverTheWorkHappens':
    'Leve as suas legendas para onde o trabalho acontece',
  'pricing.upgrade.subtitleExport.timestampsStayPerfectlyAlignedWithYourVideo':
    'Os códigos de tempo mantêm-se perfeitamente alinhados com o vídeo',
  'pricing.upgrade.subtitleExport.withSubtitleExport': 'Com a exportação de legendas:',
  'pricing.upgrade.teamspace.aboutTeamspaceCollaboration': 'sobre a colaboração no Teamspace',
  'pricing.upgrade.teamspace.agenciesAndTeamsManagingMultipleDubbingProjectsWithout':
    'agências e equipas que gerem vários projetos de dobragem sem confusão.',
  'pricing.upgrade.teamspace.collaborateWithYourTeamInOnePlace': 'Colabore com a sua equipa num só lugar.',
  'pricing.upgrade.teamspace.contactUsToFindTheRightNumberOf':
    'Contacte-nos para encontrar o número ideal de Teamspaces e membros para a sua equipa.',
  'pricing.upgrade.teamspace.giveFullFeatureAccessForInviteesWithoutExtra':
    'Dê aos convidados acesso a todas as funcionalidades sem subscrições adicionais',
  'pricing.upgrade.teamspace.inviteTeammatesWithIndividualLoginsNoSharedCredentials':
    'Convide colegas com acessos individuais — sem partilhar credenciais',
  'pricing.upgrade.teamspace.lookingToScaleYourTeam': 'Quer expandir a sua equipa?',
  'pricing.upgrade.teamspace.orContactUs': 'ou contacte-nos',
  'pricing.upgrade.teamspace.orUpgradeToBusiness': 'ou mude para o Business',
  'pricing.upgrade.teamspace.scaleYourTeam': 'Expanda a sua equipa',
  'pricing.upgrade.teamspace.teamsCutProjectCoordinationTimeBy60':
    'As equipas reduzem em 60% o tempo de coordenação dos projetos',
  'pricing.upgrade.teamspace.unlockTeamspaces': 'Desbloqueie Teamspaces',
  'pricing.upgrade.teamspace.upgradeToBusinessForATeamspaceWith5':
    'Mude para o Business para obter um Teamspace com 5 lugares ou adicione os lugares de que precisa.',
  'pricing.upgrade.teamspace.upgradeToCreatorProToHaveTeamspaceWith':
    'Mude para o Creator Pro para obter um Teamspace com até 3 membros',
  'pricing.upgrade.teamspace.upgradeToEnterpriseForCustomTeamspacesAndMember':
    'Mude para o Enterprise para personalizar os Teamspaces e os limites de membros ou adicione os lugares de que precisa.',
  'pricing.upgrade.teamspace.workBetterTogether': 'Trabalhem melhor em conjunto',
  'pricing.upgrade.teamspace.workOnSharedProjectsSeamlesslyNoBackAnd':
    'Trabalhe em projetos partilhados sem complicações — sem transferências constantes de ficheiros',
  'pricing.upgrade.texts.choosePlan': 'Escolher plano',
  'pricing.upgrade.texts.contactUs': 'Contacte-nos',
  'pricing.upgrade.texts.everythingInBusinessPlus': 'Tudo o que inclui o Business, mais:',
  'pricing.upgrade.texts.everythingInCreatorPlus': 'Tudo o que inclui o Creator, mais:',
  'pricing.upgrade.texts.everythingInCreatorProPlus': 'Tudo o que inclui o Creator Pro, mais:',
  'pricing.upgrade.texts.everythingInTrialPlus': 'Tudo o que inclui o Trial, mais:',
  'pricing.upgrade.texts.orChoosePlan': 'ou escolha um plano',
  'pricing.upgrade.texts.upgradeToBusinessPlan': 'Mudar para o plano Business',
  'pricing.upgrade.texts.upgradeToCreatorPlan': 'Mudar para o plano Creator',
  'pricing.upgrade.texts.upgradeToCreatorProPlan': 'Mudar para o plano Creator Pro',
  'pricing.upgrade.texts.withTheBusinessPlanYouLlGet': 'Com o plano Business, terá:',
  'pricing.upgrade.texts.withTheCreatorPlanYouLlGet': 'Com o plano Creator, terá:',
  'pricing.upgrade.texts.withTheCreatorProPlanYouLlGet': 'Com o plano Creator Pro, terá:',
  'pricing.upgrade.translationDictionary.dictionarySavesYourBrandNamesProductTermsAnd':
    'O dicionário guarda os nomes das suas marcas, termos de produtos e expressões-chave — e utiliza-os de forma consistente em todos os projetos.',
  'pricing.upgrade.translationDictionary.fixATermOnceNeverCorrectItAgain':
    'Corrija um termo uma vez e não volte a corrigi-lo',
  'pricing.upgrade.translationDictionary.getConsistentTranslationsWithDictionaryAndOtherPro':
    'Obtenha traduções consistentes com o dicionário e outras ferramentas Pro',
  'pricing.upgrade.translationDictionary.noMoreReEditingTheSameTermsAcross':
    'Não volte a editar os mesmos termos em vários projetos',
  'pricing.upgrade.translationDictionary.seePlansWithDictionary': 'Ver planos com dicionário',
  'pricing.upgrade.translationDictionary.teamsAndCreatorsWithSpecificTerminologyOrBrand':
    'equipas e criadores com terminologia específica ou linguagem própria da marca.',
  'pricing.upgrade.translationDictionary.translationsThatSoundLikeYouNotJustCorrect':
    'Traduções que refletem a sua voz, não apenas traduções corretas',
  'pricing.upgrade.translationDictionary.withDictionary': 'Com o dicionário:',
  'pricing.upgrade.translationDictionary.yourBrandVoiceStaysConsistentInEveryLanguage':
    'A voz da sua marca mantém-se consistente em todos os idiomas',
  'pricing.upgrade.translationTone.contentThatFeelsWrittenForThatAudienceNot':
    'Conteúdo que parece escrito para esse público, e não traduzido',
  'pricing.upgrade.translationTone.getBetterTranslationControlWithPromptingAndOther':
    'Controle melhor as traduções com instruções e outras ferramentas Pro',
  'pricing.upgrade.translationTone.lessEditingAfterEveryDub': 'Menos edição após cada dobragem',
  'pricing.upgrade.translationTone.seePlansWithPrompting': 'Ver planos com instruções',
  'pricing.upgrade.translationTone.teamsWithOngoingLocalizationWorkflows':
    'equipas com fluxos de localização contínuos.',
  'pricing.upgrade.translationTone.tellUsTheToneAudienceAndContextAnd':
    'Indique-nos o tom, o público e o contexto — e obtenha uma tradução adequada ao seu conteúdo, não apenas às palavras.',
  'pricing.upgrade.translationTone.translationsThatSoundLikeYou': 'Traduções que refletem a sua voz',
  'pricing.upgrade.translationTone.withPrompting': 'Com instruções:',
  'pricing.upgrade.translationTone.yourToneCarriesAcrossEveryLanguage': 'O seu tom mantém-se em todos os idiomas',
  'pricing.upgrade.unlimitedLength.anyContentLongerThanAMinuteTutorialsInterviews':
    'qualquer conteúdo com mais de um minuto — tutoriais, entrevistas ou cursos.',
  'pricing.upgrade.unlimitedLength.dubTheWholeVideoNotJustAPreview':
    'Dobre o vídeo completo, não apenas uma pré-visualização',
  'pricing.upgrade.unlimitedLength.everyWordEverySpeakerToTheVeryEnd':
    'Todas as palavras, todos os locutores, até ao fim',
  'pricing.upgrade.unlimitedLength.getFullLengthDubbingWithOtherProTools':
    'Obtenha dobragens completas e outras ferramentas Pro',
  'pricing.upgrade.unlimitedLength.noContentCutToFitATimeLimit': 'Sem cortar conteúdo para cumprir um limite de tempo',
  'pricing.upgrade.unlimitedLength.seePlansWithUnlimitedLength': 'Ver planos com duração ilimitada',
  'pricing.upgrade.unlimitedLength.withUnlimitedLength': 'Com duração ilimitada:',
  'pricing.upgrade.unlimitedLength.yourFullVideoFullyDubbedAndReadyTo':
    'O seu vídeo completo, totalmente dobrado e pronto a publicar',
  'pricing.upgrade.unlimitedLength.yourTrialPreviews1MinuteOnAPaid':
    'O Trial permite pré-visualizar 1 minuto. Num plano pago, o Rask dobra o ficheiro completo — sem cortes nem conteúdo em falta.',
  'pricing.upgrade.userPrompting.brandsAndCreatorsWhoNeedOnBrandTranslations':
    'marcas e criadores que precisam de traduções alinhadas com a marca sem muita edição.',
  'pricing.upgrade.userPrompting.controlYourTranslation': 'Controle a sua tradução',
  'pricing.upgrade.userPrompting.enterpriseUsersConfirmTranslationEditsUpTo5':
    'Os utilizadores do Enterprise confirmam alterações às traduções até 5× mais depressa',
  'pricing.upgrade.userPrompting.guideWordChoiceAndTerminology': 'Oriente a escolha de palavras e a terminologia',
  'pricing.upgrade.userPrompting.howToUsePromptingEffectively': 'sobre como utilizar as instruções eficazmente',
  'pricing.upgrade.userPrompting.makeYourDubbedVideosMatchYourBrandVoice':
    'Faça com que os vídeos dobrados reflitam a voz da sua marca.',
  'pricing.upgrade.userPrompting.setTheToneStyleAndContextForTranslations':
    'Defina o tom, o estilo e o contexto das traduções através de instruções. Escolha um dos nossos modelos ou escreva uma instrução personalizada para as suas necessidades.',
  'pricing.upgrade.userPrompting.setToneAndFormalityLevel': 'Defina o tom e o nível de formalidade',
  'pricing.upgrade.userPrompting.unlockTranslationPrompting': 'Desbloqueie as instruções de tradução',
  'pricing.upgrade.userPrompting.unlockTranslationPromptingFeature':
    'Desbloqueie a funcionalidade de instruções de tradução',
  'pricing.upgrade.userPrompting.useReadyMadeTemplatesOrWriteCustomPrompts':
    'Utilize modelos predefinidos ou escreva instruções personalizadas',
  'pricing.upgrade.videoSubtitles.unlockCaptionsFeature': 'Desbloqueie a funcionalidade de legendas',
  'pricing.upgrade.videoSubtitles.upgradeToCreatorProToDownloadVideosWith':
    'Mude para o Creator Pro para transferir vídeos com legendas',
  'pricing.upgrade.voicePresets.aboutVoiceCloneLibrary': 'sobre a biblioteca do Voice Clone',
  'pricing.upgrade.voicePresets.adjustExpressivenessOrRemoveAccents': 'Ajuste a expressividade ou remova sotaques',
  'pricing.upgrade.voicePresets.creatorsDubbingInMultipleLanguagesAndBrandsMaintaining':
    'Criadores que fazem dobragens em vários idiomas e marcas que mantêm a mesma voz em todos os conteúdos.',
  'pricing.upgrade.voicePresets.levelUpDubbingWithThisAndOtherPro':
    'Eleve a qualidade das dobragens com esta e outras ferramentas Pro',
  'pricing.upgrade.voicePresets.makeYourClonedVoiceSoundExactlyRightEvery':
    'Faça com que a sua voz clonada soe exatamente como pretende — sempre.',
  'pricing.upgrade.voicePresets.reuseYourClonedVoicesAcrossUnlimitedProjects':
    'Reutilize as suas vozes clonadas num número ilimitado de projetos',
  'pricing.upgrade.voicePresets.saveCustomizedVoiceClonesOrCreateNewOnes':
    'Guarde clones de voz personalizados ou crie novos de raiz',
  'pricing.upgrade.voicePresets.unlockMoreVoiceClones': 'Desbloqueie mais Voice Clones',
  'pricing.upgrade.voicePresets.unlockVoiceCloneLibrary': 'Desbloqueie a biblioteca do Voice Clone',
  'pricing.upgrade.voicePresets.upgradeToBusinessToSaveUpTo10':
    'Mude para o Business para guardar até 10 Voice Clones personalizados',
  'pricing.upgrade.voicePresets.upgradeToCreatorProToCreateAUstom':
    'Mude para o Creator Pro para criar um Voice Clone personalizado',
  'pricing.upgrade.voicePresets.upgradeToEnterpriseToSaveUnlimitedCustomVoice':
    'Mude para o Enterprise para guardar um número ilimitado de Voice Clones personalizados',
  'pricing.upgrade.voicePresets.whatYouCanDo': 'O que pode fazer',
  'pricing.yearly.buyMinutes': 'Compre minutos adicionais a qualquer momento',
  'pricing.yearly.keepMinutes': 'Não perde minutos no final do mês',
  'pricing.yearly.only': 'APENAS NOS PLANOS ANUAIS',
  'pricing.yearly.unlimitedEditing': 'Reedição e nova dobragem ilimitadas',
  'projectsList.dropHere': 'Largue aqui',
  'projectsList.gridView': 'Vista em grelha',
  'projectsList.listView': 'Vista em lista',
  'projectsList.menu.delete': 'Eliminar',
  'projectsList.menu.download': 'Transferir vídeo',
  'projectsList.menu.move': 'Mover projeto',
  'projectsList.menu.rename': 'Mudar o nome',
  'projectsList.menu.share': 'Partilhar',
  'projectsList.meta': '{type} · {time}',
  'projectsList.moreActions': 'Mais ações para {name}',
  'projectsList.restoringFiles':
    'Está tudo seguro. O seu projeto está temporariamente indisponível e ficará pronto daqui a 3–4 horas.',
  'projectsList.select': 'Selecionar {name}',
  'recordingEditor.aborted.description': 'Esta gravação foi cancelada e não pode ser processada.',
  'recordingEditor.aborted.title': 'Gravação cancelada',
  'recordingEditor.analyzing.title': 'A analisar a sua forma de falar...',
  'recordingEditor.autoZoom.cardTitle': 'Zoom {number}',
  'recordingEditor.autoZoom.emptyDescription': 'Não encontrámos nenhum momento nesta gravação que justifique um zoom.',
  'recordingEditor.autoZoom.emptyTitle': 'Sem zooms',
  'recordingEditor.autoZoom.locked': 'Faz zoom onde clica para que os espetadores possam acompanhar.',
  'recordingEditor.autoZoom.masterSwitch': 'Ativar ou desativar todos os zooms automáticos',
  'recordingEditor.autoZoom.preset.medium': 'Médio',
  'recordingEditor.autoZoom.preset.strong': 'Forte',
  'recordingEditor.autoZoom.preset.subtle': 'Subtil',
  'recordingEditor.autoZoom.title': 'Zoom automático',
  'recordingEditor.autoZoom.turnOff': 'Desativar o zoom que começa em {time}',
  'recordingEditor.autoZoom.turnOn': 'Ativar o zoom que começa em {time}',
  'recordingEditor.autoZoom.zoomSwitchTooltip': 'Ativar / desativar este zoom',
  'recordingEditor.defaultTitle': 'Gravação',
  'recordingEditor.failed.description': 'Falha no processamento. Tente novamente ou volte mais tarde.',
  'recordingEditor.failed.overlay': 'Não foi possível processar',
  'recordingEditor.failed.title': 'Falha no processamento',
  'recordingEditor.failed.tryAgain': 'Tentar novamente',
  'recordingEditor.header.back': 'Voltar às gravações',
  'recordingEditor.header.download': 'Transferir',
  'recordingEditor.header.downloading': 'A transferir...',
  'recordingEditor.header.viewPlans': 'Ver planos',
  'recordingEditor.leaveHint': 'Pode sair desta página e voltar mais tarde.',
  'recordingEditor.mobileBanner.dismiss': 'Fechar',
  'recordingEditor.mobileBanner.text': 'Para uma melhor experiência de edição, abra num computador.',
  'recordingEditor.notFound.description': 'A página que procura não existe.',
  'recordingEditor.notFound.goHome': 'Ir para o início',
  'recordingEditor.notFound.title': 'Página não encontrada',
  'recordingEditor.player.back': 'Recuar 10 segundos',
  'recordingEditor.player.backTooltip': 'Recuar 10 s',
  'recordingEditor.player.forward': 'Avançar 10 segundos',
  'recordingEditor.player.forwardTooltip': 'Avançar 10 s',
  'recordingEditor.player.pause': 'Pausar',
  'recordingEditor.player.play': 'Reproduzir',
  'recordingEditor.player.playPauseTooltip': 'Reproduzir / Pausar',
  'recordingEditor.player.spaceKey': 'Espaço',
  'recordingEditor.player.seek': 'Posição de reprodução',
  'recordingEditor.player.speed': 'Ajustar a velocidade de reprodução',
  'recordingEditor.player.speedTooltip': 'Ajustar velocidade',
  'recordingEditor.player.translate': 'Traduzir',
  'recordingEditor.player.translateTooltip': 'Localize este vídeo no editor de tradução',
  'recordingEditor.preview.description':
    'Pré-visualização do seu vídeo finalizado. A renderização final está em curso.',
  'recordingEditor.preview.preparing': 'A preparar a pré-visualização...',
  'recordingEditor.processing.title': 'A processar o vídeo',
  'recordingEditor.rendering.description':
    'Estamos a aplicar as suas últimas edições. Entretanto, pode continuar a ver o vídeo abaixo; basta manter este separador aberto.',
  'recordingEditor.rendering.downloadStarted': 'Transferência iniciada',
  'recordingEditor.rendering.locked': 'Edição bloqueada durante a renderização',
  'recordingEditor.rendering.shareDescription':
    'A ligação de partilha abrirá automaticamente quando estiver pronta. Pode continuar a ver o vídeo abaixo, mas não feche este separador.',
  'recordingEditor.rendering.title': 'A preparar o seu vídeo…',
  'recordingEditor.timeline.autoPauseOff': 'Desativar o corte automático de pausa que começa em {time}',
  'recordingEditor.timeline.autoPauseOn': 'Ativar o corte automático de pausa que começa em {time}',
  'recordingEditor.timeline.autoPauseRemove': 'Remover o corte automático de pausa em {time}',
  'recordingEditor.timeline.autoPauseRestore': 'Repor o corte automático de pausa em {time}',
  'recordingEditor.timeline.frameAlt': 'Fotograma em {time}',
  'recordingEditor.timeline.moveZoom': 'Mover o zoom que começa em {time}',
  'recordingEditor.timeline.removed': 'Removido',
  'recordingEditor.timeline.zoomChip': 'zoom',
  'recordingEditor.timeline.zoomIn': 'Ampliar a linha temporal',
  'recordingEditor.timeline.zoomOut': 'Reduzir a linha temporal',
  'recordingEditor.timeline.zoomSlider': 'Zoom da linha temporal',
  'recordingEditor.transcript.cutHint': 'Palavra removida do vídeo. Clique nela para anular.',
  'recordingEditor.transcript.emptyDescription':
    'Não há nada para cortar, mas ainda pode pré-visualizar, partilhar ou transferir a gravação.',
  'recordingEditor.transcript.emptyTitle': 'Nenhuma fala detetada',
  'recordingEditor.transcript.hint': 'Toque nas palavras para as remover do vídeo ou as repor.',
  'recordingEditor.transcript.tabTooltip': 'Edite o seu vídeo através da transcrição.',
  'recordingEditor.transcript.title': 'Transcrição',
  'recordingModals.extension.banner.description':
    'Grave diretamente a partir do navegador sem abrir o Rask e obtenha zoom automático dinâmico em cada clique.',
  'recordingModals.extension.banner.title': 'Grave ainda mais depressa com a extensão do Rask',
  'recordingModals.extension.closeAria': 'Fechar a configuração da extensão',
  'recordingModals.extension.install.addToChrome': 'Adicionar ao Chrome',
  'recordingModals.extension.install.cardKind': 'Extensão do Chrome',
  'recordingModals.extension.install.cta': 'Instalar extensão',
  'recordingModals.extension.install.description':
    'Os zooms automáticos são adicionados enquanto grava. Instale a extensão do Rask para Chrome para os ativar.',
  'recordingModals.extension.install.title': 'Instale a extensão para obter zooms automáticos',
  'recordingModals.extension.pin.cta': 'Gravar vídeo',
  'recordingModals.extension.pin.description':
    'Clique no ícone de fixação para manter o Rask na barra de ferramentas e, em seguida, clique no ícone do Rask para o abrir e começar a gravar — o zoom automático acompanha os seus cliques.',
  'recordingModals.extension.pin.extensions': 'Extensões',
  'recordingModals.extension.pin.installed': 'Extensão instalada',
  'recordingModals.extension.pin.title': 'Fixe o Rask para aceder mais tarde',
  'recordingModals.extension.recorderName': 'Rask Screen Recorder',
  'recordingModals.intro.paid.description':
    'Grave o seu ecrã e nós transformamos a gravação numa demo de produto impecável, removendo as palavras de preenchimento, as pausas e as hesitações.',
  'recordingModals.intro.trial.badge': 'PERÍODO EXPERIMENTAL · 1 VÍDEO GRATUITO',
  'recordingModals.intro.trial.description':
    'Grave o seu ecrã e nós transformamos a gravação numa demo de produto impecável, removendo as palavras de preenchimento, as pausas e as hesitações. O seu período experimental inclui 1 vídeo com até {minutes} minutos.',
  'recordingModals.paywall.autoZoom.badge': 'DISPONÍVEL EM TODOS OS PLANOS',
  'recordingModals.paywall.autoZoom.bullet1': 'Leve o público diretamente à funcionalidade que está a mostrar',
  'recordingModals.paywall.autoZoom.bullet2': 'Torne nítidos os pequenos detalhes da interface em qualquer ecrã',
  'recordingModals.paywall.autoZoom.bullet3': 'Destaque cada clique para que nada passe despercebido',
  'recordingModals.paywall.autoZoom.description':
    'O Rask aplica zoom automaticamente a cada clique. A sua demo ganha um acabamento profissional e o público olha sempre para o que importa.',
  'recordingModals.paywall.autoZoom.preview.badge': 'Zoom automático',
  'recordingModals.paywall.autoZoom.preview.cta': 'Começar',
  'recordingModals.paywall.autoZoom.strip': 'Gravações de ecrã com o aspeto de uma demo profissional.',
  'recordingModals.paywall.autoZoom.title': 'Zoom dinâmico, adicionado por nós',
  'recordingModals.paywall.choosePlan': 'Escolher plano',
  'recordingModals.paywall.closeAria': 'Fechar janela de planos',
  'recordingModals.paywall.download.badge': 'DISPONÍVEL EM TODOS OS PLANOS',
  'recordingModals.paywall.download.bullet1': 'Demo completa em alta qualidade',
  'recordingModals.paywall.download.bullet2': 'Exporte um MP4 limpo, apenas com a sua marca',
  'recordingModals.paywall.download.bullet3': 'Publique onde quiser ou envie o ficheiro à sua equipa',
  'recordingModals.paywall.download.description':
    'Com um plano pago, pode exportar a sua demo final com qualidade máxima, pronta a publicar e a partilhar.',
  'recordingModals.paywall.download.preview.alt': 'Pré-visualização da demo em vídeo',
  'recordingModals.paywall.download.preview.button': 'Transferir vídeo',
  'recordingModals.paywall.download.strip': 'O resultado completo — exatamente o que criou.',
  'recordingModals.paywall.download.title': 'A sua demo está pronta.\nTransfira-a na íntegra',
  'recordingModals.paywall.recordingMinutes.badge': 'GRAVAÇÃO GRATUITA JÁ UTILIZADA',
  'recordingModals.paywall.recordingMinutes.bullet1': 'Grave todas as demos de que precisar',
  'recordingModals.paywall.recordingMinutes.bullet2': 'Deixe a IA aperfeiçoar cada gravação',
  'recordingModals.paywall.recordingMinutes.bullet3': 'Adicione um zoom dinâmico que acompanha a ação',
  'recordingModals.paywall.recordingMinutes.description':
    'Já utilizou a sua gravação gratuita. Faça upgrade para continuar e gravar demos de produto ilimitadas, aperfeiçoadas por IA.',
  'recordingModals.paywall.recordingMinutes.preview.rec': 'REC {time}',
  'recordingModals.paywall.recordingMinutes.strip': 'Demos ilimitadas, do início ao fim.',
  'recordingModals.paywall.recordingMinutes.title': 'Continue a transformar o seu ecrã em demos impecáveis',
  'recordingModals.paywall.translateMinutes.badge': 'FAÇA UPGRADE PARA OBTER MAIS MINUTOS',
  'recordingModals.paywall.translateMinutes.bullet1': 'Fale com o público em mais de 135 idiomas',
  'recordingModals.paywall.translateMinutes.bullet2': 'Mantenha a sua própria voz em todos os idiomas',
  'recordingModals.paywall.translateMinutes.bullet3': 'Transforme um vídeo numa biblioteca de versões localizadas',
  'recordingModals.paywall.translateMinutes.description':
    'Faça upgrade para continuar a traduzir os seus vídeos para mais de 135 idiomas, com vozes naturais, como as de falantes nativos.',
  'recordingModals.paywall.translateMinutes.preview.caption': 'A traduzir o vídeo de demonstração',
  'recordingModals.paywall.translateMinutes.strip': 'Um vídeo, pronto para todos os mercados.',
  'recordingModals.paywall.translateMinutes.title': 'Chegue a todos os públicos, cada um no seu idioma',
  'recordingModals.recorder.ariaLabel': 'Gravador de ecrã',
  'recordingModals.recorder.camera': 'Câmara',
  'recordingModals.recorder.cameraFallback': 'Câmara {index}',
  'recordingModals.recorder.cameraUnavailable': 'A câmara não está disponível. A gravar sem câmara.',
  'recordingModals.recorder.close': 'Fechar gravador',
  'recordingModals.recorder.defaultTitle': 'Gravação de ecrã {date}',
  'recordingModals.recorder.delete.cancel': 'Cancelar',
  'recordingModals.recorder.delete.closeAria': 'Fechar confirmação de eliminação',
  'recordingModals.recorder.desktopOnly': 'A gravação de ecrã só está disponível no computador',
  'recordingModals.recorder.delete.confirm': 'Eliminar',
  'recordingModals.recorder.delete.description': 'A gravação não será guardada. Pode começar de novo quando quiser.',
  'recordingModals.recorder.delete.title': 'Eliminar esta gravação?',
  'recordingModals.recorder.discard': 'Descartar gravação',
  'recordingModals.recorder.duration': 'Tempo de gravação',
  'recordingModals.recorder.error.cancelled':
    'A partilha de ecrã foi cancelada. Escolha um ecrã, uma janela ou um separador para começar a gravar.',
  'recordingModals.recorder.error.generic': 'Não foi possível iniciar a gravação do ecrã. Tente novamente.',
  'recordingModals.recorder.error.sharingEnded':
    'A partilha de ecrã terminou antes de a gravação começar. Tente novamente.',
  'recordingModals.recorder.microphone': 'Microfone',
  'recordingModals.recorder.microphoneFallback': 'Microfone {index}',
  'recordingModals.recorder.microphoneUnavailable': 'O microfone não está disponível. A gravar sem microfone.',
  'recordingModals.recorder.noCamera': 'Sem câmara',
  'recordingModals.recorder.noCameraOption': 'Não usar a câmara',
  'recordingModals.recorder.noMicrophone': 'Sem microfone',
  'recordingModals.recorder.noMicrophoneOption': 'Não usar o microfone',
  'recordingModals.recorder.pause': 'Pausar gravação',
  'recordingModals.recorder.reconnecting': 'A restabelecer a ligação…',
  'recordingModals.recorder.record': 'Gravar',
  'recordingModals.recorder.resume': 'Retomar gravação',
  'recordingModals.recorder.saveFailed.accessDenied':
    'De momento, não pode guardar gravações neste Teamspace. Peça ao proprietário para verificar o plano e o seu acesso.',
  'recordingModals.recorder.saveFailed.autoStopped':
    'A gravação parou porque não foi possível carregá-la. O que gravou até agora foi mantido, por isso pode tentar guardá-la novamente.',
  'recordingModals.recorder.saveFailed.delete': 'Eliminar',
  'recordingModals.recorder.saveFailed.retry': 'Tentar novamente',
  'recordingModals.recorder.saveFailed.title': 'Não foi possível guardar a gravação',
  'recordingModals.recorder.saving': 'A guardar a gravação…',
  'recordingModals.recorder.stop': 'Parar gravação',
  'recordingModals.share.button': 'Partilhar',
  'recordingModals.share.closeAria': 'Fechar janela de partilha',
  'recordingModals.share.copy': 'Copiar',
  'recordingModals.share.description': 'Copie a ligação e envie-a a quem quiser.',
  'recordingModals.share.linkAria': 'Ligação de partilha',
  'recordingModals.share.linkCopied': 'Ligação copiada para a área de transferência',
  'recordingModals.share.title': 'A sua demo está pronta a partilhar',
  'recordingModals.share.upsell': 'Partilhe demos completas e sem marca de água',
  'records.credits.freeRecordingAvailable': '1 gravação gratuita · até {minutes} min',
  'records.credits.freeRecordingUsed': 'Gravação gratuita utilizada',
  'records.credits.unlimited': 'Ilimitado',
  'records.newRecording': 'Nova gravação',
  'records.pageTitle': 'Gravar vídeos',
  'records.preparingUpdatedVideo': 'A preparar o vídeo atualizado…',
  'records.status.aborted': 'Cancelada',
  'records.status.completed': 'Concluída',
  'records.status.created': 'Criada',
  'records.status.failed': 'Falhou',
  'records.status.processing': 'A processar',
  'records.translate': 'Traduzir',
  'records.translateAria': 'Traduzir {name}',
  'records.type': 'Gravação de ecrã',
  'records.zeroState.action': 'Gravar vídeo',
  'records.zeroState.description':
    'Basta gravar e falar: cortamos as palavras de hesitação, as pausas e os enganos por si. Uma única gravação chega.',
  'records.zeroState.title': 'Grave. Nós damos o acabamento.',
  'sidebar.api.getKey': 'Obter chave da API',
  'sidebar.api.title': 'Use a API da Rask nos seus produtos',
  'sidebar.bookCall': 'Agendar uma chamada com a equipa de Sucesso do Cliente',
  'sidebar.dictionary': 'Dicionário',
  'sidebar.getHelp': 'Obter ajuda',
  'sidebar.helpCenter': 'Centro de Ajuda',
  'sidebar.recordVideo': 'Gravar vídeo',
  'sidebar.settingsMembers': 'Definições e membros',
  'sidebar.teamspace.defaultName': 'O meu Teamspace',
  'sidebar.teamspace.description': 'Simplifique o trabalho em equipa com os Teamspaces',
  'sidebar.teamspace.new': 'Novo Teamspace',
  'sidebar.translation': 'Tradução',
  'sidebar.viewPlans': 'Ver planos',
  'sidebar.voiceCloneLibrary': 'Biblioteca de Voice Clone',
  'sidebarNav.assets': 'Recursos',
  'sidebarNav.home': 'Início',
  'sidebarNav.newRecording': 'Gravar um novo vídeo',
  'sidebarNav.newTranslation': 'Traduzir um novo vídeo',
  'sidebarNav.plan.free': 'Plano gratuito',
  'teamspace.action.cancel': 'Cancelar',
  'teamspace.action.delete': 'Eliminar',
  'teamspace.action.discardChanges': 'Descartar alterações',
  'teamspace.action.leave': 'Sair',
  'teamspace.action.remove': 'Remover',
  'teamspace.action.save': 'Guardar',
  'teamspace.delete.subtitle':
    'Depois de o eliminar, perderá permanentemente, juntamente com a sua equipa, o acesso a todos os projetos deste Teamspace.',
  'teamspace.delete.title': 'Pretende eliminar permanentemente este Teamspace?',
  'teamspace.discard.subtitle': 'Se sair agora, as suas alterações serão perdidas.',
  'teamspace.discard.title': 'Tem alterações não guardadas',
  'teamspace.form.color': 'Cor',
  'teamspace.form.leave': 'Sair do Teamspace',
  'teamspace.form.name': 'Nome do Teamspace',
  'teamspace.form.namePlaceholder': 'Introduza o nome',
  'teamspace.leave.subtitle': 'Depois de sair, perderá o acesso a todos os projetos deste espaço.',
  'teamspace.leave.title': 'Pretende sair deste espaço?',
  'teamspace.member.count': 'Membros {count} / {limit}',
  'teamspace.member.duplicateEmail': 'Este e-mail já foi adicionado',
  'teamspace.member.editor': 'Editor',
  'teamspace.member.emailPlaceholder': 'Introduza o e-mail',
  'teamspace.member.incorrectEmail': 'Introduza um endereço de e-mail válido',
  'teamspace.member.invite': 'Convidar',
  'teamspace.member.owner': 'Proprietário',
  'teamspace.member.ownerWithMembers': 'Proprietário • Membros: {count}',
  'teamspace.member.remove.subtitle':
    'Após a remoção, esta pessoa perderá o acesso ao Teamspace e a todos os projetos nele incluídos. Pode voltar a adicionar este membro mais tarde e restaurar o respetivo acesso.',
  'teamspace.member.remove.title': 'Tem a certeza de que pretende remover este membro do Teamspace?',
  'teamspace.member.you': '(você)',
  'teamspace.settings.fallbackName': 'Teamspace',
  'teamspace.settings.tab': 'Definições',
  'teamspace.settings.usageTab': 'Utilização',
  'teamspace.upgrade.addMore': 'Adicionar mais',
  'teamspace.upgrade.getStarted': 'Começar',
  'teamspace.upgrade.inviteUsers': 'Convidar utilizadores a colaborar',
  'teamspace.upgrade.planMembers': 'Limite de membros do seu plano: {count}',
  'teamspace.usage.description': 'Estes minutos são partilhados entre todos os Teamspaces de que é proprietário.',
  'teamspace.usage.manageSubscription': 'Gerir subscrição',
  'teamspace.usage.minutes': 'Minutos do Teamspace',
  'teamspace.welcome.createFirst':
    'Comece por criar o seu primeiro vídeo no separador Tradução e siga os passos de introdução.',
  'teamspace.welcome.getStarted': 'Começar',
  'teamspace.welcome.invited':
    'Recebeu um convite para colaborar com a sua equipa em projetos de localização de vídeos.',
  'teamspace.welcome.title': 'Boas-vindas ao Teamspace {name}!',
  'trial.booking.bookedDescription': 'Consulte a sua caixa de entrada, aceite o convite e vemo-nos em breve!',
  'trial.booking.bookedSnackbar': 'A sua demonstração está agendada — até lá!',
  'trial.booking.bookedTitle': 'A sua demonstração está agendada!',
  'trial.booking.calendarSubtitle':
    'Terá uma apresentação personalizada do produto, conhecerá histórias comprovadas de sucesso de clientes e saberá quais são os preços para o seu caso de utilização.',
  'trial.booking.calendarTitle': 'Marque a sua demonstração de 30 minutos do Rask',
  'trial.booking.done': 'Concluído',
  'trial.booking.maybeLater': 'Talvez mais tarde',
  'trial.demo.description':
    'Selecione o idioma de tradução pretendido e veja o resultado. Faça alterações e ajuste as vozes para explorar as funcionalidades do editor.',
  'trial.demo.openEditor': 'Abrir no editor',
  'trial.demo.paidLanguages': 'Idiomas disponíveis nos planos pagos',
  'trial.demo.projectLabel': 'Projeto de demonstração',
  'trial.demo.title': 'Experimente gratuitamente o projeto de demonstração!',
  'trial.demo.translateOwnVideo': 'Traduzir o seu próprio vídeo',
  'trial.demoBanner.delegate.cta': 'Deixe connosco',
  'trial.demoBanner.delegate.subtitle': 'Veja exatamente como numa chamada de 30 minutos com a nossa equipa.',
  'trial.demoBanner.delegate.title': 'Quer delegar-nos o seu trabalho de localização?',
  'trial.demoBanner.integration.cta': 'Preciso de uma integração',
  'trial.demoBanner.integration.subtitle': 'Marque uma demonstração individual — nós tratamos do resto.',
  'trial.demoBanner.integration.title': 'Integre o Rask no seu fluxo de trabalho sem complicações',
  'trial.demoBanner.volume.cta': 'Reduza os custos e o esforço',
  'trial.demoBanner.volume.subtitle': 'Marque uma demonstração individual — criaremos o seu plano de localização.',
  'trial.demoBanner.volume.title': 'Produz conteúdo em grande volume?',
  'trial.landing.durationMinutes': '{count} min',
  'trial.landing.durationSeconds': '{count} s',
  'trial.landing.fileFallback': 'O seu ficheiro',
  'trial.landing.localizing': 'A localizar',
  'trial.landing.previewAlt': 'Pré-visualização',
  'trial.landing.uploaded': 'Carregado',
  'trial.player.enterFullscreen': 'Entrar em ecrã inteiro',
  'trial.player.exitFullscreen': 'Sair do ecrã inteiro',
  'trial.player.lipSync': 'Sincronização labial',
  'trial.player.localized': 'Localizado',
  'trial.player.mute': 'Desativar som',
  'trial.player.original': 'Original',
  'trial.player.pause': 'Pausar',
  'trial.player.pauseVideo': 'Pausar vídeo',
  'trial.player.play': 'Reproduzir',
  'trial.player.playVideo': 'Reproduzir vídeo',
  'trial.player.previewAria': 'Pré-visualização do vídeo {name}',
  'trial.player.seek': 'Posição no vídeo',
  'trial.player.unmute': 'Ativar som',
  'trial.player.upgrade.continueWatching': 'Continuar a ver',
  'trial.player.upgrade.lockedSubtitle':
    'Traduzimos o primeiro minuto. Faça upgrade para traduzir o vídeo completo — na íntegra e sem marca de água.',
  'trial.player.upgrade.lockedTitle': 'Esta foi a pré-visualização — desbloqueie o vídeo completo',
  'trial.player.upgrade.oneMinutePreview': 'Pré-visualização de 1 minuto',
  'trial.player.upgrade.overlaySubtitle':
    'Está a gostar da pré-visualização? Faça upgrade para traduzir o vídeo completo — na íntegra e sem marca de água.',
  'trial.player.upgrade.overlayTitle': 'Faça upgrade para traduzir o vídeo completo',
  'trial.player.upgrade.replay': 'Repetir pré-visualização',
  'trial.player.upgrade.seePlans': 'Ver planos',
  'trial.player.upgrade.upgrade': 'Fazer upgrade',
  'trial.player.videoLanguage': 'Idioma do vídeo',
  'trial.player.videoProgress': 'Progresso do vídeo',
  'trial.preview.editorDescription': 'Ajuste o guião, as vozes e a sincronização ao seu gosto.',
  'trial.preview.editorTitle': 'Explore no editor',
  'trial.preview.export': 'Exportar',
  'trial.preview.exportDescription': 'Transfira o MP4 localizado com áudio dobrado e legendas.',
  'trial.preview.exportTitle': 'Exporte o seu vídeo',
  'trial.preview.openEditor': 'Abrir o editor',
  'trial.preview.talkToSales': 'Fale com a equipa comercial sobre dobragem em grande escala',
  'trial.processing.audioReady': 'O seu ficheiro está pronto',
  'trial.processing.audioReadyDescription': 'O seu ficheiro localizado está pronto a visualizar.',
  'trial.processing.completeAnnouncement': 'Localização concluída. Todas as etapas de processamento terminaram.',
  'trial.processing.currentStepAnnouncement': 'Etapa de processamento atual: {step}',
  'trial.processing.localizedInto': 'Localização para {language} concluída',
  'trial.processing.localizingAudio': 'A localizar o seu ficheiro',
  'trial.processing.localizingInto': 'A localizar para {language}',
  'trial.processing.localizingVideo': 'A localizar o seu vídeo',
  'trial.processing.progressAria': 'Progresso da localização: {percent}%',
  'trial.processing.steps.backgroundAudio.description': 'A preservar a música e o som ambiente de fundo.',
  'trial.processing.steps.backgroundAudio.title': 'Áudio de fundo preservado',
  'trial.processing.steps.speaker.description': 'A separar a voz de cada locutor da mistura de fundo.',
  'trial.processing.steps.speaker.title': 'Locutores identificados',
  'trial.processing.steps.timing.description': 'A sincronizar cada fala com o momento em que é dita no ecrã.',
  'trial.processing.steps.timing.title': 'Sincronizado com os tempos do original',
  'trial.processing.steps.translation.description':
    'A adaptar expressões, tom e formulações ao público — sem traduzir palavra por palavra.',
  'trial.processing.steps.translation.title': 'Traduzido para o idioma de destino',
  'trial.processing.steps.translation.titleWithLanguage': 'Traduzido para {language}',
  'trial.processing.steps.voice.description': 'A recriar o tom de cada locutor no novo idioma.',
  'trial.processing.steps.voice.title': 'Voz de cada locutor clonada',
  'trial.processing.videoReady': 'O seu vídeo está pronto',
  'trial.processing.videoReadyDescription': 'O seu vídeo localizado está pronto a visualizar.',
  'trial.processing.waitDescription': 'Demora cerca de um minuto — aguarde, mostraremos o resultado aqui.',
  'trial.processing.workingOnAudio': 'A processar o seu ficheiro',
  'trial.processing.workingOnVideo': 'A processar o seu vídeo',
  'trial.publicShare.branding': 'Localizado com o Rask',
  'trial.publicShare.ctaQuestion': 'Quer localizar o seu próprio vídeo?',
  'trial.publicShare.description': 'Veja-o no idioma original ou mude para a versão localizada.',
  'trial.publicShare.heading': 'Este vídeo foi localizado com o Rask',
  'trial.publicShare.loadErrorDescription': 'Atualize a página ou tente novamente dentro de alguns instantes.',
  'trial.publicShare.loadErrorTitle': 'Não foi possível carregar este vídeo',
  'trial.publicShare.loading': 'A carregar o vídeo…',
  'trial.publicShare.loadingAria': 'A carregar o vídeo partilhado',
  'trial.publicShare.metaTitle': 'Vídeo localizado',
  'trial.publicShare.noCard': 'Localize um vídeo em mais de 135 idiomas — sem precisar de cartão.',
  'trial.publicShare.playerAria': 'Leitor de vídeo: {name}',
  'trial.publicShare.raskHome': 'Página inicial do Rask',
  'trial.publicShare.sharedVideo': 'Partilhado',
  'trial.publicShare.tryFree': 'Experimente o Rask grátis',
  'trial.publicShare.viewPlans': 'Ver planos',
  'trial.share.button': 'Partilhar',
  'trial.share.copied': 'Copiado!',
  'trial.share.copy': 'Copiar',
  'trial.share.description': 'Envie o seu vídeo a qualquer pessoa através da ligação abaixo',
  'trial.share.error': 'Ocorreu um erro. Tente novamente mais tarde.',
  'trial.share.title': 'Partilhe o seu vídeo',
  'trial.sidebarBanner.cta': 'Passar para a versão completa',
  'trial.sidebarBanner.title': 'Desbloqueie funcionalidades avançadas e leve as suas traduções de vídeo a outro nível!',
  'trial.survey.continue': 'Continuar',
  'trial.survey.continueAnyway': 'Continuar mesmo assim',
  'trial.survey.footnote': 'Demora 5 segundos · ajuda-nos a configurar tudo corretamente',
  'trial.survey.hours.fifteenToThirty': '15–30 horas',
  'trial.survey.hours.lessThanOne': 'Menos de 1 hora',
  'trial.survey.hours.moreThanThirty': 'Mais de 30 horas',
  'trial.survey.hours.oneToTen': '1–10 horas',
  'trial.survey.hours.tenToFifteen': '10–15 horas',
  'trial.survey.hoursPlaceholder': 'Selecione o volume',
  'trial.survey.hoursQuestion': 'Com quantas horas de vídeo trabalha por mês?',
  'trial.survey.languagesPlaceholder': 'Selecione o número de línguas',
  'trial.survey.languagesQuestion': 'Quantas línguas fala o seu público?',
  'trial.survey.submitError': 'Não foi possível guardar as suas respostas. Tente novamente.',
  'trial.survey.subtitle': 'Duas perguntas rápidas para adaptarmos o seu espaço de trabalho.',
  'trial.survey.title': 'Boas-vindas ao Rask',
  'trialPaywall.benefit.business.marketsDescription': 'traduza para várias línguas num único fluxo',
  'trialPaywall.benefit.business.marketsTitle': 'Vários mercados em simultâneo',
  'trialPaywall.benefit.business.minutesDescription': 'concebido para equipas que localizam conteúdos regularmente',
  'trialPaywall.benefit.business.teamDescription':
    'use 10 vozes, colabore com 5 membros da equipa e obtenha processamento prioritário',
  'trialPaywall.benefit.business.teamTitle': 'Maior produtividade da equipa',
  'trialPaywall.benefit.business.terminologyDescription': 'mantenha os termos da marca e dos produtos alinhados',
  'trialPaywall.benefit.business.terminologyTitle': 'Terminologia consistente',
  'trialPaywall.benefit.creator.minutesDescription': 'para projetos simples e pontuais',
  'trialPaywall.benefit.creator.projectsDescription': 'localize, edite e exporte os seus próprios vídeos',
  'trialPaywall.benefit.creator.projectsTitle': 'Experimente projetos reais',
  'trialPaywall.benefit.creator.voiceDescription': 'ajuste vozes clonadas e crie a sua própria biblioteca',
  'trialPaywall.benefit.creator.voiceTitle': 'Personalize a clonagem de voz',
  'trialPaywall.benefit.creator.workflowDescription': 'ideal para localização autónoma ocasional',
  'trialPaywall.benefit.creator.workflowTitle': 'Fluxo individual simples',
  'trialPaywall.benefit.creatorPro.editsDescription': 'trabalhe com guiões, legendas e definições de voz',
  'trialPaywall.benefit.creatorPro.editsTitle': 'Edições prontas a publicar',
  'trialPaywall.benefit.creatorPro.lipSyncDescription': 'sincronize os movimentos da boca com a fala traduzida',
  'trialPaywall.benefit.creatorPro.lipSyncTitle': 'Sincronização labial dos vídeos traduzidos',
  'trialPaywall.benefit.creatorPro.minutesDescription': 'traduza mais vídeos, com minutos adicionais disponíveis',
  'trialPaywall.benefit.creatorPro.teamDescription': 'partilhe a sua subscrição com 3 membros da equipa',
  'trialPaywall.benefit.creatorPro.teamTitle': 'Trabalhe em conjunto com a sua equipa',
  'trialPaywall.benefit.enterprise.minutesDescription': 'para operações de localização de grande volume',
  'trialPaywall.benefit.enterprise.minutesTitle': 'Número de minutos personalizado',
  'trialPaywall.benefit.enterprise.procurementDescription': 'utilize contratos e faturação personalizados',
  'trialPaywall.benefit.enterprise.procurementTitle': 'Preparado para processos de compra',
  'trialPaywall.benefit.enterprise.reviewDescription': 'adicione revisão humana a conteúdos críticos',
  'trialPaywall.benefit.enterprise.reviewTitle': 'Revisão gerida',
  'trialPaywall.benefit.enterprise.supportDescription':
    'obtenha apoio dedicado ao sucesso do cliente para fluxos de trabalho complexos',
  'trialPaywall.benefit.enterprise.supportTitle': 'Apoio dedicado',
  'trialPaywall.benefits.heading': 'Com o {plan}, tem acesso a:',
  'trialPaywall.benefits.monthlyMinutesFew': '{count} minutos por mês',
  'trialPaywall.benefits.monthlyMinutesMany': '{count} minutos por mês',
  'trialPaywall.benefits.monthlyMinutesOne': '{count} minuto por mês',
  'trialPaywall.benefits.monthlyMinutesOther': '{count} minutos por mês',
  'trialPaywall.benefits.yearlyMinutesFew': 'Comece com {count} minutos e obtenha mais quando quiser',
  'trialPaywall.benefits.yearlyMinutesMany': 'Comece com {count} minutos e obtenha mais quando quiser',
  'trialPaywall.benefits.yearlyMinutesOne': 'Comece com {count} minuto e obtenha mais quando quiser',
  'trialPaywall.benefits.yearlyMinutesOther': 'Comece com {count} minutos e obtenha mais quando quiser',
  'trialPaywall.card.customMinutes': 'Minutos personalizados',
  'trialPaywall.card.customPricing': 'Preço personalizado',
  'trialPaywall.card.minutesFew': '{count} minutos',
  'trialPaywall.card.minutesMany': '{count} minutos',
  'trialPaywall.card.minutesOne': '{count} minuto',
  'trialPaywall.card.minutesOther': '{count} minutos',
  'trialPaywall.card.perMinute': 'por minuto',
  'trialPaywall.card.perMonth': '/mês',
  'trialPaywall.card.total': 'no total',
  'trialPaywall.chip.business': 'Resultados mais precisos',
  'trialPaywall.chip.creator': 'Ideal para começar',
  'trialPaywall.chip.creatorPro': 'Mais popular',
  'trialPaywall.cta.bookDemo': 'Agendar uma demonstração',
  'trialPaywall.cta.continueWithPlan': 'Continuar com {plan}',
  'trialPaywall.cta.processing': 'A processar...',
  'trialPaywall.defaultTitle': 'Desbloqueie todas as opções de transferência',
  'trialPaywall.error.generic': 'Ocorreu um erro. Tente novamente mais tarde.',
  'trialPaywall.header.moreMinutes': 'Mais minutos',
  'trialPaywall.header.moreMinutesShort': 'Mais min',
  'trialPaywall.include.aiDubbing': 'Dobragem com IA em mais de 135 línguas',
  'trialPaywall.include.editor': 'Editor de vídeo integrado',
  'trialPaywall.include.transcriptionTranslation': 'Transcrição e tradução automáticas',
  'trialPaywall.include.voiceCloning': 'Clonagem de voz em 32 línguas',
  'trialPaywall.includes.all': 'Todos os planos incluem:',
  'trialPaywall.includes.annual': 'Todos os planos anuais incluem:',
  'trialPaywall.includes.enterprise': 'O plano Enterprise inclui:',
  'trialPaywall.legacyChip.business': 'Resultado mais preciso',
  'trialPaywall.legacyChip.creator': 'Ideal para começar',
  'trialPaywall.period.payAnnual': 'Pagar anualmente',
  'trialPaywall.period.savings': 'poupe até {percent}%',
  'trialPaywall.upgradeBanner.cta': 'Escolher um plano',
  'trialPaywall.upgradeBanner.description':
    'Para traduzir vídeos com mais de um minuto sem marca de água, escolha um plano adequado às suas necessidades.',
  'trialPaywall.upgradeBanner.title': 'Escolha um plano para traduzir o vídeo completo',
  'translationSection.status.analyzingSpeakers': 'A analisar oradores',
  'translationSection.status.analyzingSrt': 'A analisar SRT',
  'translationSection.status.analyzingVideo': 'A analisar vídeo',
  'translationSection.status.analyzingVoices': 'A analisar vozes',
  'translationSection.status.determineSpeakersFailed': 'Falha na identificação dos oradores',
  'translationSection.status.error': 'Erro',
  'translationSection.status.forbiddenLink': 'Ligação não permitida',
  'translationSection.status.generatingVideo': 'A gerar vídeo',
  'translationSection.status.mergingFailed': 'Falha ao juntar o vídeo',
  'translationSection.status.noAudio': 'Sem áudio',
  'translationSection.status.noWords': 'Sem palavras',
  'translationSection.status.onscreenQueued': 'Texto no ecrã · na fila',
  'translationSection.status.onscreenTranslating': 'A traduzir o texto no ecrã',
  'translationSection.status.onscreenTranslatingPercent': 'Texto no ecrã · {percent}%',
  'translationSection.status.readyToGenerate': 'Pronto para gerar o vídeo',
  'translationSection.status.separateBackgroundFailed': 'Falha ao separar o fundo',
  'translationSection.status.transcribeSegmentsFailed': 'Falha ao transcrever os segmentos',
  'translationSection.status.transcribing': 'A transcrever vídeo',
  'translationSection.status.transcriptionFailed': 'Falha na transcrição',
  'translationSection.status.translatingText': 'A traduzir texto',
  'translationSection.status.translationFailed': 'Falha na tradução',
  'translationSection.status.uploadFailed': 'Falha no carregamento',
  'translationSection.status.uploading': 'A carregar',
  'translationSection.status.videoGenerated': 'Vídeo gerado',
  'translationSection.status.videoHasNoSound': 'O vídeo não tem som',
  'translationSection.status.videoLacksSpeech': 'O vídeo não contém fala',
  'translationSection.status.voiceoverFailed': 'Falha na locução',
  'translationSection.type': 'Tradução',
  'translationSection.zeroState.action': 'Carregar vídeo',
  'translationSection.zeroState.description':
    'Carregue um vídeo e obtenha uma dobragem precisa, legendas e clonagem de voz em mais de 135 idiomas.',
  'translationSection.zeroState.title': 'Traduza o seu primeiro vídeo',
  'voice.action.apply': 'Aplicar',
  'voice.action.cancel': 'Cancelar',
  'voice.action.delete': 'Eliminar',
  'voice.action.regenerate': 'Gerar novamente',
  'voice.action.save': 'Guardar',
  'voice.aria.pauseAudio': 'Pausar áudio',
  'voice.aria.playAudio': 'Reproduzir áudio',
  'voice.aria.removeSample': 'Remover amostra de voz',
  'voice.aria.settings': 'Botão das definições de voz',
  'voice.autocomplete.search': 'Pesquisar áudio',
  'voice.autocomplete.select': 'Selecionar áudio',
  'voice.create.generate': 'Gerar clone de voz',
  'voice.create.nameLabel': 'Nome da voz',
  'voice.create.namePlaceholder': 'Introduza um nome',
  'voice.create.subtitle':
    'Crie um clone de voz personalizado para utilizar em vários projetos ao carregar ficheiros com gravações da sua voz.',
  'voice.create.title': 'Novo clone de voz personalizado',
  'voice.delete.subtitle':
    'Depois de eliminada, esta clonagem de voz personalizada deixará de estar acessível. Se a utilizar nos seus projetos, será substituída pela clonagem de voz instantânea.',
  'voice.delete.title': 'Pretende eliminar permanentemente esta clonagem de voz personalizada?',
  'voice.dropzone.choose': 'Clique para escolher um ficheiro',
  'voice.dropzone.drag': 'ou arraste-o e largue-o aqui',
  'voice.dropzone.upload': 'Clique para carregar um ficheiro',
  'voice.error.fileInvalidType': 'Tipo de ficheiro inválido',
  'voice.error.fileTooBig': 'O ficheiro é demasiado grande',
  'voice.error.fileTooSmall': 'O ficheiro é demasiado pequeno',
  'voice.error.generatePreview': 'Não foi possível gerar a pré-visualização',
  'voice.error.genericRetryLater': 'Ocorreu um erro. Tente novamente mais tarde.',
  'voice.error.insufficientSpeech':
    'Não há fala suficiente para clonar esta voz. Edite a atribuição do orador ou utilize as predefinições recomendadas.',
  'voice.error.invalidLink': 'Introduza uma ligação válida',
  'voice.error.maxDuration': 'A duração máxima é de 10 minutos',
  'voice.error.maxSamples': 'Pode carregar até 10 amostras',
  'voice.error.prefix': 'Erro: {message}',
  'voice.error.sampleUnavailable': 'A pré-visualização da voz não está disponível',
  'voice.error.saveToLibrary': 'Não foi possível guardar a clonagem de voz na sua biblioteca',
  'voice.error.tooManyFiles': 'Demasiados ficheiros',
  'voice.group.aiPresets': 'Predefinições de voz com IA',
  'voice.group.instantClone': 'Clonagem instantânea de voz',
  'voice.group.library': 'Biblioteca de clones de voz',
  'voice.hint.aiNotCustomizable': 'A predefinição de voz de IA não pode ser personalizada.',
  'voice.hint.createOwnAfter': 'para personalizar a emoção e o sotaque.',
  'voice.hint.createOwnBefore': 'Pode',
  'voice.hint.createOwnLink': 'criar a sua própria voz',
  'voice.hint.planAccess':
    'A personalização de voz e a opção de guardar na biblioteca estão disponíveis a partir do plano Creator Pro.',
  'voice.hint.upgradeAll': 'Atualize o seu plano para utilizar todas estas funcionalidades!',
  'voice.instant.generatePreview': 'Gerar pré-visualização',
  'voice.instant.playPreview': 'Reproduzir pré-visualização',
  'voice.instant.saveToLibrary': 'Guardar na biblioteca',
  'voice.instant.savingTooltip': 'Estamos a guardar a voz na biblioteca. Poderá utilizá-la assim que estiver guardada.',
  'voice.label.name': 'Nome',
  'voice.label.speaker': 'Locutor',
  'voice.label.voice': 'Voz',
  'voice.language.englishUS': 'Inglês (EUA)',
  'voice.library.add': 'Adicionar clone de voz',
  'voice.library.create': 'Criar clone de voz',
  'voice.library.description':
    'Crie clones de voz de alta qualidade, com controlo total das definições, e utilize-os em vários projetos para obter resultados consistentes.',
  'voice.library.dropHere': 'Largue aqui',
  'voice.library.newTitle': 'Nova clonagem de voz',
  'voice.library.upgradeToCreate': 'Atualizar plano para criar clone de voz',
  'voice.library.voicesAvailable': 'Vozes disponíveis: {count}',
  'voice.option.instantClone': 'Clonagem de voz',
  'voice.rename.namePlaceholder': 'Introduza um novo nome',
  'voice.rename.title': 'Mudar o nome do clone de voz personalizado',
  'voice.samples.count': 'Amostras {quantity}/{maxQuantity}',
  'voice.settings.applyInstruction':
    'Para utilizar a Clonagem de Voz atualizada, aplique-a aqui e, depois, aplique as alterações ao projeto.',
  'voice.settings.editFilesTitle': 'Editar',
  'voice.settings.editSamples': 'Editar amostras',
  'voice.settings.editVoice': 'Editar voz',
  'voice.settings.title': 'Definições de voz',
  'voice.settings.updateCaption':
    'Aplique as alterações aos projetos anteriores para utilizar as novas definições de voz.',
  'voice.slider.accent.maximum':
    'Máximo = a voz clonada é muito semelhante à voz original e pode incluir o sotaque do locutor original. Recomendado para áudio de alta qualidade e sem ruído, pois a IA consegue reproduzi-lo com precisão.',
  'voice.slider.accent.minimum':
    'Mínimo = adequado para amostras com artefactos de fundo, mas a semelhança da voz pode diminuir.',
  'voice.slider.accent.title': 'Semelhança e sotaque',
  'voice.slider.expressiveness.maximum':
    'Máximo = a voz será mais emotiva e variável, mas menos estável e consistente ao longo do vídeo.',
  'voice.slider.expressiveness.minimum': 'Mínimo = a voz será mais estável e consistente, mas poderá ter pouca emoção.',
  'voice.slider.expressiveness.title': 'Expressividade',
  'voice.speakers.subtitle':
    'Aqui pode ver as vozes de todos os oradores do projeto e escolher outra voz para cada um.',
  'voice.speakers.title': 'Vozes dos oradores',
  'voice.status.failed': 'Falhou',
  'voice.status.inProgress': 'Em curso',
  'voice.tips.first': 'Áudio ou vídeo com uma duração de 1 a 10 minutos e até 10 MB cada',
  'voice.tips.fourth':
    'Para obter uma voz consistente, evite carregar amostras gravadas em ambientes diferentes ou com estilos de fala distintos',
  'voice.tips.proLabel': 'Dica profissional:',
  'voice.tips.proText':
    'Depois de criar a voz, pode ajustar a semelhança e a expressividade. Crie vozes separadas para diferentes estilos de fala, tons e emoções.',
  'voice.tips.second': 'Um único locutor, com um estilo de fala consistente e poucas ou nenhumas pausas longas',
  'voice.tips.third': 'Som de alta qualidade, sem ruído de fundo',
  'voice.upload.linkPlaceholder': 'Cole uma ligação do YouTube ou Vimeo',
  'voice.upload.or': 'ou',

  'upsell.action.maybeLater': 'Talvez mais tarde',
  'upsell.action.orSwitchToAnnual': 'Ou mude para o plano anual e mantenha os seus minutos durante todo o ano',
  'upsell.action.orUpgradeTo': 'Ou mude para o {plan}',
  'upsell.action.startTranslating': 'Começar a traduzir',
  'upsell.action.switchToAnnual': 'Mudar para o anual · {price}',
  'upsell.action.upgradeTo': 'Mudar para o {plan} · {price}',
  'upsell.banner.annualDayOneText':
    'No plano anual, todos os {minutes} minutos ficam disponíveis desde o primeiro dia e durante todo o ano. Poupe {amount} por ano.',
  'upsell.banner.annualNowText':
    'No plano anual, todos os {minutes} minutos ficam já disponíveis e permanecem disponíveis durante todo o ano. Poupe {amount} por ano.',
  'upsell.banner.annualShortText':
    'Todos os {minutes} minutos já disponíveis, durante todo o ano. Poupe {amount} por ano.',
  'upsell.banner.businessGivesMonth':
    'O Business oferece {minutes} minutos por mês, além do Dicionário e da tradução para vários idiomas de uma só vez.',
  'upsell.banner.businessGivesYear':
    'O Business oferece {minutes} minutos para todo o ano, além do Dicionário e da tradução para vários idiomas de uma só vez.',
  'upsell.banner.businessText': 'Obtenha {minutes} minutos por mês e o Dicionário para manter os termos consistentes.',
  'upsell.banner.businessTitle': 'Traduza para vários idiomas de uma só vez no Business.',
  'upsell.banner.creatorProGivesMonth':
    'O Creator Pro oferece {minutes} minutos por mês, além de transferências com Lip-sync e legendas.',
  'upsell.banner.creatorProGivesYear':
    'O Creator Pro oferece {minutes} minutos para todo o ano, além de transferências com Lip-sync e legendas.',
  'upsell.banner.creatorProText': 'Obtenha {minutes} minutos por mês, legendas no vídeo e exportação de SRT.',
  'upsell.banner.creatorProTitle': 'Transfira vídeos com Lip-sync no Creator Pro.',
  'upsell.banner.fullYearTitle': 'Obtenha já os minutos do ano inteiro.',
  'upsell.banner.usedHalfMonth': 'Utilizou metade dos seus minutos deste mês.',
  'upsell.banner.usedHalfYear': 'Utilizou metade dos seus minutos anuais.',
  'upsell.banner.dismiss': 'Fechar',
  'upsell.counter.left': 'restam {minutes} min',
  'upsell.counter.used': '{percent}% utilizado · restam {minutes} min',
  'upsell.download.annualTitle': 'Obtenha já os minutos do ano inteiro',
  'upsell.download.businessTitle': 'Traduza para vários idiomas de uma só vez',
  'upsell.download.creatorProTitle': 'Vá mais longe com este vídeo no Creator Pro',
  'upsell.download.dictionary': 'Mantenha a terminologia consistente em todos os projetos com o Dicionário',
  'upsell.download.done': 'O seu vídeo foi transferido',
  'upsell.download.doneAudio': 'O seu áudio foi transferido',
  'upsell.download.doneSubtitles': 'As suas legendas foram transferidas',
  'upsell.download.lipSync': 'Transfira-o com Lip-sync para vários locutores',
  'upsell.download.multilanguage': 'Tradução para vários idiomas com um clique',
  'upsell.download.subtitles': 'Adicione legendas ou exporte ficheiros SRT',
  'upsell.feature.dictionary': 'Mantenha os termos consistentes com o Dicionário',
  'upsell.feature.lipSync': 'Lip-sync para vários locutores incluído',
  'upsell.feature.minutesInsteadMonth': '{minutes} minutos por mês em vez de {from}',
  'upsell.feature.minutesInsteadYear': '{minutes} minutos por ano em vez de {from}',
  'upsell.feature.minutesPerMonth': '{minutes} minutos por mês',
  'upsell.feature.minutesPerMonthShort': '{minutes} minutos/mês',
  'upsell.feature.minutesPerYear': '{minutes} minutos para todo o ano',
  'upsell.feature.minutesStay': 'Os minutos ficam disponíveis durante todo o ano',
  'upsell.feature.multilanguage': 'Traduza para vários idiomas de uma só vez',
  'upsell.feature.poolDayOne': 'Todos os {minutes} minutos disponíveis desde o primeiro dia',
  'upsell.feature.poolUpfront': 'Todos os {minutes} minutos disponíveis de imediato',
  'upsell.feature.save': 'Poupe {amount}',
  'upsell.feature.saveYear': 'Poupe {amount} por ano',
  'upsell.feature.subtitles': 'Adicione legendas e exporte ficheiros SRT',
  'upsell.hero.annualPlan': '{plan} Anual',
  'upsell.hero.current': 'Atual · {plan} · {minutes} min',
  'upsell.hero.fullYear': 'Ano inteiro · já disponível',
  'upsell.hero.lipSync': 'Lip-sync',
  'upsell.hero.minutes': '{minutes} min',
  'upsell.hero.multiplier': '{multiplier}× minutos',
  'upsell.hero.savePerYear': 'Poupe {amount}/ano',
  'upsell.price.perMonth': '{price}/mês',
  'upsell.price.perYear': '{price}/ano',
  'upsell.usage.annualTitle': 'Mantenha os seus minutos durante todo o ano',
  'upsell.usage.tierMonthTitle': 'Obtenha {minutes} minutos por mês no {plan}',
  'upsell.usage.tierMultiplierTitle': 'Multiplique os seus minutos por {multiplier} no {plan}',
  'upsell.usage.tierYearTitle': 'Obtenha {minutes} minutos por ano no {plan}',
  'upsell.usage.usedMonth': 'Utilizou {used} de {total} minutos este mês',
  'upsell.usage.usedYear': 'Utilizou {used} de {total} minutos este ano',
  'upsell.welcome.dictionary': 'Dicionário para manter os termos consistentes',
  'upsell.welcome.includes': 'O seu plano inclui',
  'upsell.welcome.languages': 'Mais de 135 idiomas, com edição de cada fala',
  'upsell.welcome.lipSyncDownloads': 'Transferências de vídeo com Lip-sync',
  'upsell.welcome.lipSyncSubtitles': 'Transferências com Lip-sync e legendas',
  'upsell.welcome.minutesMonth': '{minutes} minutos por mês para dobragem e tradução',
  'upsell.welcome.minutesYear': '{minutes} minutos para todo o ano, já disponíveis',
  'upsell.welcome.multilanguage': 'Tradução para vários idiomas com um clique',
  'upsell.welcome.needMore': 'Precisa de mais?',
  'upsell.welcome.offerMonth': 'O {plan} oferece {minutes} minutos por mês e ainda:',
  'upsell.welcome.offerYear': 'O {plan} Anual oferece {minutes} minutos para todo o ano e ainda:',
  'upsell.welcome.srtVoices': 'Exportação SRT e até 3 vozes guardadas',
  'upsell.welcome.subtitlesSrt': 'Legendas no vídeo, exportação e importação de SRT',
  'upsell.welcome.title': 'Bem-vindo ao {plan}',
  'upsell.welcome.voiceCloning': 'Clonagem de voz que preserva a voz de cada locutor',
  'acquisitionSurvey.otherPlaceholder': 'Diga-nos onde',
  'acquisitionSurvey.question': 'Como conheceu a Rask?',
  'acquisitionSurvey.skip': 'Ignorar',
  'acquisitionSurvey.source.blogger': 'Criador de conteúdos ou blogger',
  'acquisitionSurvey.source.chatgpt': 'ChatGPT',
  'acquisitionSurvey.source.friend': 'Colega ou amigo',
  'acquisitionSurvey.source.google': 'Pesquisa no Google',
  'acquisitionSurvey.source.instagramFacebook': 'Instagram ou Facebook',
  'acquisitionSurvey.source.linkedin': 'LinkedIn',
  'acquisitionSurvey.source.other': 'Outro',
  'acquisitionSurvey.source.otherAi': 'Claude e outras ferramentas de IA',
  'acquisitionSurvey.source.tiktok': 'TikTok',
  'acquisitionSurvey.source.x': 'X (Twitter)',
  'acquisitionSurvey.source.youtube': 'YouTube',
  'acquisitionSurvey.submit': 'Continuar',
} as const;
